/* ============================================
   TRADING JOURNAL PRO - MONKEY DFX
   Aplicaci?n Principal con Importaci?n CSV
   ============================================ */

//  Desactivar logs en producci?n
const __DEV__ = false;
const console_log = () => {};
const console_warn = () => {};
const console_error = () => {};

// ============================================
// HELPER: Detectar trades en Break Even (BE)
// BE = -0.1% <= resultado <= 0.1% del balance
// ============================================
function isBreakEvenTrade(trade, balance) {
    const profitUSD = parseFloat(trade.profitUSD) || 0;
    const profitPercent = (profitUSD / balance) * 100;
    return profitPercent >= -0.1 && profitPercent <= 0.1;
}

import { 
    tursoClient, 
    initializeDatabase,
    monthNames,
    dayNames,
    generateId,
    isWeekend,
    formatDateKey,
	parseMetaTraderFile,
    calculatePercentageResults,
    initSessionTimeout,
    API_BASE_URL
} from './config.js';

// ============================================
// ?? EXPONER FUNCIONES GLOBALES A WINDOW
// Para que scripts no-m?dulo (como accounts.js) puedan usarlas
// ============================================
window.tursoClient = tursoClient;
window.generateId = generateId;
window.formatDateKey = formatDateKey;
window.isWeekend = isWeekend;
// ?? Exponer funciones de manejo de cuentas
window.changeAccount = null; // Se asignar? despu?s de definir la funci?n
window.selectCustomOption = null; // Se asignar? despu?s de definir la funci?n
window.updateDisplay = null; // Se asignar? despu?s de definir la funci?n

// Small safe HTML escaper used across non-module UI snippets.
// Some pages include only this bundle and not other scripts that
// define escapeHtml, so provide a fallback here to avoid runtime errors.
function escapeHtml(s) {
    if (!s && s !== 0) return '';
    try {
        return String(s)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    } catch (e) { return '' + s; }
}

function getAuthToken() {
    return sessionStorage.getItem('tfx_token') ||
           sessionStorage.getItem('tfx_authToken') ||
           sessionStorage.getItem('userToken') ||
           localStorage.getItem('tfx_token') ||
           localStorage.getItem('userToken');
}

function isGestionPage() {
    try {
        const path = (window.location && window.location.pathname ? window.location.pathname : '').toLowerCase();
        return path.includes('gestion');
    } catch (e) {
        return false;
    }
}

function isAccountSynced(account) {
    if (!account) return false;
    return !!(account.mt_account_number || account.sync_provider === 'tradovate');
}

function getSyncProviderLabel(account) {
    if (!account) return 'Sincronización';
    if (account.sync_provider === 'tradovate') return 'Tradovate';
    if (account.mt_account_number) return 'MetaTrader';
    return 'Sincronización';
}

function getOrCreateTradovateDeviceId() {
    let deviceId = localStorage.getItem('tradovateDeviceId');
    if (deviceId) return deviceId;
    try {
        if (crypto?.randomUUID) {
            deviceId = crypto.randomUUID();
        } else {
            deviceId = `tv-${Date.now().toString(36)}-${Math.random().toString(36).substring(2, 10)}`;
        }
    } catch (e) {
        deviceId = `tv-${Date.now().toString(36)}-${Math.random().toString(36).substring(2, 10)}`;
    }
    localStorage.setItem('tradovateDeviceId', deviceId);
    return deviceId;
}
// ============================================
// VARIABLES GLOBALES
// ============================================
let currentDate = new Date();
let journalData = {};
let selectedDate = null;
let accounts = {};
let currentAccount = null;
let showWeekendTrades = false;  // ?? Por defecto: ocultar fin de semana
let currentUserId = null;
let isAdmin = false;
let profitChart = null;
let performanceViewOffset = 0;  // ?? Para desplazamiento en vista de desempe?o

function isDemoSessionLocal() {
    try {
        const demoToken = 'demo_token_local';
        const demoUserId = 'demo_user';
        let demoParamActive = false;
        try {
            const params = new URLSearchParams(window.location.search || '');
            const demoParam = params.get('demo');
            demoParamActive = demoParam === '1' || demoParam === 'true' || demoParam === 'yes';
        } catch (e) {}
        const token = sessionStorage.getItem('tfx_token') || sessionStorage.getItem('tfx_authToken') ||
                      sessionStorage.getItem('userToken') || localStorage.getItem('tfx_token') || localStorage.getItem('userToken');
        const userId = sessionStorage.getItem('tfx_userId') || sessionStorage.getItem('currentUserId') ||
                       localStorage.getItem('tfx_userId') || localStorage.getItem('currentUserId');
        return localStorage.getItem('demo_mode') === 'true' ||
               demoParamActive ||
               token === demoToken || userId === demoUserId ||
               !!localStorage.getItem('demo_db_v1');
    } catch (e) {
        return false;
    }
}

// ?? EXPONER VARIABLES GLOBALES A WINDOW INMEDIATAMENTE
window.accounts = accounts;
window.currentAccount = currentAccount;
window.currentUserId = currentUserId;
window.userPlan = localStorage.getItem('userPlan') || 'free';
window.userId = currentUserId;

// ============================================
// AUTENTICACI?N
// ============================================
// ============================================
// GESTIÓN DE SESIÓN ROBUSTA
// ============================================

/**
 * Sincroniza datos del usuario desde la BD y actualiza localStorage/sessionStorage
 * @returns {Promise<Object|null>} Datos del usuario o null si no hay sesión válida
 */
async function syncUserDataFromDB() {
    const isDemo = (window.SessionValidator && typeof window.SessionValidator.isDemoSession === 'function')
        ? window.SessionValidator.isDemoSession()
        : isDemoSessionLocal();

    if (isDemo && localStorage.getItem('demo_mode') !== 'true') {
        try { localStorage.setItem('demo_mode', 'true'); } catch (e) {}
    }

    if (isDemo) {
        return {
            email: localStorage.getItem('userEmail') || sessionStorage.getItem('userEmail') || 'demo@tripulacionfx.com',
            username: localStorage.getItem('userName') || 'DEMO',
            userId: 'demo_user',
            userType: 'user',
            userPlan: 'unlimited',
            expiresAt: null
        };
    }

    const token = sessionStorage.getItem('tfx_token') || sessionStorage.getItem('tfx_authToken') ||
                  sessionStorage.getItem('userToken') || localStorage.getItem('tfx_token') || localStorage.getItem('userToken');
    const userId = sessionStorage.getItem('tfx_userId') || sessionStorage.getItem('currentUserId') ||
                   localStorage.getItem('tfx_userId') || localStorage.getItem('currentUserId');
    
    if (!token || !userId) {



        return null;
    }
    
    try {
        if (!window.tursoClient) {

            return checkSession(); // Fallback a localStorage
        }
        
        // Consultar datos actuales del usuario desde la BD
        const result = await tursoClient.execute({
            sql: 'SELECT id, email, username, user_type, user_plan, expires_at, paypal_subscription_id, paypal_payer_id FROM users WHERE id = ?',
            args: [userId]
        });
        
        if (!result || !result.rows || result.rows.length === 0) {
            localStorage.clear();
            sessionStorage.clear();
            return null;
        }
        
        const user = result.rows[0];
        
        // Detectar si el usuario cambi� (nuevo login)
        const previousUserId = sessionStorage.getItem('currentUserId') || localStorage.getItem('currentUserId');
        const userIdChanged = previousUserId && previousUserId !== user.id;
        
        // Si el usuario cambi�, limpiar datos personales del usuario anterior
        if (userIdChanged) {
            // Limpiar localStorage de datos del usuario anterior
            localStorage.removeItem('accounts');
            localStorage.removeItem('selectedAccountId');
            localStorage.removeItem('selectedAccount');
            localStorage.removeItem('currentAccount');
            sessionStorage.removeItem('hasSeenWelcomeThisSession');
            sessionStorage.removeItem('dbUserType');
            
            // Limpiar UI visual del usuario anterior
            // Resetear nombre y balance de cuenta
            const nameEl = document.getElementById('accountSwitchName');
            const balanceEl = document.getElementById('accountSwitchBalance');
            const avatarEl = document.getElementById('accountSwitchAvatar');
            if (nameEl) nameEl.textContent = 'Seleccionar cuenta';
            if (balanceEl) balanceEl.textContent = '$0.00';
            if (avatarEl) avatarEl.textContent = '';
            
            // Limpiar window.currentAccount tambi�n
            window.currentAccount = null;
        }
        
        // Actualizar localStorage con datos frescos de la BD
        sessionStorage.setItem('userEmail', user.email);
        sessionStorage.setItem('currentUserId', user.id);
        localStorage.removeItem('userEmail');
        localStorage.removeItem('currentUserId');
        sessionStorage.setItem('userPlan', user.user_plan || 'free');
        localStorage.setItem('userPlan', user.user_plan || 'free');
        window.userPlan = user.user_plan || 'free';
        localStorage.setItem('accountExpires', user.expires_at || '');
        localStorage.setItem('userCreatedAt', user.created_at || '');
        localStorage.setItem('userLastLogin', user.last_login || '');
        if (user.paypal_subscription_id) {
            localStorage.setItem('paypalSubscriptionId', user.paypal_subscription_id);
            sessionStorage.setItem('paypalSubscriptionId', user.paypal_subscription_id);
        }
        
        // ?? Actualizar visibilidad de botones de funcionalidades despu�s de cambiar plan
        if (window.updateMissionControlVisibility) {
            window.updateMissionControlVisibility();
        }
        if (window.updateTradeControlVisibility) {
            window.updateTradeControlVisibility();
        }
        // ?? Actualizar bot�n del plan en header
        if (window.updatePlanDisplayButton) {
            window.updatePlanDisplayButton();
        }
        if (window.updateFollowPlanButton) {
            window.updateFollowPlanButton();
        }
        // ?? Aplicar restricciones de plan en calendar-demo.js
        if (window.applyPlanRestrictionsFromAppJs) {
            window.applyPlanRestrictionsFromAppJs();
        }
        
        if (user.full_name) {
            localStorage.setItem('userFullName', user.full_name);
        }
        
        if (user.country) {
            localStorage.setItem('userCountry', user.country);
        }
        
        if (user.username) {
            localStorage.setItem('userName', user.username);
        }
        
        // ?? CR?TICO: Sincronizar userType desde BD
        if (user.user_type) {
            sessionStorage.setItem('dbUserType', user.user_type);
            sessionStorage.setItem('userType', user.user_type);
            if (user.user_type === 'admin') {
                localStorage.setItem('userType', 'admin');
            } else {
                localStorage.removeItem('userType');
            }
            try { window.dispatchEvent(new CustomEvent('userTypeUpdated')); } catch (e) {}
        } else {
            sessionStorage.removeItem('dbUserType');
            localStorage.removeItem('userType');
            try { window.dispatchEvent(new CustomEvent('userTypeUpdated')); } catch (e) {}
        }
        
        return {
            email: user.email,
            username: user.username || user.email.split('@')[0],
            userId: user.id,
            userType: user.user_type || 'user',
            userPlan: user.user_plan || 'free',
            expiresAt: user.expires_at
        };
        
    } catch (error) {

        return checkSession(); // Fallback a localStorage
    }
}

/**
 * Verifica sesi?n local (fallback cuando no hay conexi?n a BD)
 */
async function checkSession() {
    const isDemo = (window.SessionValidator && typeof window.SessionValidator.isDemoSession === 'function')
        ? window.SessionValidator.isDemoSession()
        : isDemoSessionLocal();

    if (isDemo && localStorage.getItem('demo_mode') !== 'true') {
        try { localStorage.setItem('demo_mode', 'true'); } catch (e) {}
    }

    if (isDemo) {
        return {
            email: localStorage.getItem('userEmail') || sessionStorage.getItem('userEmail') || 'demo@tripulacionfx.com',
            username: localStorage.getItem('userName') || 'DEMO',
            userId: 'demo_user',
            userType: 'user',
            userPlan: 'unlimited'
        };
    }

    const email = sessionStorage.getItem('tfx_email') || sessionStorage.getItem('userEmail') ||
                  localStorage.getItem('tfx_email') || localStorage.getItem('userEmail') ||
                  (isDemo ? 'demo@tripulacionfx.com' : null);
    const userId = sessionStorage.getItem('tfx_userId') || sessionStorage.getItem('currentUserId') ||
                   localStorage.getItem('tfx_userId') || localStorage.getItem('currentUserId');
    const token = sessionStorage.getItem('tfx_token') || sessionStorage.getItem('tfx_authToken') ||
                  sessionStorage.getItem('userToken') || localStorage.getItem('tfx_token') || localStorage.getItem('userToken');
    const username = localStorage.getItem('userName') || (isDemo ? 'DEMO' : null);
    
    if (!email || !userId || !token) {


        return null;
    }
    
    return {
        email: email,
        username: username || email.split('@')[0],
        userId: userId,
        userType: sessionStorage.getItem('dbUserType') || localStorage.getItem('userType') || 'user',
        userPlan: localStorage.getItem('userPlan') || 'free'
    };
}

function updateUserDisplay(email) {
    // Prefer stored username, otherwise show local-part of the email
    const username = localStorage.getItem('userName') || sessionStorage.getItem('userEmail');
    const short = username || (email ? String(email).split('@')[0] : '-');
    const displayEl = document.getElementById('currentUserDisplay');
    const displayElMobile = document.getElementById('currentUserDisplayMobile');
    if (displayEl) displayEl.textContent = short.toUpperCase();
    if (displayElMobile) displayElMobile.textContent = short.toUpperCase();
    
    // Actualizar iniciales en avatares en todas las páginas
    const initials = short.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
    
    // dashboard-new.html
    const dashboardInitials = document.getElementById('userInitials');
    if (dashboardInitials) dashboardInitials.textContent = initials || 'U';
    
    // calendar-demo.html
    const calendarInitials = document.getElementById('calendarUserInitials');
    if (calendarInitials) calendarInitials.textContent = initials || 'U';
}

// ============================================
// GESTI?N DE CUENTAS
// ============================================
async function loadAccountsFromDB() {
    if (!currentUserId) {
        currentUserId = sessionStorage.getItem('tfx_userId') || sessionStorage.getItem('currentUserId') ||
                        localStorage.getItem('tfx_userId') || localStorage.getItem('currentUserId');
        window.currentUserId = currentUserId;
    }
    if (!currentUserId) return {};
    
    try {
        // Si no hay tursoClient o est? en offline, retornar vac?o (crear? cuenta por defecto)
        if (!window.tursoClient) {

            return {};
        }
        
        const result = await tursoClient.execute({
            sql: `SELECT * FROM accounts 
                  WHERE user_id = ? 
                  AND (is_archived = 0 OR is_archived IS NULL)
                  AND (status IS NULL OR LOWER(status) NOT IN ('archived', 'archivado'))
                  ORDER BY created_at`,
            args: [currentUserId]
        });
        
        const accountsObj = {};
        for (const row of result.rows) {
            // ?? FIX: Turso retorna null como {type: 'null'}, necesitamos convertirlo
            let mtAccountNumber = row.mt_account_number;
            if (mtAccountNumber && typeof mtAccountNumber === 'object' && mtAccountNumber.type === 'null') {
                mtAccountNumber = null;
            }
            let syncProvider = row.sync_provider;
            if (syncProvider && typeof syncProvider === 'object' && syncProvider.type === 'null') {
                syncProvider = null;
            }
            let externalAccountId = row.external_account_id;
            if (externalAccountId && typeof externalAccountId === 'object' && externalAccountId.type === 'null') {
                externalAccountId = null;
            }
            
            accountsObj[row.id] = {
                id: row.id,
                name: row.name,
                balance: row.balance,
                initial_balance: row.initial_balance || row.balance,
                mt_account_number: mtAccountNumber,
                sync_provider: syncProvider,
                external_account_id: externalAccountId,
                status: row.status || 'active',
                is_archived: row.is_archived || 0,
                is_primary: row.is_primary || 0,
                synced_at: row.synced_at || null,
                data: {}
            };
        }
        
        return accountsObj;
    } catch (error) {
        return {};
    }
}

async function saveAccountToDB(account, options = {}) {
    const includeName = options && options.includeName === true;
    if (!currentUserId) return false;
    
    // Si no hay tursoClient, simular ?xito (modo offline)
    if (!window.tursoClient) {

        return true;
    }
    
    try {
        const exists = await tursoClient.execute({
            sql: 'SELECT id FROM accounts WHERE id = ?',
            args: [account.id]
        });
        
        if (exists.rows.length > 0) {
            if (includeName) {
                await tursoClient.execute({
                    sql: `UPDATE accounts SET name = ?, balance = ?, status = ? WHERE id = ?`,
                    args: [account.name, account.balance, account.status, account.id]
                });
            } else {
                await tursoClient.execute({
                    sql: `UPDATE accounts SET balance = ?, status = ? WHERE id = ?`,
                    args: [account.balance, account.status, account.id]
                });
            }
        } else {
            // ?? Si es nueva cuenta, guardar tambi?n initial_balance
            const initialBalance = account.initial_balance || account.balance;
            await tursoClient.execute({
                sql: `INSERT INTO accounts (id, user_id, name, balance, initial_balance, status) VALUES (?, ?, ?, ?, ?, ?)`,
                args: [account.id, currentUserId, account.name, account.balance, initialBalance, account.status]
            });
        }
        
        return true;
    } catch (error) {
        console_error('Error saving account:', error);
        return false;
    }
}

async function initializeAccounts() {
    accounts = await loadAccountsFromDB();
    window.accounts = accounts; // Expose to window for risk management
    
    // ?? BALANCE STATE MANAGER: Inicializar con todas las cuentas
    if (window.balanceStateManager) {
        window.balanceStateManager.initialize(accounts);
    }
    
    // ?? PRIORIDAD DE CARGA DE CUENTA:
    // 1. Cuenta seleccionada desde accounts.html
    // 2. Cuenta marcada como principal en BDD (is_primary = 1)
    // 3. Primera cuenta activa
    // 4. Primera cuenta del array
    
    const selectedAccountId = localStorage.getItem('selectedAccountId');
    const selectedAccountName = localStorage.getItem('selectedAccountName');

    // Limpiar selecciones huérfanas si la cuenta ya no existe
    if (selectedAccountId && !accounts[selectedAccountId]) {
        localStorage.removeItem('selectedAccountId');
        localStorage.removeItem('selectedAccountName');
    }
    
    if (Object.keys(accounts).length === 0) {
        // ?? NO crear autom?ticamente - mostrar modal solo si es primera vez
        currentAccount = null;
        window.currentAccount = null;
        
        // Verificar si ya se mostr? el modal de bienvenida
        const hasSeenWelcome = localStorage.getItem('hasSeenWelcome');
        
        // Mostrar modal de crear primera cuenta solo si no lo ha visto antes
        if (!hasSeenWelcome) {
            setTimeout(() => {
                showFirstAccountModal();
                // Marcar como visto para que no se muestre de nuevo
                localStorage.setItem('hasSeenWelcome', 'true');
            }, 800);
        }
    } else if (selectedAccountId && accounts[selectedAccountId]) {
        // ?? SI VIENE DE accounts.html Y LA CUENTA EXISTE, SELECCIONARLA (m?xima prioridad)
        currentAccount = selectedAccountId;
        
        if (selectedAccountName) {
            setTimeout(() => {
                showAlert('Cuenta Seleccionada', `Visualizando: ${selectedAccountName}`, 'info');
            }, 500);
        }
        
        // ?? LIMPIAR localStorage
        localStorage.removeItem('selectedAccountId');
        localStorage.removeItem('selectedAccountName');
    } else {
        // FIX: Primero intentar recuperar la última cuenta seleccionada (para refresh)
        const savedAccountId = localStorage.getItem('selectedAccountId') || localStorage.getItem('selectedAccount');
        if (savedAccountId && accounts[savedAccountId]) {
            currentAccount = savedAccountId;
        } else {
            // ?? SI HAY CUENTA PRINCIPAL (is_primary = 1), USARLA
            const primaryAccount = Object.values(accounts).find(acc => acc.is_primary === 1 || acc.is_primary === '1');
            if (primaryAccount) {
                currentAccount = primaryAccount.id;
                // ?? COMENTADO: No mostrar alerta cada vez que carga
                // setTimeout(() => {
                //     showAlert('Cuenta Principal', `Cuenta principal: ${primaryAccount.name}`, 'info');
                // }, 500);
            } else {
                // ?? FIX: Preferir cuenta con sync EA reciente sobre cuentas manuales
                const activeAccounts = Object.values(accounts).filter(acc => acc.status === 'active' || !acc.status);
                const sortedBySync = activeAccounts.sort((a, b) => {
                    // Primero cuentas vinculadas con EA (mt_account_number)
                    const aSync = a.mt_account_number ? 1 : 0;
                    const bSync = b.mt_account_number ? 1 : 0;
                    if (aSync !== bSync) return bSync - aSync;
                    // Luego por synced_at más reciente
                    if (a.synced_at && b.synced_at) return new Date(b.synced_at) - new Date(a.synced_at);
                    if (a.synced_at) return -1;
                    if (b.synced_at) return 1;
                    return 0;
                });
                const activeAccount = sortedBySync[0];
                currentAccount = activeAccount ? activeAccount.id : Object.keys(accounts)[0];
            }
        }
    }
    
    window.currentAccount = currentAccount; // Expose to window for risk management
    window.currentDate = currentDate;       // ?? Exponer currentDate para calendar-demo.js
    updateAccountSelector();
    
    if (currentAccount) {
        await loadCurrentAccountData();
        updateAccountSwitchUI(currentAccount);
        if (window.updateFollowPlanButton) {
            window.updateFollowPlanButton();
        }
        setTimeout(() => {
            if (window.currentAccount) {
                updateAccountSwitchUI(window.currentAccount);
            }
        }, 0);
    } else if (window.updateFollowPlanButton) {
        window.updateFollowPlanButton();
    }
    
    // ?? FIX 3: Iniciar auto-refresh de datos
    startAutoRefresh();
}

function updateAccountSwitchUI(accountId) {
    const account = accounts && accounts[accountId];
    const nameEl = document.getElementById('accountSwitchName');
    const balanceEl = document.getElementById('accountSwitchBalance');
    const avatarEl = document.getElementById('accountSwitchAvatar');
    const syncBadge = document.getElementById('accountSyncBadge');
    const syncTooltip = document.getElementById('accountSyncBadgeTooltip');

    if (!account) {
        if (nameEl) nameEl.textContent = 'Seleccionar cuenta';
        if (balanceEl) balanceEl.textContent = '$0.00';
        if (avatarEl) avatarEl.textContent = '';
        if (syncBadge) syncBadge.classList.add('hidden');
        return;
    }

    const safeName = String(account.name || 'Cuenta').trim() || 'Cuenta';
    if (nameEl) nameEl.textContent = safeName;

    if (avatarEl) {
        const parts = safeName.split(/\s+/).filter(Boolean);
        const letters = parts
            .map(p => p.replace(/[^A-Za-zÁÉÍÓÚÜÑáéíóúüñ]/g, ''))
            .filter(p => p.length > 0);
        const initials = letters.slice(0, 2).map(p => p[0]).join('');
        avatarEl.textContent = (initials || 'AC').toUpperCase();
    }

    if (balanceEl) {
        let balance = account.balance;
        if (window.balanceStateManager) {
            balance = window.balanceStateManager.getAccountBalance(accountId);
        }
        const safeBalance = Number(balance);
        const formatted = Number.isFinite(safeBalance) ? safeBalance : 0;
        balanceEl.textContent = `$${formatted.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        balanceEl.classList.remove('opacity-0');
    }

    if (syncBadge) {
        const isSynced = !!account.mt_account_number;
        if (isSynced) {
            syncBadge.classList.remove('hidden');
            if (syncTooltip) {
                syncTooltip.textContent = 'Cuenta sincronizada · MetaTrader (MT4/MT5)';
            }
        } else {
            syncBadge.classList.add('hidden');
        }
    }
}

// Exponer para otros módulos (calendar-demo.js)
window.updateAccountSwitchUI = updateAccountSwitchUI;

// ?? FUNCI?N CENTRALIZADA PARA CALCULAR BALANCE DE UNA CUENTA
window.calculateAccountBalance = function(accountId) {
    // ?? BALANCE STATE MANAGER: Single Source of Truth
    if (window.balanceStateManager) {
        return window.balanceStateManager.getAccountBalance(accountId);
    }
    
    // ?? FALLBACK (solo si manager no est? disponible - no deber?a ocurrir)
    const account = accounts[accountId];
    if (!account) return 0;
    
    const initialBalance = account.initial_balance || account.balance || 0;
    let realBalance = initialBalance;
    
    // journalData de app.js ya est? filtrado por cuenta actual
    // Solo sumar si estamos calculando la cuenta actual cargada
    if (accountId === currentAccount) {
        Object.keys(journalData).forEach(dateKey => {
            const trades = journalData[dateKey] || [];
            trades.forEach(trade => {
                realBalance += (parseFloat(trade.profitUSD) || 0);
            });
        });
    }
    // Si es otra cuenta, solo devolver initial_balance ya que no tenemos sus trades cargados
    
    return realBalance;
};

function updateAccountSelector() {
    const select = document.getElementById('accountSelect');
    if (!select) {
        return;
    }
    select.innerHTML = '';
    
    const allAccounts = Object.values(accounts);
    const activeAccounts = allAccounts.filter(acc => {
        // Solo mostrar cuentas con estado 'active' o sin estado definido
        return (acc.status === 'active' || !acc.status) && !isAccountArchived(acc);
    });
    
    // ?? Ocultar select (ahora usamos custom dropdown)
    if (activeAccounts.length === 0) {
        select.style.display = 'none';
        return;
    } else {
        select.style.display = 'none'; // Siempre oculto
    }
    
    // Sort: primary first (is_primary = 1)
    const sortedAccounts = activeAccounts.sort((a, b) => {
        if (a.is_primary === 1 || a.is_primary === '1') return -1;
        if (b.is_primary === 1 || b.is_primary === '1') return 1;
        return 0;
    });
    
    sortedAccounts.forEach(account => {
        const option = document.createElement('option');
        option.value = account.id;
        const isSynced = isAccountSynced(account);
        const syncStatus = isSynced ? 'Sincronizada' : 'No sincronizada';
        const isPrimary = account.is_primary === 1 || account.is_primary === '1' ? '? ' : '';
        const syncEmoji = isSynced ? '?' : '?';
        option.textContent = `${isPrimary}${account.name} ${syncEmoji}`;
        option.title = `${account.name} - ${syncStatus}`;
        if (account.id === currentAccount) {
            option.selected = true;
        }
        select.appendChild(option);
    });
    
    // Actualizar dropdown personalizado
    updateCustomAccountSelector();
}

// Dropdown personalizado para mejor UX
function updateCustomAccountSelector() {
    const dropdown = document.getElementById('selectDropdown');
    const textElement = document.getElementById('selectedAccountText');
    
    if (!dropdown || !textElement) return;
    
    dropdown.innerHTML = '';
    
    const allAccounts = Object.values(accounts);
    const activeAccounts = allAccounts.filter(acc => {
        // Solo mostrar cuentas con estado 'active' o sin estado definido
        return (acc.status === 'active' || !acc.status) && !isAccountArchived(acc);
    });
    
    if (activeAccounts.length === 0) return;
    
    const sortedAccounts = activeAccounts.sort((a, b) => {
        if (a.is_primary === 1 || a.is_primary === '1') return -1;
        if (b.is_primary === 1 || b.is_primary === '1') return 1;
        return 0;
    });
    
    sortedAccounts.forEach(account => {
        const option = document.createElement('div');
        option.className = 'custom-select-option';
        option.dataset.value = account.id;
        const isPrimary = account.is_primary === 1 || account.is_primary === '1';
        const isSynced = isAccountSynced(account);
        const syncEmoji = isSynced ? '?' : '?';
        const syncBadge = isSynced ? '<span class="synced-badge">Sincronizada</span>' : '';
        const starSvg = isPrimary ? '<svg style="width:14px;height:14px;vertical-align:middle;margin-right:6px;fill:#ffa851;flex-shrink:0;" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>' : '';
        
        option.innerHTML = `
            ${starSvg}<span>${account.name} ${syncEmoji}</span>${syncBadge}
        `;
        
        if (account.id === currentAccount) {
            option.classList.add('selected');
            textElement.innerHTML = `${starSvg}${account.name} ${syncEmoji}${syncBadge}`;
        }
        
        option.addEventListener('click', () => {
            selectCustomOption(account.id);
        });
        
        dropdown.appendChild(option);
    });
}

function isAccountArchived(account) {
    if (!account) return true;
    const flag = account.is_archived;
    if (flag === true || flag === 'true' || flag === 1 || flag === '1') return true;
    if (flag === false || flag === 'false' || flag === 0 || flag === '0' || flag == null) return false;
    return Boolean(flag);
}

function selectCustomOption(accountId) {
    // ?? VALIDAR que la cuenta existe
    if (!accounts[accountId]) {
        console_error('ERROR: Intento de cambiar a cuenta inexistente', { accountId, availableAccounts: Object.keys(accounts) });
        showAlert('Error', 'Cuenta no encontrada', 'error');
        return;
    }
    
    const select = document.getElementById('accountSelect');
    if (select) {
        select.value = accountId;
    }
    currentAccount = accountId;
    window.currentAccount = currentAccount;
    
    // Cerrar dropdown
    const dropdown = document.getElementById('selectDropdown');
    if (dropdown) {
        dropdown.classList.remove('active');
    } else {
        // Cerrar dropdown de calendar-demo.html
        const accountDropdown = document.getElementById('accountDropdown');
        if (accountDropdown) {
            accountDropdown.classList.remove('opacity-100', 'visible', 'scale-100');
            accountDropdown.classList.add('opacity-0', 'invisible', 'scale-95');
        }
        const accountChevron = document.getElementById('accountChevron');
        if (accountChevron) {
            accountChevron.classList.remove('rotate-180');
        }
    }
    
    // Actualizar visual
    updateCustomAccountSelector();
    
    // Cambiar cuenta
    changeAccount();
}

// Toggle dropdown
if (document.getElementById('selectTrigger')) {
    document.getElementById('selectTrigger').addEventListener('click', () => {
        const dropdown = document.getElementById('selectDropdown');
        if (dropdown) {
            dropdown.classList.toggle('active');
        }
    });
    
    // Cerrar dropdown al hacer click fuera
    document.addEventListener('click', (e) => {
        const selector = document.getElementById('customAccountSelector');
        const dropdown = document.getElementById('selectDropdown');
        if (dropdown && !selector.contains(e.target)) {
            dropdown.classList.remove('active');
        }
    });
}

async function changeAccount() {
    _lastKnownTotalTradeCount = -1; // Resetear caché al cambiar de cuenta
    const previousAccount = currentAccount;
    // SINCRONIZAR: Si window.currentAccount fue actualizado (ej: desde calendar-demo.js), usar ese valor
    if (window.currentAccount && window.currentAccount !== currentAccount) {
        currentAccount = window.currentAccount;
    }
    
    await saveCurrentAccountData();
    
    // ?? Si currentAccount ya fue actualizado (ej: desde selectCustomOption), respetarlo
    // Si no, leerlo del select (compatibilidad con journal.html)
    if (!currentAccount) {
        const select = document.getElementById('accountSelect');
        if (select && select.value) {
            currentAccount = select.value;
        }
    }

    // Forzar desactivación de sesión al cambiar de cuenta
    if (previousAccount && previousAccount !== currentAccount) {
        if (window.tradeControl && typeof window.tradeControl.deactivateAutoManagementSession === 'function') {
            try { await window.tradeControl.deactivateAutoManagementSession(previousAccount); } catch (e) {}
        }
    }
    
    window.currentAccount = currentAccount; // Expose to window for risk management
    window.currentDate = currentDate;       // ?? Asegurar que currentDate este expuesto

    // Si la cuenta no está sincronizada, desactivar sesión automática
    const accountForSyncCheck = window.accounts ? window.accounts[currentAccount] : null;
    if (accountForSyncCheck && !isAccountSynced(accountForSyncCheck)) {
        if (window.tradeControl && typeof window.tradeControl.deactivateAutoManagementSession === 'function') {
            try { await window.tradeControl.deactivateAutoManagementSession(); } catch (e) {}
        }
    }
    
    // FIX: Limpiar cache del plan cuando se cambia de cuenta para forzar recarga
    if (window.planManagerV2 && typeof window.planManagerV2.clearPlanCache === 'function') {
        // Limpiar ANTES de actualizar (para forzar búsqueda fresh)
        window.planManagerV2.clearPlanCache(currentAccount);
        // Actualizar el botón de plan con el estado de la NUEVA cuenta inmediatamente, sin usar cache
        if (typeof window.planManagerV2.updateButtonLabel === 'function') {
            await window.planManagerV2.updateButtonLabel(currentAccount, true);
        }
    }
    
    // ?? OPTIMIZACION: Solo recargar datos de la cuenta actual
    await loadCurrentAccountData();
    
    // ?? CRITICAL FIX: Forzar sync inmediato al cambiar de cuenta para traer trades cerrados
    // Sin esto el usuario tiene que esperar hasta 10s para ver los trades de la nueva cuenta
    if (typeof doFullRefresh === 'function') {
        try {
            await doFullRefresh();
        } catch (e) {
            console_warn('doFullRefresh fallido al cambiar cuenta:', e);
        }
    }
    
    // ?? Actualizar header con nombre y balance de la cuenta
    updateAccountSwitchUI(currentAccount);
    
    // ?? Invalidar DESPU?S de cargar datos (asegurar que window.journalData est? actualizado)
    if (typeof invalidateRecapCache === 'function') {
        invalidateRecapCache();
    }
    
    // ?? Actualizar visibilidad del bot?n de ajustes
    const userPlan = sessionStorage.getItem('userPlan') || localStorage.getItem('userPlan') || 'free';
    const settingsBtn = document.getElementById('settingsBtn');
    if (settingsBtn) {
        const hasAccount = currentAccount && accounts[currentAccount];
        const shouldShow = userPlan !== 'free' && hasAccount;
        settingsBtn.style.display = shouldShow ? 'inline-flex' : 'none';
    }

    // ?? Actualizar visibilidad del botón de Eventos Económicos (solo Unlimited)
    const syncEventsBtn = document.getElementById('syncEventsBtn');
    if (syncEventsBtn) {
        if (userPlan !== 'unlimited') {
            syncEventsBtn.classList.add('hidden');
            syncEventsBtn.style.display = 'none !important';
        } else {
            syncEventsBtn.classList.remove('hidden');
            syncEventsBtn.style.cssText = `display: inline-flex !important;`;
        }
    }
    
    // ?? Actualizar ?ltimas operaciones
    if (typeof updateLatestTrades === 'function') {
        updateLatestTrades();
    }
    
    // ? Actualizar m?tricas en tiempo real (calendar-demo)
    if (typeof updateRealTimeMetrics === 'function') {
        updateRealTimeMetrics(window.currentDate);
    }
    
    // ??? Solo llamar updateDisplay una vez
    updateDisplay();

    if (window.updatePlanDisplayButton) {
        window.updatePlanDisplayButton();
    }
    // FIX: Esperar a que el botón del plan se actualice con la nueva cuenta
    if (window.updateFollowPlanButton) {
        await window.updateFollowPlanButton(currentAccount);
    }

    // FIX: Si no hay plan activo, asegurar desactivación de sesión automática
    if (window.planManagerV2 && window.tradeControl && typeof window.tradeControl.deactivateAutoManagementSession === 'function') {
        try {
            const plan = await window.planManagerV2.getPlanCached(true, currentAccount);
            if (!plan) {
                await window.tradeControl.deactivateAutoManagementSession();
            }
        } catch (e) {}
    }
}

async function saveCurrentAccountData() {
    if (currentAccount && accounts[currentAccount]) {
        accounts[currentAccount].data = { ...journalData };
        await saveAccountToDB(accounts[currentAccount]);
    }
}

async function loadCurrentAccountData() {
    // Destruir gr�ficos antiguos primero
    if (profitChart) {
        try { profitChart.destroy(); } catch (e) { console_warn("Error destroying profitChart:", e); }
        profitChart = null;
    }
    if (window.rMultipleChartInstance) {
            try { window.rMultipleChartInstance.destroy(); } catch (e) {}
    }
    
    // Limpiar canvas
    const profitCanv = document.getElementById("profitChart");
    if (profitCanv) {
        const c = profitCanv.getContext("2d");
        c.clearRect(0, 0, profitCanv.width, profitCanv.height);
    }
    const rMultipleCanv = document.getElementById("rMultipleChart");
    if (rMultipleCanv) {
        const c = rMultipleCanv.getContext("2d");
        c.clearRect(0, 0, rMultipleCanv.width, rMultipleCanv.height);
    }
    
    if (currentAccount && accounts[currentAccount]) {
        journalData = await loadTradesFromDB(currentAccount);
        
        // ?? BALANCE STATE MANAGER: Cargar trades en el manager
        if (window.balanceStateManager) {
            // Aplanar el objeto de trades por fecha en un array simple
            const allTrades = Object.values(journalData).flat();
            window.balanceStateManager.loadTrades(currentAccount, allTrades);
            
            // ?? Actualizar �ltimas operaciones si est� disponible
            if (typeof window.updateLatestTrades === 'function') {
                setTimeout(() => window.updateLatestTrades(), 100);
            }
        }
        
        // ?? AUTOFIX: Cargar installation_id desde la BD para sincronización con MT5
        // Esto previene el bug donde la sesión auto-management no puede desactivarse
        try {
            if (currentUserId && tursoClient) {
                const instResult = await tursoClient.execute({
                    sql: 'SELECT installation_id FROM installations WHERE user_id = ? AND account_id = ? LIMIT 1',
                    args: [currentUserId, currentAccount]
                });
                
                if (instResult && instResult.rows && instResult.rows.length > 0) {
                    const installationId = instResult.rows[0].installation_id;
                    if (installationId) {
                        sessionStorage.setItem('installationID', installationId);
                    }
                }
            }
        } catch (err) {}
    } else {
        journalData = {};
    }
    // ?? Exponer datos globalmente para recap-card.js
    window.journalData = journalData;
    window.accounts = accounts;  // Asegurar que accounts est� actualizado
    
    // ?? Recargar notas de la cuenta actual
    await loadNotesForCurrentAccount();

    // ?? Recargar ajustes de balance (cashflows) de la cuenta actual
    await loadCashflowsForCurrentAccount();

    // ?? Usar profit total (all-time) para el balance
    await refreshAccountTotalProfit(currentAccount);
}

// ?? Cargar notas diarias de la cuenta actual
async function loadNotesForCurrentAccount() {
    try {
        if (!currentUserId || !tursoClient || !currentAccount) return;
        
        // Limpiar mapa de notas anterior
        window.__dailyNotesMap = {};
        
        const y = currentDate.getFullYear();
        const m = String(currentDate.getMonth() + 1).padStart(2, '0');
        const prefix = `${y}-${m}-`;
        
        const res = await tursoClient.execute({ 
            sql: 'SELECT date, sentiment, note, day_outcome FROM daily_notes WHERE user_id = ? AND account_id = ? AND date LIKE ?', 
            args: [currentUserId, currentAccount, prefix + '%'] 
        });
        
        if (res && res.rows) {
            res.rows.forEach(r => {
                try { 
                    window.__dailyNotesMap[r.date] = { 
                        sentiment: r.sentiment, 
                        note: r.note, 
                        day_outcome: r.day_outcome 
                    }; 
                } catch (e) {}
            });
        }
    } catch (e) {
        // Silently fail
    }
}

// ?? Cargar ajustes de balance de la cuenta actual
async function loadCashflowsForCurrentAccount() {
    try {
        if (!currentUserId || !tursoClient || !currentAccount) return;

        const res = await tursoClient.execute({
            sql: 'SELECT id, type, amount, notes, date, created_at FROM cashflows WHERE user_id = ? AND account_id = ? ORDER BY date ASC, created_at ASC',
            args: [currentUserId, currentAccount]
        });

        const rows = res?.rows || [];

        if (window.balanceStateManager) {
            window.balanceStateManager.loadCashflows(currentAccount, rows);
        }

        const map = {};
        rows.forEach(r => {
            if (!r || !r.date) return;
            let dateKey = String(r.date).trim();
            if (dateKey.includes('T') || dateKey.includes(' ')) {
                dateKey = dateKey.split(/[T ]/)[0];
            }
            if (/^\d{4}\.\d{2}\.\d{2}$/.test(dateKey)) {
                dateKey = dateKey.replace(/\./g, '-');
            }
            if (!map[dateKey]) map[dateKey] = [];
            map[dateKey].push(r);
        });

        window.__cashflowsMap = window.__cashflowsMap || {};
        window.__cashflowsMap[currentAccount] = map;
    } catch (e) {
        // Silently fail
    }
}

// ?? Cargar profit total (all-time) de la cuenta actual
async function refreshAccountTotalProfit(accountId) {
    try {
        if (!accountId || !tursoClient) return;
        const res = await tursoClient.execute({
            sql: 'SELECT COALESCE(SUM(profit_usd), 0) as total_profit FROM trades WHERE account_id = ?',
            args: [accountId]
        });
        const totalProfit = Number(res?.rows?.[0]?.total_profit) || 0;
        if (window.balanceStateManager) {
            window.balanceStateManager.loadTotalProfit(accountId, totalProfit);
        }
    } catch (e) {
        // Silently fail
    }
}

window.refreshAccountTotalProfit = refreshAccountTotalProfit;

// Exponer para uso externo
window.loadCashflowsForCurrentAccount = loadCashflowsForCurrentAccount;

// Exponer para uso externo
window.loadNotesForCurrentAccount = loadNotesForCurrentAccount;

async function editAccountName() {
    if (!currentAccount) return;
    
    const currentName = accounts[currentAccount].name;
    const newName = await showPrompt({
        title: 'Editar nombre de cuenta',
        message: 'Ingresa el nuevo nombre para la cuenta:',
        defaultValue: currentName,
        placeholder: 'Nombre de la cuenta',
        required: true
    });
    
    if (newName && newName.trim() && newName !== currentName) {
        // 🔄 Primero actualizar en memoria
        accounts[currentAccount].name = newName.trim();
        
        // 💾 Guardar en BDD y validar éxito
        const saveSuccess = await saveAccountToDB(accounts[currentAccount], { includeName: true });
        
        if (!saveSuccess) {
            // ❌ Si falla el guardado, revertir cambio en memoria y alertar
            accounts[currentAccount].name = currentName;
            showAlert('Error', 'No se pudo guardar el nombre. Por favor, intenta de nuevo.', 'error');
            return;
        }
        
        // ✅ Si fue exitoso, recargar desde BDD para confirmar consistencia
        const updatedAccounts = await loadAccountsFromDB();
        if (updatedAccounts && updatedAccounts[currentAccount]) {
            // Verificar que el cambio se guardó correctamente
            if (updatedAccounts[currentAccount].name === newName.trim()) {
                accounts = updatedAccounts;
                window.accounts = accounts;
                updateAccountSelector();
                showAlert('Actualizacion Exitosa', 'Nombre actualizado correctamente', 'success');
            } else {
                // Si el nombre no se actualizó en la BDD, algo falló
                accounts[currentAccount].name = currentName;
                showAlert('Error', 'El cambio no se guardó correctamente. Por favor, intenta de nuevo.', 'error');
            }
        } else {
            // Falló cargar los datos actualizados
            accounts[currentAccount].name = currentName;
            showAlert('Error', 'No se pudieron verificar los cambios. Por favor, recarga la página.', 'error');
        }
    }
}

// ?? MOSTRAR PANTALLA DE BIENVENIDA PRO
function showWelcomeState() {
    const calendarContainer = document.querySelector('.calendar-container');
    const metricsSidebar = document.querySelector('.metrics-sidebar');
    const statGrid = document.querySelector('.stats-grid');
    
    if (!calendarContainer) return;
    
    // Ocultar secciones existentes
    if (metricsSidebar) metricsSidebar.style.display = 'none';
    if (statGrid) statGrid.style.display = 'none';
    
    // Crear estado de bienvenida
    const welcomeHTML = `
        <div id="welcomeState" style="
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 60vh;
            flex-direction: column;
            text-align: center;
            gap: 24px;
            padding: 40px;
            background: linear-gradient(135deg, rgba(26, 188, 156, 0.05) 0%, rgba(255, 154, 60, 0.05) 100%);
            border-radius: 20px;
            border: 1px solid rgba(26, 188, 156, 0.1);
        ">
            <div style="font-size: 80px; animation: bounce 2s infinite;">??</div>
            <div>
                <h2 style="font-size: 32px; font-weight: 700; margin-bottom: 12px; letter-spacing: -0.5px;">
                    Bienvenido al Journal Pro
                </h2>
                <p style="font-size: 16px; color: #90a4ae; margin-bottom: 8px; line-height: 1.6;">
                    Lleva un control profesional de tus operaciones de trading.<br>
                    Crea tu primera cuenta para comenzar a registrar tus trades.
                </p>
            </div>
            <div style="
                display: flex;
                gap: 12px;
                flex-wrap: wrap;
                justify-content: center;
                margin-top: 20px;
                font-size: 14px;
                color: #90a4ae;
            ">
                <div style="display: flex; align-items: center; gap: 8px;">
                    <span style="font-size: 20px;">??</span>
                    <span>Estad?sticas Detalladas</span>
                </div>
                <div style="display: flex; align-items: center; gap: 8px;">
                    <span style="font-size: 20px;">??</span>
                    <span>Gesti?n de Riesgo</span>
                </div>
                <div style="display: flex; align-items: center; gap: 8px;">
                    <span style="font-size: 20px;">??</span>
                    <span>An?lisis Profundo</span>
                </div>
            </div>
            <button onclick="showFirstAccountModal()" style="
                margin-top: 20px;
                padding: 14px 32px;
                background: linear-gradient(135deg, #1abc9c 0%, #16a085 100%);
                color: white;
                border: none;
                border-radius: 8px;
                font-size: 16px;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.3s ease;
                box-shadow: 0 4px 15px rgba(26, 188, 156, 0.3);
            " onmouseover="this.style.boxShadow='0 6px 20px rgba(26, 188, 156, 0.5); this.style.transform='translateY(-2px)'" onmouseout="this.style.boxShadow='0 4px 15px rgba(26, 188, 156, 0.3); this.style.transform='translateY(0)'">
                ? Crear Primera Cuenta
            </button>
            <style>
                @keyframes bounce {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-20px); }
                }
            </style>
        </div>
    `;
    
    calendarContainer.innerHTML = welcomeHTML;
}

function hideWelcomeState() {
    const welcomeState = document.getElementById('welcomeState');
    const calendarContainer = document.querySelector('.calendar-container');
    const metricsSidebar = document.querySelector('.metrics-sidebar');
    const statGrid = document.querySelector('.stats-grid');
    
    if (welcomeState) {
        welcomeState.remove();
    }
    if (calendarContainer) {
        calendarContainer.innerHTML = '';
    }
    if (metricsSidebar) metricsSidebar.style.display = 'block';
    if (statGrid) statGrid.style.display = 'grid';
}

// ?? MOSTRAR MODAL DE CREAR PRIMERA CUENTA
window.showFirstAccountModal = function showFirstAccountModal() {
    // Obtener nombre del usuario
    const userName = localStorage.getItem('userName') || (sessionStorage.getItem('userEmail') || localStorage.getItem('userEmail'))?.split('@')[0] || 'Trader';
    const isMobile = window.innerWidth <= 640;
    const headerPadding = isMobile ? '24px 16px 20px' : '60px 48px 48px';
    const bodyPadding = isMobile ? '20px 16px' : '48px 48px';
    const titleFontSize = isMobile ? '22px' : '32px';
    const headerTextSize = isMobile ? '13px' : '15px';
    const subtitleFontSize = isMobile ? '13px' : '16px';
    const subtitleMargin = isMobile ? '16px' : '36px';
    const featureGap = isMobile ? '10px' : '18px';
    const featurePadding = isMobile ? '12px 10px' : '24px 20px';
    const iconContainerSize = isMobile ? '36px' : '44px';
    const iconFontSize = isMobile ? '16px' : '20px';
    const featureTitleSize = isMobile ? '11px' : '14px';
    const featureDescSize = isMobile ? '10px' : '12px';
    const buttonFlexDirection = isMobile ? 'column' : 'row';
    const buttonPadding = isMobile ? '11px 16px' : '13px 24px';
    const buttonFontSize = isMobile ? '13px' : '14px';
    const buttonWidth = isMobile ? '100%' : 'auto';
    const buttonMinWidth = isMobile ? 'auto' : '140px';
    const confirmButtonMinWidth = isMobile ? 'auto' : '200px';
    const modalMaxHeight = isMobile ? '90vh' : 'auto';
    const footerMargin = isMobile ? '16px' : '24px';
    const features = [
        {
            icon: '📊',
            title: 'Análisis Real',
            description: 'Datos en vivo',
            border: 'rgba(6, 182, 212, 0.15)',
            background: 'rgba(6, 182, 212, 0.05)',
            gradient: 'linear-gradient(135deg, #06b6d4 0%, #3b82f6 100%)',
            highlight: 'rgba(6, 182, 212, 0.08)'
        },
        {
            icon: '📈',
            title: 'Control Total',
            description: 'Gestión completa',
            border: 'rgba(59, 130, 246, 0.15)',
            background: 'rgba(59, 130, 246, 0.05)',
            gradient: 'linear-gradient(135deg, #8b5cf6 0%, #a855f7 100%)',
            highlight: 'rgba(59, 130, 246, 0.08)'
        },
        {
            icon: '⚡',
            title: 'Rápido & Simple',
            description: 'Fácil de usar',
            border: 'rgba(6, 182, 212, 0.15)',
            background: 'rgba(6, 182, 212, 0.05)',
            gradient: 'linear-gradient(135deg, #06b6d4 0%, #8b5cf6 100%)',
            highlight: 'rgba(6, 182, 212, 0.08)'
        },
        {
            icon: '🎯',
            title: 'Crecimiento',
            description: 'Mejora continua',
            border: 'rgba(59, 130, 246, 0.15)',
            background: 'rgba(59, 130, 246, 0.05)',
            gradient: 'linear-gradient(135deg, #a855f7 0%, #8b5cf6 100%)',
            highlight: 'rgba(59, 130, 246, 0.08)'
        }
    ];
    const featureCards = features.map(feature => `
        <div style="
            background: ${feature.background};
            border: 1px solid ${feature.border};
            border-radius: 12px;
            padding: ${featurePadding};
            text-align: center;
            transition: all 0.3s ease;
        " onmouseover="
            this.style.borderColor='${feature.border.replace('0.15', '0.4')}';
            this.style.background='${feature.highlight}';
            this.style.transform='translateY(-2px)';
        " onmouseout="
            this.style.borderColor='${feature.border}';
            this.style.background='${feature.background}';
            this.style.transform='translateY(0)';
        ">
            <div style="
                width: ${iconContainerSize};
                height: ${iconContainerSize};
                background: ${feature.gradient};
                border-radius: 10px;
                margin: 0 auto 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: ${iconFontSize};
            ">${feature.icon}</div>
            <p style="font-size: ${featureTitleSize}; font-weight: 600; color: #e2e8f0; margin: 0 0 4px 0;">${feature.title}</p>
            <p style="font-size: ${featureDescSize}; color: #94a3b8; margin: 0; line-height: 1.5;">${feature.description}</p>
        </div>
    `).join('');
    
    // Crear el overlay
    const overlay = document.createElement('div');
    overlay.className = 'welcome-modal-overlay';
    overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(8, 12, 20, 0.95);
        backdrop-filter: blur(14px);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 99999;
        opacity: 0;
        transition: opacity 0.3s ease;
        padding: ${isMobile ? '8px' : '20px'};
        overflow-y: auto;
    `;

    // Crear el modal
    const modal = document.createElement('div');
    modal.style.cssText = `
        background: linear-gradient(135deg, #0f172a 0%, #1a2847 100%);
        border-radius: ${isMobile ? '12px' : '16px'};
        padding: 0;
        max-width: ${isMobile ? '95vw' : '600px'};
        max-height: ${modalMaxHeight};
        width: 100%;
        box-shadow: 0 25px 50px rgba(6, 182, 212, 0.1), 0 0 50px rgba(59, 130, 246, 0.05);
        transform: scale(0.95) translateY(20px);
        transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
        overflow-y: auto;
        border: 1px solid rgba(6, 182, 212, 0.2);
        margin: auto;
    `;

    modal.innerHTML = `
        <div style="position: relative; overflow: hidden;">
            <div style="
                background: linear-gradient(135deg, #06b6d4 0%, #8b5cf6 100%);
                padding: ${headerPadding};
                position: relative;
                overflow: hidden;
                text-align: center;
            ">
                <div style="
                    position: absolute;
                    top: -50%;
                    right: -20%;
                    width: 400px;
                    height: 400px;
                    background: radial-gradient(circle, rgba(255,255,255,0.08) 0%, transparent 70%);
                    border-radius: 50%;
                "></div>
                <div style="
                    position: absolute;
                    bottom: -30%;
                    left: -10%;
                    width: 300px;
                    height: 300px;
                    background: radial-gradient(circle, rgba(59,130,246,0.1) 0%, transparent 70%);
                    border-radius: 50%;
                "></div>
                <div style="position: relative; z-index: 1;">
                    <h1 style="
                        font-size: ${titleFontSize};
                        font-weight: 700;
                        color: white;
                        margin: 0 0 ${isMobile ? '8px' : '12px'} 0;
                        letter-spacing: -0.5px;
                    ">¡Hola, ${userName}!</h1>
                    <p style="
                        font-size: ${headerTextSize};
                        color: rgba(255, 255, 255, 0.95);
                        margin: 0;
                        font-weight: 500;
                    ">Estás listo para comenzar tu trading profesional</p>
                </div>
            </div>

            <div style="padding: ${bodyPadding};">
                <div style="text-align: center; margin-bottom: ${subtitleMargin};">
                    <p style="
                        font-size: ${subtitleFontSize};
                        color: #cbd5e1;
                        line-height: 1.6;
                        margin: 0;
                        font-weight: 400;
                    ">Crea tu primera cuenta de trading y accede a herramientas profesionales de análisis</p>
                </div>

                <div style="
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(${isMobile ? '140px' : '180px'}, 1fr));
                    gap: ${featureGap};
                    margin-bottom: ${isMobile ? '24px' : '40px'};
                ">
                    ${featureCards}
                </div>

                <div style="display: flex; flex-direction: ${buttonFlexDirection}; gap: 12px;">
                    <button id="cancelBtn" style="
                        flex: 1;
                        min-width: ${buttonMinWidth};
                        width: ${buttonWidth};
                        padding: ${buttonPadding};
                        border: 1px solid #475569;
                        background: rgba(15, 23, 42, 0.5);
                        color: #cbd5e1;
                        border-radius: 8px;
                        font-size: ${buttonFontSize};
                        font-weight: 600;
                        cursor: pointer;
                        transition: all 0.3s ease;
                    " onmouseover="
                        this.style.background='rgba(30, 41, 59, 0.7)';
                        this.style.borderColor='#64748b';
                        this.style.color='#e2e8f0';
                    " onmouseout="
                        this.style.background='rgba(15, 23, 42, 0.5)';
                        this.style.borderColor='#475569';
                        this.style.color='#cbd5e1';
                    ">Más Tarde</button>
                    <button id="confirmBtn" style="
                        flex: 1;
                        min-width: ${confirmButtonMinWidth};
                        width: ${buttonWidth};
                        padding: ${buttonPadding};
                        border: none;
                        background: linear-gradient(135deg, #06b6d4 0%, #8b5cf6 100%);
                        color: white;
                        border-radius: 8px;
                        font-size: ${buttonFontSize};
                        font-weight: 600;
                        cursor: pointer;
                        transition: all 0.3s ease;
                        box-shadow: 0 8px 20px rgba(6, 182, 212, 0.3);
                    " onmouseover="
                        this.style.transform='translateY(-2px)';
                        this.style.boxShadow='0 12px 28px rgba(6, 182, 212, 0.4)';
                    " onmouseout="
                        this.style.transform='translateY(0)';
                        this.style.boxShadow='0 8px 20px rgba(6, 182, 212, 0.3)';
                    ">Crear Cuenta</button>
                </div>

                <p style="
                    text-align: center;
                    font-size: ${isMobile ? '11px' : '12px'};
                    color: #64748b;
                    margin: ${footerMargin} 0 0 0;
                    font-weight: 400;
                ">Puedes crear múltiples cuentas después</p>
            </div>
        </div>
    `;

    // Agregar estilos de animación
    const style = document.createElement('style');
    style.textContent = `
        @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-20px); }
        }
        @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
        }
        @keyframes pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.05); }
        }
        
        @media (max-width: 640px) {
            .welcome-modal-overlay {
                padding: 16px !important;
            }
        }
    `;
    document.head.appendChild(style);

    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    // Animar entrada
    setTimeout(() => {
        overlay.style.opacity = '1';
        modal.style.transform = 'scale(1) translateY(0)';
    }, 10);

    // Funci?n para cerrar el modal
    function closeModal(confirmed) {
        overlay.style.opacity = '0';
        modal.style.transform = 'scale(0.9) translateY(20px)';
        
        setTimeout(() => {
            document.body.removeChild(overlay);
            document.head.removeChild(style);
            
            if (confirmed && window.showAddAccountModal) {
                window.showAddAccountModal();
            }
        }, 300);
    }

    // Event listeners
    modal.querySelector('#confirmBtn').addEventListener('click', () => closeModal(true));
    modal.querySelector('#cancelBtn').addEventListener('click', () => closeModal(false));
    overlay.addEventListener('click', (e) => {
        if (e.target === overlay) closeModal(false);
    });

    // ESC para cerrar
    const escHandler = (e) => {
        if (e.key === 'Escape') {
            closeModal(false);
            document.removeEventListener('keydown', escHandler);
        }
    };
    document.addEventListener('keydown', escHandler);
};

// Función para forzar el modal (para testing)
window.forceShowWelcomeModal = function() {
    localStorage.removeItem('hasSeenWelcome');
    window.showFirstAccountModal();
};
window.showAddAccountModal = function() {
    // Siempre abrir el modal de crear/editar cuenta
    // El modal de bienvenida solo se muestra al cargar la p?gina cuando no hay cuentas
    document.getElementById('accountForm').reset();
    const accountModal = document.getElementById('accountModal');
    if (accountModal) {
        accountModal.classList.add('show');
        accountModal.style.display = 'flex';
        accountModal.style.zIndex = '10001';
        accountModal.setAttribute('aria-hidden', 'false');
    }
    
    // ?? Actualizar estado del bot?n de importaci?n
    const btnImport = document.getElementById('btnImportTradesModal');
    if (btnImport) {
        const currentAccountData = accounts[currentAccount];
        const isSyncedCurrentAccount = currentAccountData && isAccountSynced(currentAccountData);
        
        if (isSyncedCurrentAccount) {
            btnImport.disabled = true;
            btnImport.style.opacity = '0.5';
            btnImport.style.cursor = 'not-allowed';
            btnImport.title = '? La cuenta actual es sincronizada (no puedes importar manualmente)';
        } else {
            btnImport.disabled = false;
            btnImport.style.opacity = '1';
            btnImport.style.cursor = 'pointer';
            btnImport.title = '?? Importar trades desde CSV/HTML';
        }
    }
}

window.closeAccountModal = function() {
    const accountModal = document.getElementById('accountModal');
    if (accountModal) {
        accountModal.classList.remove('show');
        try { accountModal.style.display = 'none'; } catch (e) {}
        accountModal.setAttribute('aria-hidden', 'true');
    }
}

// CAMBIAR ENTRE TABS DEL MODAL
window.switchAccountTab = function(tab) {
    // BLOQUEAR SINCRONIZACION AUTOMATICA EN MOVIL
    if (tab === 'auto') {
        // Detectar si es movil
        const isMobile = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        
        if (isMobile) {
            // Mostrar alerta
            showAlert('Solo disponible en Desktop', 'La sincronizacion automatica requiere instalar una aplicacion en tu ordenador. Por favor, accede desde tu PC o portatil.', 'info');
            return;
        }
    }

    const userPlan = (localStorage.getItem('userPlan') || 'free').toLowerCase();
    // Bloquear acceso a la pesta?a 'auto' para usuarios FREE
    if (tab === 'auto' && userPlan === 'free') {
        return;
    }

    const manualPanel = document.getElementById('manualPanel');
    const autoPanel = document.getElementById('autoPanel');
    const tabs = document.querySelectorAll('#accountModal .tab-button');
    
    // Actualizar estilos de las tabs con underline style
    tabs.forEach(t => {
        const underline = t.querySelector('span');
        if (t.dataset.tab === tab) {
            t.classList.remove('text-slate-400', 'hover:text-slate-300');
            t.classList.add('text-white');
            if (underline) underline.classList.add('scale-x-100');
            if (underline) underline.classList.remove('scale-x-0');
        } else {
            t.classList.add('text-slate-400', 'hover:text-slate-300');
            t.classList.remove('text-white');
            if (underline) underline.classList.remove('scale-x-100');
            if (underline) underline.classList.add('scale-x-0');
        }
    });
    
    if (tab === 'manual') {
        manualPanel.classList.remove('hidden');
        autoPanel.classList.add('hidden');
    } else {
        manualPanel.classList.add('hidden');
        autoPanel.classList.remove('hidden');
        const selectedPlatform = localStorage.getItem('selectedPlatform');
        if (selectedPlatform !== 'tradovate') {
            startPendingAccountsPolling(); // Iniciar polling
        }
    }
}

// ?? SELECCIONAR PLATAFORMA
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.platform-btn').forEach(btn => {
        btn.addEventListener('click', function() {
            const platform = this.dataset.platform;

            if (platform === 'mt4' && window.demoGate && window.demoGate('mt4', 'MetaTrader 4')) {
                return;
            }
            if (platform === 'mt5' && window.demoGate && window.demoGate('mt5', 'MetaTrader 5')) {
                return;
            }

            localStorage.setItem('selectedPlatform', platform);

            const step1 = document.getElementById('syncStep1');
            const step2 = document.getElementById('syncStep2');
            const step2Tradovate = document.getElementById('syncStep2Tradovate');

            if (step1) step1.classList.add('hidden');

            if (platform === 'tradovate') {
                if (step2) step2.classList.add('hidden');
                if (step2Tradovate) step2Tradovate.classList.remove('hidden');
            } else {
                if (step2Tradovate) step2Tradovate.classList.add('hidden');
                if (step2) step2.classList.remove('hidden');
            }
        });
    });
});

// ?? DESCARGAR EXPORTER
document.addEventListener('DOMContentLoaded', function() {
    const downloadBtn = document.getElementById('downloadExporterBtn');
    if (downloadBtn) {
        downloadBtn.addEventListener('click', function() {
            showAlert('Descarga Iniciada', 'Descarga iniciada. Ejecuta el instalador cuando termine.', 'info');
        });
    }
});

// ?? PROCEDER A SINCRONIZACI?N
window.proceedToSync = function() {
    document.getElementById('syncStep2').classList.add('hidden');
    document.getElementById('syncStep3').classList.remove('hidden');
    
    startPendingAccountsPolling();
}

// ?? MOSTRAR TUTORIAL DE SINCRONIZACIÓN
window.showTutorialModal = function() {
    const modal = document.getElementById('tutorialModal');
    if (modal) {
        modal.classList.remove('hidden');
    }
}

// ?? CERRAR TUTORIAL Y PAUSAR VIDEO
window.closeTutorialModal = function() {
    const modal = document.getElementById('tutorialModal');
    const video = document.getElementById('tutorialVideo');
    if (modal) {
        modal.classList.add('hidden');
    }
    if (video) {
        video.src = video.src; // Reinicia el iframe para pausar el video
    }
}

// ============================================
// TRADOVATE SYNC
// ============================================
let tradovateConnectionId = null;
let tradovateAccountsCache = [];
let lastTradovateSyncAt = 0;
const TRADOVATE_SYNC_INTERVAL = 5 * 60 * 1000; // 5 minutos

window.connectTradovate = async function() {
    const envSelect = document.getElementById('tradovateEnv');
    const usernameInput = document.getElementById('tradovateUsername');
    const passwordInput = document.getElementById('tradovatePassword');
    const listContainer = document.getElementById('tradovateAccountsList');
    const btn = document.getElementById('tradovateConnectBtn');

    const environment = envSelect ? envSelect.value : 'demo';
    const username = usernameInput ? usernameInput.value.trim() : '';
    const password = passwordInput ? passwordInput.value : '';

    if (!username || !password) {
        showAlert('Datos incompletos', 'Ingresa usuario y contraseña de Tradovate.', 'warning');
        return;
    }

    const token = getAuthToken();
    if (!token) {
        showAlert('Error de sesión', 'No hay sesión activa.', 'error');
        return;
    }

    if (btn) {
        btn.disabled = true;
        btn.textContent = 'Conectando...';
    }

    try {
        const deviceId = getOrCreateTradovateDeviceId();
        const resp = await fetch(`${API_BASE_URL}/api/tradovate/connect`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ username, password, environment, deviceId })
        });

        const data = await resp.json().catch(() => ({}));
        if (!resp.ok || !data.success) {
            throw new Error(data.error || 'No se pudo conectar con Tradovate');
        }

        tradovateConnectionId = data.connectionId;
        tradovateAccountsCache = data.accounts || [];

        renderTradovateAccounts(tradovateAccountsCache);

        if (listContainer && tradovateAccountsCache.length === 0) {
            listContainer.innerHTML = '<p class="text-center text-sm text-slate-400">No se encontraron cuentas en Tradovate.</p>';
        }
    } catch (error) {
        showAlert('Error Tradovate', error.message || 'Error al conectar con Tradovate', 'error');
    } finally {
        if (btn) {
            btn.disabled = false;
            btn.textContent = 'Conectar y listar cuentas';
        }
    }
};

function renderTradovateAccounts(accountsList) {
    const listContainer = document.getElementById('tradovateAccountsList');
    if (!listContainer) return;

    if (!accountsList || accountsList.length === 0) {
        listContainer.innerHTML = '';
        return;
    }

    listContainer.innerHTML = accountsList.map(acc => {
        const accountId = escapeHtml(acc.id);
        const accountName = escapeHtml(acc.name || `Cuenta ${acc.id}`);
        const accountType = escapeHtml(acc.accountType || 'Futures');
        return `
            <div class="pending-account-card">
                <div class="account-info">
                    <h4>Tradovate - ${accountName} <small style="color:#34d399;">[#${accountId}]</small></h4>
                    <div class="account-details">
                        <span>⚙️ Tipo: ${accountType}</span>
                        <span>✅ Estado: ${(acc.active ? 'Activa' : 'Inactiva')}</span>
                    </div>
                    <div class="account-initial-balance" style="margin-top: 15px; padding-top: 15px; border-top: 1px solid #444;">
                        <label style="display: block; margin-bottom: 8px; color: #34d399; font-weight: bold;">
                            💵 Balance Inicial (para cálculos):
                        </label>
                        <input 
                            type="number" 
                            id="tradovateInitialBalance_${accountId}"
                            class="initial-balance-input"
                            value="10000"
                            step="0.01"
                            min="0"
                            style="width: 100%; padding: 8px; background: #1a1a2e; color: #fff; border: 1px solid #34d399; border-radius: 4px; font-size: 14px;"
                            placeholder="Ingresa el balance inicial"
                        />
                        <small style="color: #999; display: block; margin-top: 5px;">Este balance se usará para calcular porcentajes.</small>
                    </div>
                </div>
                <div class="account-actions">
                    <button class="btn-primary" onclick="confirmTradovateAccount('${accountId}')">
                        ⚡ Conectar y Sincronizar
                    </button>
                </div>
            </div>
        `;
    }).join('');
}

window.confirmTradovateAccount = async function(tradovateAccountId) {
    if (!tradovateConnectionId) {
        showAlert('Error Tradovate', 'Primero conecta tu cuenta de Tradovate.', 'error');
        return;
    }

    const token = getAuthToken();
    if (!token) {
        showAlert('Error de sesión', 'No hay sesión activa.', 'error');
        return;
    }

    const initialBalanceInput = document.getElementById(`tradovateInitialBalance_${tradovateAccountId}`);
    const initialBalance = initialBalanceInput ? parseFloat(initialBalanceInput.value) : null;

    if (!initialBalance || initialBalance <= 0) {
        showAlert('Balance inválido', 'Ingresa un balance inicial válido (mayor a 0).', 'warning');
        return;
    }

    try {
        const resp = await fetch(`${API_BASE_URL}/api/tradovate/confirm`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                connectionId: tradovateConnectionId,
                tradovateAccountId,
                initialBalance
            })
        });

        const data = await resp.json().catch(() => ({}));
        if (!resp.ok || !data.success) {
            throw new Error(data.error || 'No se pudo confirmar la cuenta Tradovate');
        }

        showAlert('Cuenta Tradovate vinculada', 'Sincronización inicial en progreso.', 'success');

        await initializeAccounts();
        updateDisplay();

        if (data.accountId) {
            await triggerTradovateSync(data.accountId);
        }

        window.closeAccountModal();
    } catch (error) {
        showAlert('Error Tradovate', error.message || 'Error al confirmar cuenta Tradovate', 'error');
    }
};

async function triggerTradovateSync(accountId) {
    const token = getAuthToken();
    if (!token) return;

    try {
        await fetch(`${API_BASE_URL}/api/tradovate/sync`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ accountId })
        });
    } catch (e) {
    }
}

// 🔧 POLLING PARA DETECTAR CUENTAS PENDIENTES (OPTIMIZADO)
let pollingInterval = null;
let lastPendingAccountsHash = null; // Para detectar cambios

async function startPendingAccountsPolling() {
    if (pollingInterval) clearInterval(pollingInterval);
    
    // 🔧 OPTIMIZACIÓN: Cada 30 segundos en lugar de 5 (ahorra ~500 requests/hora)
    pollingInterval = setInterval(async () => {
        await checkPendingAccounts();
    }, 30000);
    
    // Primera comprobación inmediata
    await checkPendingAccounts();
}

async function checkPendingAccounts() {
    try {
        const userEmail = sessionStorage.getItem('userEmail') || localStorage.getItem('userEmail');
        const turso = window.tursoClient;
        const container = document.getElementById('pendingAccountsList');
        
        if (!userEmail || !turso) {
            if (container) {
                container.innerHTML = `<p style="text-align: center; color: #999; padding: 20px;">No hay sesión activa. Por favor inicia sesión.</p>`;
            }
            return;
        }
        
        const emailLower = userEmail.toLowerCase();
        
        // ?? CORRECCI?N: Leer de la tabla installations que es donde el EA crea los registros
        // Una instalaci?n est? "pending" si:
        // - Tiene account (n?mero de cuenta MT)
        // - confirmed = 0 o NULL (a?n no fue confirmada por el usuario)
        // - status = 'ACTIVE' (el EA la activ?)
        const result = await turso.execute({
            sql: `SELECT 
                    id, 
                    installation_id, 
                    account, 
                    broker, 
                    server, 
                    status,
                    confirmed,
                    account_id,
                    machine_info
                FROM installations 
                WHERE LOWER(user_email) = ? 
                AND account IS NOT NULL 
                AND (confirmed = 0 OR confirmed IS NULL)
                AND status = 'ACTIVE'
                ORDER BY created_at DESC`,
            args: [emailLower]
        });
        
        if (!result || !result.rows || result.rows.length === 0) {
            
            // ?? Solo limpiar si hab?a datos antes
            if (lastPendingAccountsHash !== 'EMPTY') {
                lastPendingAccountsHash = 'EMPTY';
                if (container) {
                    container.innerHTML = `<p style="text-align: center; color: #999; padding: 20px;">No hay cuentas pendientes. Instala el EA en tu MetaTrader para sincronizar.</p>`;
                }
            }
            return;
        }
        
        // ?? Crear hash de los datos para detectar cambios
        const dataHash = JSON.stringify(result.rows.map(r => ({ id: r.id, account: r.account })));
        if (lastPendingAccountsHash === dataHash) {
            return; // No cambi? nada, no reconstruir HTML
        }
        lastPendingAccountsHash = dataHash;
        
        // ?? TRANSFORMAR: installations ? formato de cuentas para UI
        const accounts = await Promise.all(result.rows.map(async (row) => {
            // Extraer plataforma del installation_id: ID_MT4/MT5_...
            const parts = (row.installation_id || '').split('_');
            const platformType = parts[1] ? parts[1].substring(0, 3).toUpperCase() : 'MT4'; // MT4 o MT5
            
            // ?? PASO 1: LEER DIRECTAMENTE DE machine_info (SIN necesidad de /api/get-kv)
            let balance = null;
            let equity = null;
            
            try {
                if (row.machine_info) {
                    const machineInfo = JSON.parse(row.machine_info);
                    balance = parseFloat(machineInfo.balance);
                    equity = parseFloat(machineInfo.equity);
                }
            } catch (e) {
            }
            
            // PASO 2: Si a?n no tenemos balance, usar un valor por defecto
            if (balance === null || balance === undefined || isNaN(balance) || balance === 0) {
                balance = 10000;  // Default para demo
            }
            if (equity === null || equity === undefined || isNaN(equity) || equity === 0) {
                equity = balance;  // Si no hay equity, usar el balance
            }
            
            return {
                accountNumber: row.account,
                broker: row.broker || 'Unknown',
                server: row.server || 'Unknown',
                platform: platformType,
                balance: balance,
                equity: equity,
                installationId: row.installation_id,
                installationRecordId: row.id,  // ID del registro en installations
                status: 'pending',
                accountId: row.account_id      // Para saber si ya est? vinculada
            };
        }));
        
        if (accounts.length > 0) {
            displayPendingAccounts(accounts);
        }
    } catch (error) {
        const container = document.getElementById('pendingAccountsList');
        if (container) {
            container.innerHTML = `<p style="text-align: center; color: #f44336; padding: 20px;">⚠️ Error: ${error.message || 'Error desconocido'}<br><small>Ver consola para detalles</small></p>`;
        }
    }
}


function displayPendingAccounts(accounts) {
    const container = document.getElementById('pendingAccountsList');
    
    // Obtener plataforma seleccionada (mt4 o mt5)
    const selectedPlatform = localStorage.getItem('selectedPlatform');
    
    // Filtrar cuentas por plataforma
    let accountsToShow = accounts;
    let showAllNotice = false;
    if (selectedPlatform) {
        const platformUpper = selectedPlatform.toUpperCase();
        accountsToShow = accounts.filter(a => a.platform === platformUpper);
        if (accountsToShow.length === 0 && accounts.length > 0) {
            accountsToShow = accounts;
            showAllNotice = true;
        }
    }
    
    if (accountsToShow.length === 0) {
        const platform = selectedPlatform ? selectedPlatform.toUpperCase() : 'tu plataforma';
        container.innerHTML = `<p style="text-align: center; color: #999; padding: 20px;">No hay cuentas pendientes para ${platform}</p>`;
        return;
    }
    
    const notice = showAllNotice && selectedPlatform
        ? `<p style="text-align: center; color: #fbbf24; padding: 10px 0 0; font-size: 12px;">No hay cuentas pendientes para ${selectedPlatform.toUpperCase()}. Mostrando todas.</p>`
        : '';
    let html = notice + accountsToShow.map(account => renderAccountCard(account)).join('');
    container.innerHTML = html;
}

function renderAccountCard(account) {
    const detectedBalance = (account.balance || 10000);
    const platformLabel = account.platform || 'MT?';
    const platformColor = account.platform === 'MT4' ? '#ffa500' : account.platform === 'MT5' ? '#4a90e2' : '#999';
    
    const accountId = account.accountNumber || 'N/A';
    const displayBroker = account.broker || 'Unknown Broker';
    const displayServer = account.server || 'Unknown Server';
    
    return `
        <div class="pending-account-card">
            <div class="account-info">
                <h4>${displayBroker} - Cuenta #${accountId} <small style="color: ${platformColor};">[${platformLabel}]</small></h4>
                <div class="account-details">
                    <span>💰 Balance: $${(account.balance || 0).toFixed(2)}</span>
                    <span>📊 Equity: $${(account.equity || 0).toFixed(2)}</span>
                    <span>🖥️ Servidor: ${displayServer}</span>
                </div>
                <div class="account-initial-balance" style="margin-top: 15px; padding-top: 15px; border-top: 1px solid #444;">
                    <label style="display: block; margin-bottom: 8px; color: #ffa500; font-weight: bold;">
                        💵 Balance Inicial detectado (EA):
                    </label>
                    <div style="display:flex; align-items:center; gap:10px;">
                        <div style="flex:1; padding: 8px; background: #1a1a2e; color: #fff; border: 1px solid #ffa500; border-radius: 4px; font-size: 14px;">
                            $${Number(detectedBalance).toFixed(2)}
                        </div>
                        <button type="button" onclick="toggleInitialBalanceEdit('${account.accountNumber}')" style="padding:6px 10px; font-size:12px; border-radius:6px; border:1px solid #64748b; color:#e2e8f0; background:#0f172a;">
                            Editar
                        </button>
                    </div>
                    <div id="initialBalanceEdit_${account.accountNumber}" style="display:none; margin-top:10px;">
                        <input 
                            type="number" 
                            id="initialBalance_${account.accountNumber}"
                            class="initial-balance-input"
                            value="${Number(detectedBalance).toFixed(2)}"
                            step="0.01"
                            min="0"
                            style="width: 100%; padding: 8px; background: #1a1a2e; color: #fff; border: 1px solid #ffa500; border-radius: 4px; font-size: 14px;"
                            placeholder="Ingresa el balance inicial"
                        />
                        <small style="color: #999; display: block; margin-top: 5px;">Si tu balance inicial era distinto, cámbialo aquí.</small>
                    </div>
                    <small style="color: #999; display: block; margin-top: 8px;">Se usará para cálculos y no cambiará.</small>
                </div>
            </div>
            <div class="account-actions">
                <button class="btn-primary" data-accept-account="${account.accountNumber}" onclick="acceptAccount('${account.accountNumber}', '${account.installationId}', ${Number(detectedBalance)})">
                    ✅ Aceptar y Confirmar
                </button>
                <button class="btn-secondary" onclick="rejectAccount('${account.accountNumber}')">
                    ❌ Rechazar
                </button>
            </div>
        </div>
        `;
}

// ?? ACEPTAR CUENTA
window.acceptAccount = async function(accountNumber, installationId, detectedBalance) {
    try {
        // ?? VERIFICAR ACCESO A MT SYNC POR PLAN
        const userPlan = (localStorage.getItem('userPlan') || 'free').toLowerCase();
        const userType = localStorage.getItem('userType') || 'user';
        
        if (userType !== 'admin' && !['pro', 'unlimited'].includes(userPlan)) {
            showAlert('Plan Requerido', 'Sincronizacion MT4/MT5 no disponible en Plan FREE. Actualiza a Plan PRO o UNLIMITED para usar esta funcion.', 'warning');
            return;
        }
        
        // Aviso antes de confirmar: balance inicial vs balance actual
        if (typeof window.showConfirm === 'function') {
            const proceed = await window.showConfirm({
                title: 'Balance inicial',
                message: 'El balance detectado es el ACTUAL. Si tu balance inicial era diferente, pulsa "Editar" y cámbialo antes de confirmar para que las métricas sean correctas.',
                confirmText: 'Entendido, continuar',
                cancelText: 'Volver',
                type: 'warning',
                hideIcon: true
            });
            if (!proceed) {
                return;
            }
        }

        // ?? Usar balance inicial detectado o override manual
        const overrideInput = document.getElementById(`initialBalance_${accountNumber}`);
        const overrideValue = overrideInput ? parseFloat(overrideInput.value) : null;
        const initialBalance = Number(overrideValue || detectedBalance || 0);
        if (!initialBalance || initialBalance <= 0) {
            showAlert('Balance no detectado', 'No se pudo detectar el balance inicial automáticamente. Reabre el EA y vuelve a intentar.', 'warning');
            return;
        }
        
        const userId = currentUserId;
        const turso = window.tursoClient;
        
        if (!userId || !turso) {
            showAlert('Error de Sesión', 'Error: No hay sesión activa', 'error');
            return;
        }
        
        // UI: mostrar estado sincronizando en el botón
        const acceptBtn = document.querySelector(`button[data-accept-account="${accountNumber}"]`);
        const originalBtnText = acceptBtn ? acceptBtn.textContent : null;
        if (acceptBtn) {
            acceptBtn.textContent = '🔄 Sincronizando...';
            acceptBtn.disabled = true;
        }

        // PASO 1: Reusar cuenta existente por mt_account_number para evitar duplicados
        const existingAccountResult = await turso.execute({
            sql: `SELECT id, name, initial_balance
                  FROM accounts
                  WHERE user_id = ? AND mt_account_number = ?
                  ORDER BY created_at DESC
                  LIMIT 1`,
            args: [userId, accountNumber]
        });

        let accountId;
        if (existingAccountResult?.rows?.length > 0) {
            accountId = existingAccountResult.rows[0].id;
            const existingInitialBalance = Number(existingAccountResult.rows[0].initial_balance) || Number(initialBalance) || 0;

            await turso.execute({
                sql: `UPDATE accounts
                      SET balance = ?, initial_balance = ?, status = ?, type = ?, synced_at = ?, syncing = ?
                      WHERE id = ?`,
                args: [
                    initialBalance,
                    existingInitialBalance,
                    'active',
                    'trading',
                    new Date().toISOString(),
                    0,
                    accountId
                ]
            });
        } else {
            accountId = generateId();
            const accountName = `#${accountNumber}`;

            await turso.execute({
                sql: `INSERT INTO accounts (
                    id, user_id, name, balance, initial_balance, status,
                    type, mt_account_number, synced_at, syncing
                ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?)`,
                args: [
                    accountId,
                    userId,
                    accountName,
                    initialBalance,
                    initialBalance,
                    'active',
                    'trading',
                    accountNumber,
                    new Date().toISOString(),
                    0
                ]
            });
        }
        
        // PASO 3: Actualizar instalaci?n para vincularla con la cuenta y marcar como confirmada
        await turso.execute({
            sql: 'UPDATE installations SET account_id = ?, confirmed = 1 WHERE installation_id = ? AND user_id = ?',
            args: [accountId, installationId, userId]
        });
        
        // PASO 4: Recargar UI
        showSyncInProgressPopup();
        showAlert('Cuenta Confirmada', `Cuenta confirmada: #${accountNumber} (Balance inicial: $${initialBalance.toFixed(2)})`, 'success');
        
        // Recargar cuentas
        await initializeAccounts();
        if (typeof window.populateAccountsFromAppJs === 'function') {
            try { window.populateAccountsFromAppJs(); } catch (e) {}
        }

        // ?? CRITICAL: Forzar selección de la cuenta confirmada
        // initializeAccounts() podría seleccionar otra cuenta (la primera activa)
        // Necesitamos asegurarnos de que se muestra la cuenta que acaba de confirmarse
        if (accountId && accounts[accountId]) {
            currentAccount = accountId;
            window.currentAccount = accountId;
            updateAccountSelector();
            await loadCurrentAccountData();
        }
        
        // Cerrar modal y detener polling
        clearInterval(pollingInterval);
        window.closeAccountModal();
        
        updateDisplay();
        
    } catch (error) {
        showAlert('Error de Confirmacion', `Error al confirmar: ${error.message}`, 'error');
        const acceptBtn = document.querySelector(`button[data-accept-account="${accountNumber}"]`);
        if (acceptBtn) {
            acceptBtn.disabled = false;
            acceptBtn.textContent = acceptBtn.textContent.includes('Sincronizando') ? '✅ Aceptar y Confirmar' : acceptBtn.textContent;
        }
    }
}

window.toggleInitialBalanceEdit = function(accountNumber) {
    const editBlock = document.getElementById(`initialBalanceEdit_${accountNumber}`);
    if (!editBlock) return;
    editBlock.style.display = editBlock.style.display === 'none' ? 'block' : 'none';
}

// ?? RECHAZAR CUENTA
window.rejectAccount = async function(accountNumber) {
    try {
        const userId = currentUserId;
        const turso = window.tursoClient;
        const userEmail = sessionStorage.getItem('userEmail') || localStorage.getItem('userEmail');
        
        if (!userId || !turso || !userEmail) {
            showAlert('Error de Sesión', 'Error: Sesión no válida', 'error');
            return;
        }
        
        // Eliminar la instalación pendiente de la BD
        // Usa account number para identificar
        await turso.execute({
            sql: 'DELETE FROM installations WHERE user_id = ? AND account = ? AND confirmed = 0',
            args: [userId, accountNumber]
        });
        
        showAlert('Cuenta Rechazada', 'Cuenta rechazada', 'info');
        
        // Refrescar lista de cuentas pendientes
        await checkPendingAccounts();
        
    } catch (error) {
        showAlert('Error', `Error al rechazar: ${error.message}`, 'error');
    }
}

// ?? LIMPIAR POLLING AL CERRAR MODAL
const originalCloseAccountModalCleanup = window.closeAccountModal;
window.closeAccountModal = function() {
    if (pollingInterval) {
        clearInterval(pollingInterval);
        pollingInterval = null;
    }
    
    // Resetear steps
    const step1 = document.getElementById('syncStep1');
    const step2 = document.getElementById('syncStep2');
    const step2Tradovate = document.getElementById('syncStep2Tradovate');
    const step3 = document.getElementById('syncStep3');
    
    if (step1) step1.classList.remove('hidden');
    if (step2) step2.classList.add('hidden');
    if (step2Tradovate) step2Tradovate.classList.add('hidden');
    if (step3) step3.classList.add('hidden');

    tradovateConnectionId = null;
    tradovateAccountsCache = [];
    const tradovateList = document.getElementById('tradovateAccountsList');
    if (tradovateList) tradovateList.innerHTML = '';
    const tvUser = document.getElementById('tradovateUsername');
    const tvPass = document.getElementById('tradovatePassword');
    if (tvUser) tvUser.value = '';
    if (tvPass) tvPass.value = '';
    
    originalCloseAccountModalCleanup();
}

async function toggleAccountStatus() {
    if (!currentAccount || !accounts[currentAccount]) return;
    
    const account = accounts[currentAccount];
    const previousStatus = account.status;
    
    if (account.status === 'active') {
        account.status = 'burned';
    } else if (account.status === 'burned') {
        account.status = 'superado';
    } else {
        account.status = 'active';
    }
    
    await saveAccountToDB(account);
    
    // ?? Si se marca como quemada, cambiar a la siguiente cuenta activa
    if (previousStatus === 'active' && account.status === 'burned') {
        const activeAccounts = Object.values(accounts).filter(acc => 
            (acc.status === 'active' || !acc.status) && acc.id !== currentAccount
        );
        
        if (activeAccounts.length > 0) {
            currentAccount = activeAccounts[0].id;
            window.currentAccount = currentAccount;
            await loadCurrentAccountData();
            updateAccountSelector();
            showAlert('Cuenta Quemada', `Cuenta marcada como QUEMADA. Cuenta principal cambiada a: ${accounts[currentAccount].name}`, 'info');
        } else {
            showAlert('Sin Cuentas Activas', 'Cuenta marcada como QUEMADA. No hay mas cuentas activas disponibles', 'warning');
            updateAccountSelector();
        }
    } else {
        showAlert('Estado Actualizado', 'Estado actualizado', 'success');
    }
}

// ============================================
// ?? MT4/MT5 SYNC - SINCRONIZACI?N AUTOM?TICA
// ============================================

// 🔧 SISTEMA DE POLLING LIGERO (PROFESIONAL)
// El EA envía trades instantáneamente. Este polling solo verifica
// si hay cambios mediante un timestamp ligero (pocos bytes).
// Solo carga trades completos si detecta cambios.
let autoRefreshInterval = null;
const SYNC_CHECK_INTERVAL = 3000; // 🔥 REDUCIDO: 3 segundos - sincroniza con EA (OnTimer detecta cada 3s) = 28,800 req/día
let lastKnownRefreshStateByAccount = {}; // { [accountId]: { lastUpdate, tradeCount } }
let isFullRefreshInProgress = false;
let lastDeletionCheckScopeKey = '';
let lastDeletionCheckAt = 0;
let lastDeletedTradesAlertSignature = '';

let syncPopupTimer = null;

function ensureSyncPopupHandlers() {
    const closeBtn = document.getElementById('closeSyncInProgress');
    if (closeBtn && !closeBtn.dataset.bound) {
        closeBtn.dataset.bound = '1';
        closeBtn.addEventListener('click', () => {
            hideSyncInProgressPopup();
        });
    }
}

function showSyncInProgressPopup() {
    const modal = document.getElementById('syncInProgressModal');
    if (!modal) return;
    ensureSyncPopupHandlers();
    modal.classList.remove('hidden');
    modal.style.display = 'flex';
    if (syncPopupTimer) clearTimeout(syncPopupTimer);
    syncPopupTimer = setTimeout(() => {
        hideSyncInProgressPopup();
    }, 3000);
}

function hideSyncInProgressPopup() {
    const modal = document.getElementById('syncInProgressModal');
    if (!modal) return;
    modal.classList.add('hidden');
    modal.style.display = 'none';
}

function buildTradeKey(trade, dateKey) {
    if (!trade) return '';
    if (trade.id) return String(trade.id);
    const ticket = trade.ticket || '';
    const ts = trade.timestamp || '';
    const pair = trade.pair || trade.symbol || '';
    const entry = trade.entryTime || '';
    const exit = trade.exitTime || '';
    const date = dateKey || trade.date || trade.trade_date || '';
    return [ticket, ts, pair, entry, exit, date].join('|');
}

function getTradesDataHash(data) {
    try {
        return JSON.stringify(data || {});
    } catch (e) {
        return '';
    }
}

function getRefreshScopeKey(accountId = currentAccount, dateRef = (window.currentDate || currentDate || new Date())) {
    const scopeDate = dateRef instanceof Date ? dateRef : new Date(dateRef);
    if (!scopeDate || Number.isNaN(scopeDate.getTime())) {
        return `${accountId || 'unknown'}|unknown`;
    }
    const month = String(scopeDate.getMonth() + 1).padStart(2, '0');
    return `${accountId || 'unknown'}|${scopeDate.getFullYear()}-${month}`;
}

function shouldRunDeletedTradesCheck(previousData, freshData, scopeKey) {
    if (!scopeKey || !previousData || !freshData) return false;

    const hadPreviousRows = Object.values(previousData).some((trades) => (trades || []).length > 0);
    const hasFreshRows = Object.values(freshData).some((trades) => (trades || []).length > 0);
    if (!hadPreviousRows || !hasFreshRows) return false;

    const now = Date.now();
    const scopeChanged = scopeKey !== lastDeletionCheckScopeKey;
    if (scopeChanged) {
        lastDeletionCheckScopeKey = scopeKey;
        lastDeletionCheckAt = now;
        return false;
    }

    if (!lastDeletionCheckAt) {
        lastDeletionCheckAt = now;
        return false;
    }

    return (now - lastDeletionCheckAt) >= 2000;
}

async function startAutoRefresh() {
    if (isGestionPage()) {
        return;
    }

    if (autoRefreshInterval) clearInterval(autoRefreshInterval);
    
    autoRefreshInterval = setInterval(async () => {
        if (!currentAccount) {
            return;
        }

        const accountId = currentAccount;
        
        // ✅ FILTRO 1: Solo sincronizar si la cuenta tiene MetaTrader (no manuales)
        const accountData = accounts[accountId];
        if (!accountData || !isAccountSynced(accountData)) {
            return;
        }
        
        // ✅ FILTRO 2: PAUSADO INTELIGENTE - No sincronizar si estamos en vista ANUAL
        // Usar la nueva arquitectura syncState
        const journalCalendarExists = window.journalCalendar && window.journalCalendar.syncState;
        if (journalCalendarExists && window.journalCalendar.syncState.viewMode === 'annual') {
            // Paused: guardar para procesarlater cuando vuelva a monthly
            window.journalCalendar.syncState.sync_paused_reason = 'viewing_annual';
            return;
        }
        
        try {
            const checkUrl = `${window.API_BASE_URL || 'https://mdfx-api.monkeydfx.workers.dev'}/api/account-last-update?account_id=${accountId}`;
            
            let useFullRefresh = false;
            try {
                const checkResponse = await fetch(checkUrl);
                
                if (!checkResponse.ok) {
                    // Endpoint no disponible - usar refresh completo
                    useFullRefresh = true;
                } else {
                    const checkData = await checkResponse.json();
                    const serverLastUpdate = checkData.last_update;
                    const serverTradeCount = checkData.trade_count || 0;
                    const knownState = lastKnownRefreshStateByAccount[accountId] || { lastUpdate: null, tradeCount: 0 };
                    
                    // 🔧 PASO 2: Comparar - ¿hay cambios?
                    const hasChanges = (serverLastUpdate !== knownState.lastUpdate) || 
                                       (serverTradeCount !== knownState.tradeCount);
                    
                    if (!hasChanges) {
                        // No hay cambios - no hacer nada más (ahorramos la query pesada)
                        return;
                    }
                    
                    // 🔧 PASO 3: Hay cambios - actualizar y cargar
                    lastKnownRefreshStateByAccount[accountId] = {
                        lastUpdate: serverLastUpdate,
                        tradeCount: serverTradeCount
                    };
                    useFullRefresh = true;
                }
            } catch (fetchErr) {
                // Error de red o endpoint no existe - usar refresh completo
                useFullRefresh = true;
            }
            
            if (useFullRefresh && currentAccount === accountId) {
                await doFullRefresh();
            }
            
        } catch (err) {
            console_error('Error en autoRefresh ligero:', err);
        }
    }, SYNC_CHECK_INTERVAL);
}

// Caché del total de trades en BD para detectar cambios cross-mes
let _lastKnownTotalTradeCount = -1;

async function runAutoSyncCheck(force = false) {
    try {
        if (!window.currentAccount || isFullRefreshInProgress) {
            return;
        }

        const accountId = window.currentAccount;

        // Verificar el total de trades en BD (detecta cambios en cualquier mes, no solo el actual)
        let totalCountInDB = _lastKnownTotalTradeCount;
        try {
            if (window.tursoClient) {
                const countResult = await window.tursoClient.execute({
                    sql: 'SELECT COUNT(1) as cnt FROM trades WHERE account_id = ?',
                    args: [accountId]
                });
                totalCountInDB = Number(countResult?.rows?.[0]?.cnt || 0);
            }
        } catch(e) {}

        const totalCountChanged = totalCountInDB !== _lastKnownTotalTradeCount && _lastKnownTotalTradeCount !== -1;
        if (totalCountChanged) {
            // Hay trades nuevos en otros meses → actualizar balance/métricas aunque el mes actual no cambie
            _lastKnownTotalTradeCount = totalCountInDB;
            if (window.refreshAccountTotalProfit) await window.refreshAccountTotalProfit(accountId);
            if (typeof window.updateAccountBalance === 'function') window.updateAccountBalance();
            if (typeof window.updateAccountSwitchUI === 'function') window.updateAccountSwitchUI(accountId);
        } else {
            _lastKnownTotalTradeCount = totalCountInDB;
        }

        const updatedData = await loadTradesFromDB(accountId);

        const localHash = getTradesDataHash(window.journalData);
        const remoteHash = getTradesDataHash(updatedData);
        const hasChanges = remoteHash !== localHash;

        if (!force && !hasChanges && !totalCountChanged) {
            return;
        }

        window.journalData = updatedData || {};
        journalData = window.journalData;

        // 🔧 SINCRONIZAR journal-calendar.js con nuevos datos
        if (window.journalCalendar) {
            window.journalCalendar.syncFromWindowData();
        }

        const allTrades = Object.values(window.journalData).flat();
        window.balanceStateManager?.loadTrades(accountId, allTrades);

        if (window.refreshAccountTotalProfit) {
            await window.refreshAccountTotalProfit(accountId);
        }

        if (window.updateRealTimeMetrics) {
            window.updateRealTimeMetrics(window.currentDate);
        }
        if (window.updateDisplay) {
            window.updateDisplay();
        }
        if (typeof window.updateLatestTrades === 'function') {
            window.updateLatestTrades();
        }
        if (typeof window.updateAccountBalance === 'function') {
            window.updateAccountBalance();
        }
        if (typeof window.updateAccountSwitchUI === 'function') {
            window.updateAccountSwitchUI(accountId);
        }
    } catch (e) {
        // Silent fail - no interrumpir la app si falla el auto-sync
    }
}

// 🔧 Función auxiliar para refresh completo (separada para reutilizar)
async function doFullRefresh() {
    if (!currentAccount) return;
    if (isFullRefreshInProgress) return;

    isFullRefreshInProgress = true;
    const refreshScopeKey = getRefreshScopeKey(currentAccount, window.currentDate || currentDate);
    
    try {
        const currentAccountData = accounts[currentAccount];
        if (currentAccountData && currentAccountData.sync_provider === 'tradovate') {
            const now = Date.now();
            if (now - lastTradovateSyncAt > TRADOVATE_SYNC_INTERVAL) {
                lastTradovateSyncAt = now;
                await triggerTradovateSync(currentAccount);
            }
        }

        const fresh = await loadTradesFromDB(currentAccount);
        
        // Comparar cambios - SOLO mostrar notificación si hay cambios REALES
        const oldHash = JSON.stringify(journalData);
        const newHash = JSON.stringify(fresh);
        
        if (oldHash !== newHash) {
            
            // Detectar nuevos trades para notificaciones
            const oldEntries = Object.entries(journalData || {});
            const oldTradeKeys = new Set();
            oldEntries.forEach(([dateKey, trades]) => {
                (trades || []).forEach(t => {
                    const key = buildTradeKey(t, dateKey);
                    if (key) oldTradeKeys.add(key);
                });
            });

            const newTrades = [];
            Object.entries(fresh || {}).forEach(([dateKey, trades]) => {
                (trades || []).forEach(t => {
                    const key = buildTradeKey(t, dateKey);
                    if (key && !oldTradeKeys.has(key)) {
                        newTrades.push({ trade: t, dateKey });
                    }
                });
            });

            // 🆕 DETECTAR TRADES ELIMINADOS (borrados manualmente de la BD)
            // Solo comparar en el mismo scope (cuenta+mes) y con snapshots estables
            const canCheckDeletedTrades = shouldRunDeletedTradesCheck(journalData || {}, fresh || {}, refreshScopeKey);
            if (canCheckDeletedTrades) {
                const oldTotalCount = oldEntries.reduce((sum, [, trades]) => sum + (trades || []).length, 0);
                const newTotalCount = Object.values(fresh || {}).reduce((sum, trades) => sum + (trades || []).length, 0);

                if (newTotalCount < oldTotalCount) {
                    const newTradeKeys = new Set();
                    Object.entries(fresh || {}).forEach(([dateKey, trades]) => {
                        (trades || []).forEach(t => {
                            const key = buildTradeKey(t, dateKey);
                            if (key) newTradeKeys.add(key);
                        });
                    });

                    const deletedTrades = [];
                    oldEntries.forEach(([dateKey, trades]) => {
                        (trades || []).forEach(t => {
                            const key = buildTradeKey(t, dateKey);
                            if (key && !newTradeKeys.has(key)) {
                                deletedTrades.push({ trade: t, dateKey });
                            }
                        });
                    });

                    const currentAccountData = accounts && currentAccount ? accounts[currentAccount] : null;
                    const isSyncedAccount = currentAccountData && isAccountSynced(currentAccountData);
                    const realDiff = oldTotalCount - newTotalCount;
                    const deletedSignature = deletedTrades
                        .map(({ trade, dateKey }) => buildTradeKey(trade, dateKey))
                        .filter(Boolean)
                        .sort()
                        .join('|');

                    if (
                        deletedTrades.length > 0 &&
                        deletedTrades.length === realDiff &&
                        isSyncedAccount &&
                        deletedSignature &&
                        deletedSignature !== lastDeletedTradesAlertSignature
                    ) {
                        lastDeletedTradesAlertSignature = deletedSignature;
                        showDeletedTradesNotificationNew(deletedTrades);
                    }
                }
            }

            // Verificar si hay cambios significativos (nuevos trades o modificaciones)
            const oldTradeCount = oldEntries.reduce((sum, [, trades]) => sum + (trades || []).length, 0);
            const newTradeCount = Object.values(fresh || {}).reduce((sum, trades) => sum + (trades || []).length, 0);
            const tradeCountChanged = oldTradeCount !== newTradeCount;
            
            journalData = fresh;
            // 🔧 Exponer datos globalmente para recap-card.js
            window.journalData = journalData;
            
            // ✅ FASE 3: INVALIDAR CACHÉS DE journal-calendar.js cuando datos cambian
            if (window.journalCalendar) {
                // Marcar que los cachés necesitan recalcularse
                window.journalCalendar.syncState.annualCacheToken = Date.now();
                window.journalCalendar.syncState.monthlyIndexesToken = Date.now();
                
                // Sincronizar datos locales
                window.journalCalendar.syncFromWindowData();
            }
            window.accounts = accounts;  // Asegurar que accounts esté actualizado
            
            // 🔧 ¡IMPORTANTE! SINCRONIZAR journal-calendar.js con nuevos datos
            // Esto mantiene en sync las dos fuentes de datos (app.js y journal-calendar.js)
            if (window.journalCalendar) {
                window.journalCalendar.syncFromWindowData();
            }
            
            // 🔧 SINCRONIZAR BALANCEMANAGER CON ACCOUNTS ACTUALIZADOS
            if (window.balanceStateManager) {
                window.balanceStateManager.initialize(accounts);
            }
            
            // 🔧 ACTUALIZAR BALANCE STATE MANAGER PRIMERO (antes de cualquier UI update)
            if (window.balanceStateManager) {
                const allTrades = Object.values(journalData || {}).flat();
                window.balanceStateManager.loadTrades(currentAccount, allTrades);
            }

            // 🔧 Recalcular profit total (all-time) tras sincronización
            await refreshAccountTotalProfit(currentAccount);
            
            // 🔧 ACTUALIZAR DISPLAY (journal y calendar)
            updateDisplay();
            
            // 🔧 REFRESCAR UI EN ORDEN CORRECTO
            // 1. Actualizar métricas para TODOS los meses
            if (typeof window.updateRealTimeMetrics === 'function') {
                const allDates = Object.keys(journalData || {});
                allDates.forEach(dateKey => {
                    window.updateRealTimeMetrics(new Date(dateKey));
                });
                window.updateRealTimeMetrics(window.currentDate);
            }
            
            // 2. Actualizar balance (depende de las métricas recalculadas)
            if (typeof window.updateAccountBalance === 'function') {
                window.updateAccountBalance();
            }
            
            // 3. Actualizar últimos trades
            if (typeof window.updateLatestTrades === 'function') {
                window.updateLatestTrades();
            }
            
            // 4. Actualizar UI de cambio de cuenta
            if (currentAccount) {
                updateAccountSwitchUI(currentAccount);
            }

            if (newTrades.length > 0) {
                showSyncInProgressPopup();

                const accountName = accounts?.[currentAccount]?.name || 'Cuenta';
                const toNotify = newTrades.slice(0, 5);
                toNotify.forEach(({ trade, dateKey }) => {
                    const pair = trade?.pair || trade?.symbol || '—';
                    const direction = (trade?.direction || '').toUpperCase();
                    const profit = Number(trade?.profitUSD || 0);
                    const signedProfit = `${profit >= 0 ? '+' : ''}$${Math.abs(profit).toFixed(2)}`;
                    const dateLabel = dateKey || trade?.date || trade?.trade_date || '';

                    if (window.NotificationCenter && typeof window.NotificationCenter.add === 'function') {
                        window.NotificationCenter.add({
                            type: 'success',
                            title: 'Nuevo trade sincronizado',
                            message: `${accountName} · ${pair} ${direction} · ${signedProfit}${dateLabel ? ` · ${dateLabel}` : ''}`
                        });
                    } else if (window.showNotification) {
                        window.showNotification(`Nuevo trade sincronizado: ${pair} ${direction} ${signedProfit}`, 'success', 3000);
                    }
                });
            }
            
            // Mostrar notificación SOLO si hay cambios significativos (nuevos trades)
            // No mostrar si son solo cambios de timestamps o campos menores
            if (tradeCountChanged) {
                window.showNotification('Datos actualizados desde sincronización', 'success', 3000);
            }
        }
    } catch (err) {
        console_error('Error en doFullRefresh:', err);
    } finally {
        isFullRefreshInProgress = false;
    }
}

function stopAutoRefresh() {
    if (autoRefreshInterval) {
        clearInterval(autoRefreshInterval);
        autoRefreshInterval = null;
    }
}

// ============================================
// GESTI?N DE TRADES
// ============================================
function getMonthRange(date) {
    const base = (date instanceof Date) ? date : new Date();
    const start = new Date(base.getFullYear(), base.getMonth(), 1);
    const end = new Date(base.getFullYear(), base.getMonth() + 1, 1);
    const toDateString = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    return { start: toDateString(start), end: toDateString(end) };
}

async function loadTradesFromDB(accountId, monthDate = null, loadAll = false) {
    if (!accountId) {
        return {};
    }
    
    // ?? VALIDAR que existe la cuenta
    if (!accounts[accountId]) {
        return {};
    }
    
    try {
        // Si no hay tursoClient, retornar vac�o (modo offline)
        if (!window.tursoClient) {

            return {};
        }
        
                const { start, end } = getMonthRange(monthDate || window.currentDate || new Date());
        const sql = loadAll
            ? 'SELECT * FROM trades WHERE account_id = ? ORDER BY date, timestamp'
            : `SELECT * FROM trades
                 WHERE account_id = ?
                     AND substr(replace(replace(COALESCE(NULLIF(date,''), timestamp), '.', '-'), '/', '-'), 1, 10) >= ?
                     AND substr(replace(replace(COALESCE(NULLIF(date,''), timestamp), '.', '-'), '/', '-'), 1, 10) < ?
                 ORDER BY date, timestamp`;
        const args = loadAll ? [accountId] : [accountId, start, end];
        const result = await tursoClient.execute({ sql, args });
        
        // ?? Obtener initial_balance (nunca cambia), no balance actual (que fluct?a)
        const initialBalance = accounts[accountId]?.initial_balance || accounts[accountId]?.balance || 10000;
        
        const tradesData = {};

        const normalizeDateKey = (raw) => {
            if (!raw) return '';
            let v = String(raw).trim();
            if (v.includes('T') || v.includes(' ')) {
                v = v.split(/[T ]/)[0];
            }
            if (/^\d{4}\.\d{2}\.\d{2}$/.test(v)) {
                v = v.replace(/\./g, '-');
            }
            if (/^\d{4}\/\d{2}\/\d{2}$/.test(v)) {
                v = v.replace(/\//g, '-');
            }
            // Handle DD-MM-YYYY (or DD/MM/YYYY normalized to -)
            if (/^\d{2}-\d{2}-\d{4}$/.test(v)) {
                const [p1, p2, yyyy] = v.split('-');
                const n1 = parseInt(p1, 10);
                const n2 = parseInt(p2, 10);
                let day = p1;
                let month = p2;
                if (!Number.isNaN(n1) && !Number.isNaN(n2)) {
                    if (n1 > 12 && n2 <= 12) {
                        day = p1;
                        month = p2;
                    } else if (n2 > 12 && n1 <= 12) {
                        day = p2;
                        month = p1;
                    } else {
                        // Ambiguo: asumir formato DD-MM-YYYY
                        day = p1;
                        month = p2;
                    }
                }
                v = `${yyyy}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
            }
            return v;
        };
        
       for (const row of result.rows) {
            const dateKey = normalizeDateKey(row.date);
			
			if (!tradesData[dateKey]) {
				tradesData[dateKey] = [];
			}
			
			// ? EL PROFIT_USD YA ES NETO (incluye comisi?n y swap)
			const profitNet = row.profit_usd || 0;
			
			// ?? CALCULAR result y risk usando initial_balance (fijo)
			const resultPercent = (profitNet / initialBalance) * 100;
			const riskPercent = Math.abs(resultPercent);
			
            const trade = {
				id: row.id,
				pair: row.pair,
				symbol: row.pair,
				direction: row.direction,
				profitUSD: profitNet,        // ? YA ES NETO
				result: resultPercent,
				risk: riskPercent,
				comment: row.comment,
				entryTime: row.entry_time,
				exitTime: row.exit_time,
				tradingViewUrl: row.tradingview_url,
				timestamp: row.timestamp,
				ticket: row.ticket,
				lotSize: row.lot_size,
				entryPrice: row.entry_price,
				exitPrice: row.exit_price,
				commission: row.commission,  // ?? Solo informativo
				swap: row.swap,              // ?? Solo informativo
                importSource: row.import_source,
                entry_model_id: row.entry_model_id,
                entry_model_snapshot: row.entry_model_snapshot,
                date: dateKey
			};
			
			tradesData[dateKey].push(trade);
		}
	   

        
        return tradesData;
        
    } catch (error) {
        
        // ?? DETECTAR si es error de sesión expirada
        if (error?.message?.includes('No user token found') || error?.message?.includes('token')) {
            
            // Mostrar popup al usuario
            if (window.showNotification && typeof window.showNotification === 'function') {
                window.showNotification('⏱️ Tu sesión ha expirado. Por favor, inicia sesión nuevamente.', 'warning', 5000);
            } else {
                if (window.showAlert) {
                    window.showAlert('Sesión expirada', '⏱️ Tu sesión ha expirado. Por favor, inicia sesión nuevamente.', 'warning');
                }
            }
            
            // Limpiar datos locales
            localStorage.removeItem('userToken');
            localStorage.removeItem('userEmail');
            localStorage.removeItem('currentAccount');
            
            // En Gestión no forzar redirect por flujo de journal/auto-refresh
            if (!isGestionPage()) {
                setTimeout(() => {
                    window.location.href = '/';
                }, 2000);
            }
            
            return {};
        }
        
        return {};
    }
}

async function saveTradeToDB(accountId, dateKey, trade) {
    // ?? VALIDAR que accountId coincida con currentAccount
    if (!accountId || accountId !== currentAccount) {
        console_error('Error: accountId inv�lido o no coincide con currentAccount', { accountId, currentAccount });
        return false;
    }
    
    try {
        const safeValue = (value, defaultValue = null) => {
            if (value === undefined || value === null || value === '' || isNaN(value)) {
                return defaultValue;
            }
            return value;
        };
        
        await tursoClient.execute({
            sql: `INSERT INTO trades (
                id, account_id, date, pair, direction, 
                comment, entry_time, exit_time, tradingview_url, timestamp,
                ticket, lot_size, entry_price, exit_price, 
                commission, swap, profit_usd, import_source
            ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)`,
            args: [
                trade.id || generateId(),
                accountId,
                dateKey,
                trade.pair || trade.symbol || '',
                trade.direction || 'LONG',
                trade.comment || null,
                trade.entryTime || null,
                trade.exitTime || null,
                trade.tradingViewUrl || null,
                trade.timestamp || new Date().toISOString(),
                trade.ticket || null,
                safeValue(trade.lotSize, null),
                safeValue(trade.entryPrice, null),
                safeValue(trade.exitPrice, null),
                safeValue(trade.commission, 0),
                safeValue(trade.swap, 0),
                safeValue(trade.profitUSD, 0),  // ?? YA VIENE NETO DEL PARSER
                trade.importSource || 'manual'
            ]
        });
        
        return true;
    } catch (error) {
        console_error('Error saving trade - Details for debugging:', error);
        // NO mostrar el error t�cnico al usuario - usar mensaje gen�rico
        return false;
    }
}

async function deleteTradeFromDB(tradeId) {
    try {
        await tursoClient.execute({
            sql: 'DELETE FROM trades WHERE id = ?',
            args: [tradeId]
        });
        return true;
    } catch (error) {
        return false;
    }
}

// ?? Eliminar todos los trades de un d?a espec?fico
async function deleteTradesByDateFromDB(account, dateKey) {
    try {
        await tursoClient.execute({
            sql: 'DELETE FROM trades WHERE account_id = ? AND date = ?',
            args: [account, dateKey]
        });
        return true;
    } catch (error) {
        console_error('Error deleting trades by date:', error);
        return false;
    }
}

window.deleteTrade = async function(tradeId) {
     const confirmed = await showConfirm({
        title: '?Eliminar trade?',
        message: '?Est?s seguro de que quieres eliminar este trade? Esta acci?n no se puede deshacer.',
        confirmText: 'Eliminar',
        cancelText: 'Cancelar',
        type: 'danger',
        icon: '???'
    });
	if (!confirmed) return;
    
    const success = await deleteTradeFromDB(tradeId);
    
    if (success) {
        // ?? RECARGAR desde BD para asegurar consistencia
        journalData = await loadTradesFromDB(currentAccount, window.currentDate);
        
        // ?? Exponer datos globalmente para recap-card.js
        window.journalData = journalData;
        window.accounts = accounts;  // Asegurar que accounts est? actualizado
        
        // ?? BALANCE STATE MANAGER: Actualizar despu?s de eliminar
        if (window.balanceStateManager) {
            const allTrades = Object.values(journalData).flat();
            window.balanceStateManager.loadTrades(currentAccount, allTrades);
            
            // ?? Actualizar �ltimas operaciones si est� disponible  
            if (typeof window.updateLatestTrades === 'function') {
                setTimeout(() => window.updateLatestTrades(), 100);
            }
        }

        // ?? Recalcular profit total (all-time)
        await refreshAccountTotalProfit(currentAccount);

        // ?? Recalcular profit total (all-time)
        await refreshAccountTotalProfit(currentAccount);
        
        // ?? Refrescar tarjetas de performance
        if (typeof window.renderPerformanceCardsNew === 'function') {
            window.renderPerformanceCardsNew();
        }
        
        // ?? Invalidar cach? del recap para forzar rec?lculo
        if (typeof invalidateRecapCache === 'function') {
            invalidateRecapCache();
        }
        
        loadDayTrades(selectedDate);
        updateDisplay();
        
        // ?? Actualizar m�tricas de calendar-demo despu�s de eliminar trade
        if (typeof window.updateRealTimeMetrics === 'function') {
            window.updateRealTimeMetrics(window.currentDate);
        }
        
        showAlert('Trade Eliminado', 'Trade eliminado correctamente', 'success');
    } else {
        showAlert('Error', 'Error al eliminar el trade', 'error');
    }
}





// ============================================
// GR?FICO DE PROFIT
// ============================================
function updateProfitChart() {
    const ctx = document.getElementById('profitChart');
    if (!ctx) return;
    
    const monthStart = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const monthEnd = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    
    // ?? Usar initial_balance para c?lculos de %
    const initialBalance = accounts[currentAccount]?.initial_balance || accounts[currentAccount]?.balance || 10000;
    
    const labels = [];
    const data = [];
    let accumulatedUSD = 0;
    
    for (let d = new Date(monthStart); d <= monthEnd; d.setDate(d.getDate() + 1)) {
        // ?? FILTRAR FIN DE SEMANA si est? desactivado
        const dayOfWeek = d.getDay();
        if (!showWeekendTrades && (dayOfWeek === 0 || dayOfWeek === 6)) {
            continue; // Saltar s?bado y domingo
        }
        
        const dateKey = formatDateKey(d);
        const dayTrades = journalData[dateKey] || [];
        
        const dayProfitUSD = dayTrades.reduce((sum, trade) => sum + (trade.profitUSD || 0), 0);
        accumulatedUSD += dayProfitUSD;
        
        labels.push(d.getDate());
        data.push(calculatePercent(accumulatedUSD, initialBalance));
    }
    
    if (profitChart) profitChart.destroy();

    // Mejorar apariencia: gradiente de fondo, tama?o adaptativo
    const canvas = ctx;
    const c = canvas.getContext('2d');
    const gradient = c.createLinearGradient(0, 0, 0, canvas.height || 200);
    if (accumulatedUSD >= 0) {
        gradient.addColorStop(0, 'rgba(76, 175, 80, 0.25)');
        gradient.addColorStop(1, 'rgba(76, 175, 80, 0.02)');
    } else {
        gradient.addColorStop(0, 'rgba(244, 67, 54, 0.25)');
        gradient.addColorStop(1, 'rgba(244, 67, 54, 0.02)');
    }

    profitChart = new Chart(ctx, {
        type: 'line',
        data: {
            labels: labels,
            datasets: [{
                label: 'Profit Acumulado (%)',
                data: data,
                borderColor: accumulatedUSD >= 0 ? '#4caf50' : '#f44336',
                backgroundColor: gradient,
                borderWidth: 2.5,
                fill: true,
                tension: 0.36,
                pointRadius: 3,
                pointHoverRadius: 6,
                pointBackgroundColor: '#0f1724',
                pointBorderColor: accumulatedUSD >= 0 ? '#4caf50' : '#f44336',
                pointBorderWidth: 2
            }]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: { display: false },
                tooltip: {
                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                    padding: 10,
                    titleColor: '#ff9a3c',
                    bodyColor: '#ffffff',
                    borderColor: '#ff9a3c',
                    borderWidth: 1,
                    callbacks: {
                        label: function(context) {
                            return ` ${context.parsed.y >= 0 ? '+' : ''}${context.parsed.y.toFixed(2)}%`;
                        }
                    }
                }
            },
            layout: { padding: { top: 6, bottom: 6, left: 6, right: 6 } },
            scales: {
                y: {
                    beginAtZero: true,
                    grid: { color: 'rgba(255,255,255,0.06)' },
                    ticks: {
                        color: '#90a4ae',
                        callback: function(value) { return value + '%'; }
                    }
                },
                x: {
                    grid: { color: 'rgba(255,255,255,0.03)' },
                    ticks: { color: '#90a4ae' }
                }
            }
        }
    });
}
// ============================================
// CALENDARIO Y VISUALIZACI?N
// ============================================
function calculateWeeklyStats(weekStart, currentMonth, currentYear) {
    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekStart.getDate() + 6);
    
    // ?? Usar initial_balance para c?lculos de %
    const initialBalance = accounts[currentAccount]?.initial_balance || accounts[currentAccount]?.balance || 10000;
    
    let totalProfitUSD = 0;
    let totalTrades = 0;
    let wins = 0;
    let beCount = 0;
    let totalDurationMinutes = 0;
    let tradesWithDuration = 0;
    
    // Iterar correctamente sobre los d?as de la semana
    for (let i = 0; i < 7; i++) {
        const d = new Date(weekStart);
        d.setDate(weekStart.getDate() + i);
        
        // ?? FILTRAR d?as que no pertenecen al mes actual
        if (d.getMonth() !== currentMonth || d.getFullYear() !== currentYear) {
            continue; // Saltar d?as de otros meses
        }
        
        // ?? FILTRAR FIN DE SEMANA si est? desactivado
        const dayOfWeek = d.getDay();
        if (!showWeekendTrades && (dayOfWeek === 0 || dayOfWeek === 6)) {
            continue; // Saltar s?bado (6) y domingo (0)
        }
        
        const dateKey = formatDateKey(d);
        const dayTrades = journalData[dateKey] || [];
        
        for (const trade of dayTrades) {
            totalProfitUSD += (trade.profitUSD || 0);
            totalTrades++;
            
            if (isBreakEvenTrade(trade, initialBalance)) {
                beCount++;
            } else if ((trade.profitUSD || 0) > 0) {
                wins++;
            }
            
            // Calcular duraci?n del trade
            if (trade.entryTime && trade.exitTime) {
                const [eh, em] = String(trade.entryTime).split(':').map(Number);
                const [xh, xm] = String(trade.exitTime).split(':').map(Number);
                if (![eh, em, xh, xm].some(n => Number.isNaN(n))) {
                    const start = eh * 60 + em;
                    const end = xh * 60 + xm;
                    const duration = Math.max(0, end - start);
                    totalDurationMinutes += duration;
                    tradesWithDuration++;
                }
            }
        }
    }
    
    const totalTradesExcludingBE = totalTrades - beCount;
    const winRate = totalTradesExcludingBE > 0 ? (wins / totalTradesExcludingBE) * 100 : 0;
    const totalResultPercent = calculatePercent(totalProfitUSD, initialBalance);
    const avgDurationMinutes = tradesWithDuration > 0 ? Math.round(totalDurationMinutes / tradesWithDuration) : 0;
    
    // Formatear duraci?n: "1h 30m", "45m", etc
    let avgDurationStr = '0m';
    if (avgDurationMinutes > 0) {
        const hours = Math.floor(avgDurationMinutes / 60);
        const minutes = avgDurationMinutes % 60;
        if (hours > 0 && minutes > 0) {
            avgDurationStr = `${hours}h ${minutes}m`;
        } else if (hours > 0) {
            avgDurationStr = `${hours}h`;
        } else {
            avgDurationStr = `${minutes}m`;
        }
    }
    
    return { totalResultPercent, totalTrades, winRate, avgDurationStr, avgDurationMinutes };
}
function generateCalendar() {
    const calendar = document.getElementById('calendar');
    calendar.innerHTML = '';
    
    // ?? Usar initial_balance para c?lculos de %
    const initialBalance = accounts[currentAccount]?.initial_balance || accounts[currentAccount]?.balance || 10000;
    
    // ?? CREAR HEADERS DIN?MICOS
    const displayDayNames = showWeekendTrades 
        ? ['Lun', 'Mar', 'Mi?', 'Jue', 'Vie', 'S?b', 'Dom']
        : ['Lun', 'Mar', 'Mi?', 'Jue', 'Vie', 'Fin de Semana'];
    
    displayDayNames.forEach(day => {
        const header = document.createElement('div');
        header.className = day === 'Fin de Semana' ? 'day-header weekend-header' : 'day-header';
        header.textContent = day;
        calendar.appendChild(header);
    });
    
    // ?? APLICAR CLASE DIN?MICO AL GRID
    if (showWeekendTrades) {
        calendar.classList.add('weekend-on');
        calendar.classList.remove('weekend-off');
    } else {
        calendar.classList.add('weekend-off');
        calendar.classList.remove('weekend-on');
    }
    
    const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    
    // Calcular celdas vac?as al principio (para alineamiento)
    const dayOfWeek = firstDay.getDay();
    const emptyDaysStart = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
    
    // Generar celdas vac?as iniciales
    for (let i = 0; i < emptyDaysStart; i++) {
        const cell = document.createElement('div');
        cell.className = 'day-cell other-month';
        cell.setAttribute('data-date', '');
        cell.innerHTML = '<div class="day-number"></div>';
        calendar.appendChild(cell);
    }
    
    // Generar celdas del mes actual
    for (let dayNum = 1; dayNum <= lastDay.getDate(); dayNum++) {
        const cell = document.createElement('div');
        cell.className = 'day-cell';
        
        // Formatear fecha manualmente para evitar problemas de zona horaria
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(dayNum).padStart(2, '0');
        const dateStr = `${year}-${month}-${day}`;
        
        cell.setAttribute('data-date', dateStr);
        
        // Crear Date para eventos (onclick, etc)
        const cellDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), dayNum);
        
        // NO añadir onclick si estamos en calendar-demo.html (calendar-demo.js maneja los clicks)
        if (!window.location.pathname.includes('calendar-demo')) {
            cell.onclick = () => openDayModal(cellDate);
        }
        
        const today = new Date();
        if (cellDate.toDateString() === today.toDateString()) {
            cell.classList.add('today');
        }
        
        // ?? Marcar fin de semana
        const currentDayOfWeek = cellDate.getDay();
        if (currentDayOfWeek === 0 || currentDayOfWeek === 6) {
            cell.classList.add('weekend-day');
        }
        
        const dayTrades = journalData[formatDateKey(cellDate)] || [];
        
        let dailyProfitUSD = 0;
        dayTrades.forEach(trade => {
            dailyProfitUSD += (trade.profitUSD || 0);
        });
        
        const dailyResultPercent = calculatePercent(dailyProfitUSD, initialBalance);
        
        let resultClass = 'neutral';
        if (dayTrades.length > 0) {
            // Si hay trades, determinar el color seg?n el resultado
            if (dailyResultPercent > 0.01) {
                resultClass = 'positive';
            } else if (dailyResultPercent < -0.01) {
                resultClass = 'negative';
            } else {
                // Entre -0.01 y 0.01 (incluye 0.0) ? Breakeven (?mbar)
                resultClass = 'breakeven';
            }
        }

        cell.innerHTML = `
            <div class="day-number">${dayNum}</div>
            <div class="day-content">
                ${dayTrades.map(trade => {
                    const tradePercent = calculatePercent(trade.profitUSD || 0, initialBalance);
                    return `
                    <div class="trade-item ${trade.profitUSD > 0 ? 'win' : trade.profitUSD < 0 ? 'loss' : 'breakeven'}" data-entry-time="${trade.entryTime || ''}" data-exit-time="${trade.exitTime || ''}">
                        <div class="trade-summary">
                            <span class="pair-direction">${trade.pair} ${trade.direction}</span>
                            <span class="result ${tradePercent > 0 ? 'positive' : tradePercent < 0 ? 'negative' : 'neutral'}">
                                ${tradePercent > 0 ? '+' : ''}${tradePercent.toFixed(1)}%
                            </span>
                        </div>
                    </div>
                `}).join('')}
            </div>
            ${dayTrades.length > 0 ? `
                <div class="day-top-info">
                    <div class="day-result-circle ${resultClass}">
                        ${dailyResultPercent > 0 ? '+' : ''}${dailyResultPercent.toFixed(1)}%
                    </div>
                    <div class="trades-count">${dayTrades.length}</div>
                </div>
            ` : ''}
        `;
        
        calendar.appendChild(cell);
    }
    
    // Generar celdas vac?as al final si es necesario (para completar la ?ltima semana)
    const totalCells = emptyDaysStart + lastDay.getUTCDate();
    const emptyDaysEnd = (7 - (totalCells % 7)) % 7;
    
    for (let i = 0; i < emptyDaysEnd; i++) {
        const cell = document.createElement('div');
        cell.className = 'day-cell other-month';
        cell.setAttribute('data-date', '');
        cell.innerHTML = '<div class="day-number"></div>';
        calendar.appendChild(cell);
    }
    
    // ?? Si fin de semana est? OFF, agregar celda comprimida "Fin de Semana" y stats semanales
    // Para esto, necesitamos agrupar por semanas manualmente
    const allCells = Array.from(calendar.querySelectorAll('.day-cell'));
    
    // ?? Primero: identificar cu?les semanas tienen d?as v?lidos
    const validWeeks = [];
    for (let i = 0; i < allCells.length; i += 7) {
        const weekCells = allCells.slice(i, i + 7);
        const hasValidDay = weekCells.some(cell => {
            const cellDate = cell.getAttribute('data-date');
            return cellDate && cellDate !== '';
        });
        
        if (hasValidDay) {
            validWeeks.push({ index: i, cells: weekCells });
        }
    }
    
    // ?? Luego: iterar solo sobre semanas v?lidas
    let weekIndex = 0;
    validWeeks.forEach(({ index: i, cells: weekCells }) => {
        const weekStartDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        weekStartDate.setDate(weekStartDate.getDate() + i - emptyDaysStart);
        
        // Si fin de semana est? OFF, agregar celda comprimida "Fin de Semana"
        if (!showWeekendTrades) {
            const weekendCell = document.createElement('div');
            weekendCell.className = 'weekend-cell';
            weekendCell.style.display = 'flex';
            weekendCell.style.alignItems = 'center';
            weekendCell.style.justifyContent = 'center';
            weekendCell.innerHTML = `<div style="text-align: center; color: #888; font-size: 11px; font-weight: 600;">Fin de<br>Semana</div>`;
            calendar.appendChild(weekendCell);
        }
        
        // ?? Stats semanales con USD
        const weeklyStats = calculateWeeklyStats(weekStartDate, currentDate.getMonth(), currentDate.getFullYear());
        const weeklyCell = document.createElement('div');
        weeklyCell.className = 'weekly-summary';
        weeklyCell.dataset.duration = weeklyStats.avgDurationStr;
        
        if (weeklyStats.totalResultPercent > 0) {
            weeklyCell.classList.add('positive');
        } else if (weeklyStats.totalResultPercent < 0) {
            weeklyCell.classList.add('negative');
        }
        
        weeklyCell.innerHTML = `
            <div class="week-title">Semana ${weekIndex + 1}</div>
            <div class="week-result ${weeklyStats.totalResultPercent > 0 ? 'positive' : weeklyStats.totalResultPercent < 0 ? 'negative' : 'neutral'}">
                ${weeklyStats.totalResultPercent > 0 ? '+' : ''}${weeklyStats.totalResultPercent.toFixed(1)}%
            </div>
            <div class="week-trades">${weeklyStats.totalTrades} trades</div>
            <div class="week-winrate">${weeklyStats.winRate.toFixed(0)}% WR</div>
            <div class="week-duration">${weeklyStats.avgDurationStr}</div>
        `;
        
        calendar.appendChild(weeklyCell);
        weekIndex++;
    });

    if (typeof window.updateEventsButtonVisibility === 'function') {
        window.updateEventsButtonVisibility();
    }

    if (typeof window.markEconomicEventDates === 'function') {
        const cachedEvents = localStorage.getItem('economicEventsCache');
        if (cachedEvents) {
            try {
                const eventsData = JSON.parse(cachedEvents);
                if (Array.isArray(eventsData) && eventsData.length > 0) {
                    const userPlan = (localStorage.getItem('userPlan') || 'free').toLowerCase();
                    if (userPlan === 'unlimited') {
                        window.markEconomicEventDates(eventsData);
                    }
                }
            } catch (e) {
                // Ignore cache parse errors
            }
        }
    }
}
function updateMonthStats() {
    const monthStart = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const monthEnd = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    // ?? Usar initial_balance para c?lculos de %
    const initialBalance = accounts[currentAccount]?.initial_balance || accounts[currentAccount]?.balance || 10000;

    // M?tricas del mes
    let monthlyProfitUSD = 0;
    let totalTrades = 0;
    let wins = 0;
    let beCount = 0;

    // M?trica total hist?rico
    let allTimeProfitUSD = 0;

    // M?tricas derivadas
    let monthlyTrades = [];
    let grossProfit = 0;
    let grossLoss = 0;
    let tradesByHour = {};

    // M?tricas de Revenge Trading
    let revengeTrades = [];
    const REVENGE_TIME_WINDOW = 30; // minutos para considerar revenge trading

    // Recolectar trades del mes y calcular m?tricas mensuales
    // ?? SIEMPRE incluir TODOS los trades (no filtrar por fin de semana)
    // El filtro de fin de semana solo afecta la VISUALIZACI?N del calendario
    for (let d = new Date(monthStart); d <= monthEnd; d.setDate(d.getDate() + 1)) {
        const dateKey = formatDateKey(d);
        const dayTrades = journalData[dateKey] || [];
        monthlyTrades = monthlyTrades.concat(dayTrades);

        dayTrades.forEach(trade => {
            monthlyProfitUSD += (trade.profitUSD || 0);
            totalTrades++;
            
            if (isBreakEvenTrade(trade, initialBalance)) {
                beCount++;
            } else if ((trade.profitUSD || 0) > 0) {
                wins++;
            }
        });
    }

    // Calcular total hist?rico (SIN FILTRO DE FIN DE SEMANA - siempre todos los d?as)
    Object.keys(journalData).forEach(dateKey => {
        const trades = journalData[dateKey] || [];
        trades.forEach(trade => {
            allTimeProfitUSD += Number(trade.profitUSD || 0);
        });
    });

    // Actualizar m?tricas b?sicas (mes y totales)
    const monthlyResultPercent = calculatePercent(monthlyProfitUSD, initialBalance);
    const totalTradesExcludingBE = totalTrades - beCount;
    const winRate = totalTradesExcludingBE > 0 ? (wins / totalTradesExcludingBE) * 100 : 0;

    const totalResultEl = document.getElementById('totalResult');
    if (totalResultEl) {
        // Guardar ambos valores en data attributes
        totalResultEl.setAttribute('data-usd', monthlyProfitUSD.toFixed(2));
        totalResultEl.setAttribute('data-percent', monthlyResultPercent.toFixed(2));
        totalResultEl.textContent = `${monthlyResultPercent > 0 ? '+' : ''}${monthlyResultPercent.toFixed(2)}%`;
        totalResultEl.className = `stat-value ${monthlyResultPercent > 0 ? 'positive' : monthlyResultPercent < 0 ? 'negative' : 'neutral'}`;
    }

    const totalTradesEl = document.getElementById('totalTrades');
    if (totalTradesEl) totalTradesEl.textContent = totalTrades;
    
    // ?? Verificar l?mite de trades en plan Free
    checkFreeTradeLimit(totalTrades);

    const winRateEl = document.getElementById('winRate');
    if (winRateEl) {
        winRateEl.textContent = `${winRate.toFixed(0)}%`;
    }

    const totalProfitEl = document.getElementById('totalProfitUSD');
    if (totalProfitEl) {
        // Guardar ambos valores en data attributes
        const totalResultPercent = calculatePercent(allTimeProfitUSD, initialBalance);
        totalProfitEl.setAttribute('data-usd', allTimeProfitUSD.toFixed(2));
        totalProfitEl.setAttribute('data-percent', totalResultPercent.toFixed(2));
        totalProfitEl.textContent = allTimeProfitUSD >= 0 ? `+$${Math.abs(allTimeProfitUSD).toFixed(2)}` : `-$${Math.abs(allTimeProfitUSD).toFixed(2)}`;
        totalProfitEl.className = `stat-value ${allTimeProfitUSD > 0 ? 'positive' : allTimeProfitUSD < 0 ? 'negative' : 'neutral'}`;
    }

    // Si no hay trades mensuales, limpiar m?tricas avanzadas y salir
    if (monthlyTrades.length === 0) {
        const fields = ['bestTrade','bestTradePair','worstTrade','worstTradePair','avgTradeProfit',
                       'profitFactor','bestHour','rMultipleRatio','maxR'];
        fields.forEach(id => { const el = document.getElementById(id); if (el) el.textContent = '--'; });
        return;
    }

    // Calcular distribuci?n R-Multiple
    const rMultiples = monthlyTrades.map(trade => {
        const result = (trade.profitUSD || 0) / initialBalance * 100;
        const r = result / (trade.risk || 1); // Si no hay risk definido, asumimos 1%
        return r;
    });

    // Agrupar R-Multiples en rangos
    const rDistribution = {
        'menos -2R': 0,
        '-2R a -1R': 0,
        '-1R a 0': 0,
        '0 a 1R': 0,
        '1R a 2R': 0,
        'm?s 2R': 0
    };

    rMultiples.forEach(r => {
        if (r <= -2) rDistribution['menos -2R']++;
        else if (r <= -1) rDistribution['-2R a -1R']++;
        else if (r < 0) rDistribution['-1R a 0']++;
        else if (r <= 1) rDistribution['0 a 1R']++;
        else if (r <= 2) rDistribution['1R a 2R']++;
        else rDistribution['m?s 2R']++;
    });

    // Actualizar gr?fico R-Multiple
    const rMultipleChart = document.getElementById('rMultipleChart');
    if (rMultipleChart) {
        const ctx = rMultipleChart.getContext('2d');
        if (window.rMultipleChartInstance) {
            window.rMultipleChartInstance.destroy();
        }

        window.rMultipleChartInstance = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: Object.keys(rDistribution),
                datasets: [{
                    data: Object.values(rDistribution),
                    backgroundColor: [
                        '#ef5350',  // rojo fuerte (menos -2R)
                        '#ff7043',  // naranja (-)
                        '#ffa726',  // naranja claro (-)
                        '#66bb6a',  // verde claro (+)
                        '#26a69a',  // verde (+)
                        '#00897b'   // verde fuerte (m?s 2R)
                    ],
                    borderWidth: 0,
                    borderRadius: 4
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        backgroundColor: 'rgba(0, 0, 0, 0.85)',
                        padding: 10,
                        titleColor: '#ff9a3c',
                        bodyColor: '#ffffff',
                        borderColor: '#ff9a3c',
                        borderWidth: 1,
                        callbacks: {
                            label: function(context) {
                                return `${context.parsed.y} trades`;
                            }
                        }
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        grid: { color: 'rgba(255,255,255,0.06)' },
                        ticks: { color: '#90a4ae' }
                    },
                    x: {
                        grid: { display: false },
                        ticks: { color: '#90a4ae' }
                    }
                }
            }
        });
    }

    // Calcular m?tricas R-Multiple
    const positiveRs = rMultiples.filter(r => r > 0);
    const negativeRs = rMultiples.filter(r => r < 0);
    const avgPositiveR = positiveRs.length ? positiveRs.reduce((a,b) => a + b, 0) / positiveRs.length : 0;
    const avgNegativeR = negativeRs.length ? Math.abs(negativeRs.reduce((a,b) => a + b, 0) / negativeRs.length) : 0;
    const rMultipleRatio = avgNegativeR ? (avgPositiveR / avgNegativeR).toFixed(2) : '--';
    const maxR = rMultiples.length ? Math.max(...rMultiples).toFixed(2) : '--';

    // Actualizar valores en la UI
    const rMultipleRatioEl = document.getElementById('rMultipleRatio');
    const maxREl = document.getElementById('maxR');
    if (rMultipleRatioEl) rMultipleRatioEl.textContent = rMultipleRatio + 'x';
    if (maxREl) maxREl.textContent = maxR + 'R';

    // Calcular mejor/peor/avg
    const bestTrade = monthlyTrades.reduce((best, t) => (!best || (t.profitUSD > best.profitUSD)) ? t : best, null);
    const worstTrade = monthlyTrades.reduce((worst, t) => (!worst || (t.profitUSD < worst.profitUSD)) ? t : worst, null);
    const avgProfit = monthlyTrades.reduce((s, t) => s + Number(t.profitUSD || 0), 0) / monthlyTrades.length;

    const bestTradeEl = document.getElementById('bestTrade');
    if (bestTradeEl) {
        bestTradeEl.textContent = bestTrade ? `${bestTrade.profitUSD >= 0 ? '+' : '-'}$${Math.abs(bestTrade.profitUSD).toFixed(2)}` : '--';
        bestTradeEl.className = `highlight-value ${bestTrade && bestTrade.profitUSD > 0 ? 'positive' : bestTrade && bestTrade.profitUSD < 0 ? 'negative' : 'neutral'}`;
    }
    
    const bestTradePairEl = document.getElementById('bestTradePair');
    if (bestTradePairEl) {
        bestTradePairEl.textContent = bestTrade ? (bestTrade.pair || bestTrade.symbol || '--') : '--';
    }

    // worstTrade y avgTradeProfit no existen en el HTML actual, se dejan para expansi?n futura

    // Calcular Profit Factor, rachas y mejor hora
    monthlyTrades.forEach(trade => {
        const p = Number(trade.profitUSD || 0);
        if (p > 0) grossProfit += p;
        else grossLoss += Math.abs(p);

        if (trade.entryTime) {
            const hour = new Date('2000-01-01T' + trade.entryTime).getHours();
            if (!tradesByHour[hour]) tradesByHour[hour] = { profit: 0, count: 0 };
            tradesByHour[hour].profit += p;
            tradesByHour[hour].count += 1;
        }
    });

    const profitFactor = grossLoss === 0 ? (grossProfit > 0 ? grossProfit.toFixed(2) : '--') : (grossProfit / grossLoss).toFixed(2);
    const profitFactorEl = document.getElementById('profitFactor');
    if (profitFactorEl) {
        profitFactorEl.textContent = profitFactor;
        // profitFactor est? en m?tricas disponibles para Free, pero lo dejamos sin restricci?n
    }

    // Calcular m?tricas de revenge trading
    monthlyTrades.sort((a, b) => new Date(`2000-01-01T${a.entryTime}`) - new Date(`2000-01-01T${b.entryTime}`));
    
    for (let i = 1; i < monthlyTrades.length; i++) {
        const currentTrade = monthlyTrades[i];
        const previousTrade = monthlyTrades[i-1];
        
        if (!currentTrade.entryTime || !previousTrade.entryTime) continue;

        const currentTime = new Date(`2000-01-01T${currentTrade.entryTime}`);
        const previousTime = new Date(`2000-01-01T${previousTrade.entryTime}`);
        const timeDiff = (currentTime - previousTime) / (1000 * 60); // diferencia en minutos

        // Si el trade anterior fue p?rdida y este trade fue dentro del tiempo de revenge
        if (previousTrade.profitUSD < 0 && timeDiff <= REVENGE_TIME_WINDOW) {
            revengeTrades.push(currentTrade);
        }
    }

    // Calcular score y estad?sticas de revenge
    const revengeTradesCount = revengeTrades.length;
    const revengeBeCount = revengeTrades.filter(t => isBreakEvenTrade(t, initialBalance)).length;
    const revengeTradesExcludingBE = revengeTradesCount - revengeBeCount;
    const revengeWins = revengeTrades.filter(t => !isBreakEvenTrade(t, initialBalance) && t.profitUSD > 0).length;
    const revengeWinRate = revengeTradesExcludingBE > 0 ? (revengeWins / revengeTradesExcludingBE * 100) : 0;
    
    // Factor de riesgo basado en frecuencia de revenge trades
    const revengeFactor = totalTrades > 0 ? (revengeTradesCount / totalTrades) : 0;
    
    // Calcular Revenge Score (0-100)
    let revengeScore = 100 - (revengeFactor * 100);
    if (revengeTradesCount > 0) {
        // Penalizar m?s si el win rate de revenge es bajo
        revengeScore -= ((100 - revengeWinRate) * 0.3);
    }
    revengeScore = Math.max(0, Math.min(100, revengeScore));

    // Actualizar UI de Revenge Trading
    const revengeScoreEl = document.getElementById('revengeScore');
    const revengeTradesEl = document.getElementById('revengeTrades');
    const revengeWinRateEl = document.getElementById('revengeWinRate');

    if (revengeScoreEl) {
        revengeScoreEl.textContent = revengeScore.toFixed(0);
        // Aplicar clases de color seg?n el score
        revengeScoreEl.className = 'metric-value ' + 
            (revengeScore >= 80 ? 'good' : 
             revengeScore >= 50 ? 'warning' : 
             'danger');
    }
    if (revengeTradesEl) revengeTradesEl.textContent = revengeTradesCount;
    if (revengeWinRateEl) revengeWinRateEl.textContent = revengeWinRate.toFixed(1) + '%';

    // Mejor hora
    let bestHour = null; let bestHourProfit = -Infinity;
    Object.entries(tradesByHour).forEach(([hour, data]) => {
        const avg = data.profit / data.count;
        if (avg > bestHourProfit) {
            bestHourProfit = avg;
            bestHour = hour;
        }
    });
    const bestHourEl = document.getElementById('bestHour');
    if (bestHourEl) bestHourEl.textContent = bestHour !== null ? `${bestHour}:00 (${bestHourProfit >= 0 ? '+' : ''}$${bestHourProfit.toFixed(2)})` : '--';
}
window.changeMonth = async function(direction) {
    // No hacer nada si estamos en vista anual
    if (window.journalCalendar?.syncState?.viewMode === 'annual') return;

    currentDate.setMonth(currentDate.getMonth() + direction);
    window.currentDate = currentDate; // Exponer para calendar-demo.js

    await loadCurrentAccountData();
    updateDisplay();
    
    // ?? Actualizar m�tricas del mes visible
    if (typeof window.updateRealTimeMetrics === 'function') {
        window.updateRealTimeMetrics(currentDate);
    }
    
    // ?? Actualizar �ltimas operaciones cuando se cambia de mes
    if (typeof window.updateLatestTrades === 'function') {
        setTimeout(() => window.updateLatestTrades(), 200);
    }
    
    // ?? Re-aplicar marcadores de eventos económicos (SOLO PARA UNLIMITED)
    const userPlan = (localStorage.getItem('userPlan') || 'free').toLowerCase();
    if (userPlan === 'unlimited' && window.economicEventsByDate && typeof window.markEconomicEventDates === 'function') {
        const eventsArray = Object.values(window.economicEventsByDate).flat();
        setTimeout(() => window.markEconomicEventDates(eventsArray), 100);
    }
    
    // ?? Actualizar visibilidad del botón Eventos (solo mes actual)
    if (typeof window.updateEventsButtonVisibility === 'function') {
        setTimeout(() => window.updateEventsButtonVisibility(), 100);
    }
}

// ?? MANEJADOR DEL TOGGLE DE FIN DE SEMANA
window.toggleWeekend = function() {
    const toggle = document.getElementById('weekendToggleBtn');
    if (!toggle) return;
    
    // Alternar estado
    showWeekendTrades = !showWeekendTrades;
    localStorage.setItem('showWeekendTrades', showWeekendTrades ? '1' : '0');
    updateWeekendToggleStyle();
    updateDisplay();
}

// ?? FUNCI?N PARA ACTUALIZAR ESTILO DEL TOGGLE DE FIN DE SEMANA
function updateWeekendToggleStyle() {
    const weekendToggle = document.getElementById('weekendToggleBtn');
    if (!weekendToggle) return;
    
    if (showWeekendTrades) {
        weekendToggle.classList.add('active');
    } else {
        weekendToggle.classList.remove('active');
    }
}

// ?? GENERAR M?TRICA MENSUAL HORIZONTAL
function generateMonthlyChart() {
    const container = document.getElementById('monthlyChart');
    if (!container) return;
    
    container.innerHTML = '';
    
    const initialBalance = accounts[currentAccount]?.initial_balance || accounts[currentAccount]?.balance || 10000;
    const currentYear = currentDate.getFullYear();
    const monthlyData = [];
    
    // Calcular profit por mes para el a?o actual
    for (let month = 0; month < 12; month++) {
        const monthStart = new Date(currentYear, month, 1);
        const monthEnd = new Date(currentYear, month + 1, 0);
        
        let monthlyProfitUSD = 0;
        
        for (let d = new Date(monthStart); d <= monthEnd; d.setDate(d.getDate() + 1)) {
            // ?? FILTRAR FIN DE SEMANA si est? desactivado
            const dayOfWeek = d.getDay();
            if (!showWeekendTrades && (dayOfWeek === 0 || dayOfWeek === 6)) {
                continue;
            }
            
            const dateKey = formatDateKey(d);
            const dayTrades = journalData[dateKey] || [];
            dayTrades.forEach(trade => {
                monthlyProfitUSD += (trade.profitUSD || 0);
            });
        }
        
        const monthPercent = calculatePercent(monthlyProfitUSD, initialBalance);
        monthlyData.push({
            month: monthNames[month],
            profitUSD: monthlyProfitUSD,
            profitPercent: monthPercent
        });
    }
    
    // Renderizar items
    monthlyData.forEach(data => {
        const item = document.createElement('div');
        item.className = 'month-item';
        
        const percentClass = data.profitPercent > 0 ? 'positive' : data.profitPercent < 0 ? 'negative' : 'neutral';
        const usdClass = data.profitUSD > 0 ? 'positive' : data.profitUSD < 0 ? 'negative' : 'neutral';
        
        item.innerHTML = `
            <div class="month-name">${data.month.slice(0, 3)}</div>
            <div class="month-result ${percentClass}">
                ${data.profitPercent > 0 ? '+' : ''}${data.profitPercent.toFixed(1)}%
            </div>
            <div class="month-usd ${usdClass}">
                ${data.profitUSD >= 0 ? '+' : ''}$${Math.abs(data.profitUSD).toFixed(0)}
            </div>
        `;
        
        container.appendChild(item);
    });
}

// ?? Generar vista de desempe?o en pills (7 meses: 3 antes, actual, 3 despu?s)
function generatePerformanceChartBar() {
    const container = document.getElementById('performanceStrip');
    if (!container) return;
    
    container.innerHTML = '';
    
    const initialBalance = accounts[currentAccount]?.initial_balance || accounts[currentAccount]?.balance || 10000;
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();
    
    // Mostrar 7 meses: 3 anteriores, actual, 3 posteriores + offset
    const startMonth = currentMonth - 3 + performanceViewOffset;
    
    for (let i = 0; i < 7; i++) {
        const monthIndex = startMonth + i;
        let displayMonth = monthIndex;
        let displayYear = currentYear;
        
        // Ajustar a?o si el mes es negativo o > 11
        if (displayMonth < 0) {
            displayYear -= 1;
            displayMonth += 12;
        } else if (displayMonth > 11) {
            displayYear += 1;
            displayMonth -= 12;
        }
        
        // Calcular profit para este mes
        const monthStart = new Date(displayYear, displayMonth, 1);
        const monthEnd = new Date(displayYear, displayMonth + 1, 0);
        
        let monthlyProfitUSD = 0;
        
        for (let d = new Date(monthStart); d <= monthEnd; d.setDate(d.getDate() + 1)) {
            const dateKey = formatDateKey(d);
            const dayTrades = journalData[dateKey] || [];
            dayTrades.forEach(trade => {
                monthlyProfitUSD += (trade.profitUSD || 0);
            });
        }
        
        const monthPercent = calculatePercent(monthlyProfitUSD, initialBalance);
        const isCurrentMonth = displayMonth === currentMonth && displayYear === currentYear;
        
        // Determinar clase de estado
        let statusClass = '';
        if (isCurrentMonth) {
            statusClass = 'current';
        } else if (monthPercent > 0) {
            statusClass = 'positive';
        } else if (monthPercent < 0) {
            statusClass = 'negative';
        }
        
        // Crear pill
        const pill = document.createElement('div');
        pill.className = `perf-pill-item ${statusClass}`;
        pill.onclick = () => navigateToMonth(displayYear, displayMonth);
        pill.title = `${monthNames[displayMonth]} ${displayYear}: ${monthPercent.toFixed(2)}%`;
        
        pill.innerHTML = `
            <div class="perf-pill-month">${monthNames[displayMonth].slice(0, 3)}</div>
            <div class="perf-pill-value">
                ${monthPercent > 0 ? '+' : ''}${monthPercent.toFixed(2)}%
            </div>
        `;
        
        container.appendChild(pill);
    }
}

// ?? Navegar a un mes espec?fico al hacer click en una pill
window.navigateToMonth = function(year, month) {
    currentDate = new Date(year, month, 1);
    updateDisplay();
}

// ?? Desplazar vista de desempe?o
window.shiftPerformanceView = function(direction) {
    performanceViewOffset += direction;
    generatePerformanceChartBar();
}

function updateDisplay() {
    const monthYearElement = document.getElementById('monthYear');
    if (!monthYearElement) {
        return;
    }
    
    monthYearElement.textContent = 
        `${monthNames[currentDate.getMonth()]} ${currentDate.getFullYear()}`;
    
    generateCalendar();
    generatePerformanceChartBar();
    updateMonthStats();
    updateAccountBalance();
    
    // Defer expensive chart rendering to idle time
    try {
        if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
            window.requestIdleCallback(() => {
                try { updateProfitChart(); } catch (e) { console_warn('updateProfitChart failed', e); }
            }, { timeout: 1000 });
        } else {
            setTimeout(() => {
                try { updateProfitChart(); } catch (e) { console_warn('updateProfitChart failed', e); }
            }, 300);
        }
    } catch (e) { try { updateProfitChart(); } catch (e) {} }
}

// ?? Exponer funciones de manejo de cuentas a window despu?s de definirlas
window.changeAccount = changeAccount;
window.selectCustomOption = selectCustomOption;
window.updateDisplay = updateDisplay;
window.updateMonthStats = updateMonthStats;

// Exponer loadTradesFromDB globalmente para IA Scanner y otros módulos
window.loadTradesFromDB = loadTradesFromDB;

// Carga todos los trades de un año para la vista anual del calendario
window.loadYearTradesForAnnualView = async function(year) {
    if (!window.currentAccount) return {};
    try {
        const allTrades = await loadTradesFromDB(window.currentAccount, null, true);
        // Filtrar solo el año solicitado
        const yearTrades = {};
        Object.keys(allTrades).forEach(dateKey => {
            if (dateKey.startsWith(year + '-')) {
                yearTrades[dateKey] = allTrades[dateKey];
            }
        });
        return yearTrades;
    } catch (e) {
        return {};
    }
};

function updateAccountBalance() {
    const balanceElement = document.getElementById('accountBalance');
    if (!balanceElement) return;
    
    if (currentAccount && accounts[currentAccount]) {
        let currentBalance = 0;
        if (window.balanceStateManager) {
            currentBalance = window.balanceStateManager.getAccountBalance(currentAccount);
        } else {
            const account = accounts[currentAccount];
            const initialBalance = parseFloat(account.initial_balance) || parseFloat(account.balance) || 0;
            let totalProfit = 0;
            if (journalData && typeof journalData === 'object') {
                Object.entries(journalData).forEach(([dateKey, trades]) => {
                    if (Array.isArray(trades)) {
                        trades.forEach(trade => {
                            const profit = parseFloat(trade.profitUSD || trade.profit || 0) || 0;
                            totalProfit += profit;
                        });
                    }
                });
            }
            currentBalance = initialBalance + totalProfit;
        }
        
        // Asegurar que es un número válido
        const safeBalance = isNaN(currentBalance) ? 0 : parseFloat(currentBalance);
        
        // Formatear con separadores de miles y 2 decimales
        const formatted = safeBalance.toLocaleString('en-US', { 
            minimumFractionDigits: 2, 
            maximumFractionDigits: 2 
        });
        
        balanceElement.textContent = `$${formatted}`;
        balanceElement.className = `stat-value`;  // Siempre naranja (primario), sin clases de color
    } else {
        balanceElement.textContent = '$0';
    }
}


// ============================================
// MODALES
// ============================================
function openDayModal(date) {
    selectedDate = date;
    const modal = document.getElementById('dayModal');
    const modalTitle = document.getElementById('modalTitle');
    const formSection = document.getElementById('formSection');
    const weekendNotice = document.getElementById('weekendNotice');
    
    modalTitle.textContent = `${date.getDate()} de ${monthNames[date.getMonth()]}`;
    
    // ?? VERIFICAR SI LA CUENTA ES SINCRONIZADA
    const currentAccountData = currentAccount ? accounts[currentAccount] : null;
    const isSyncedAccount = currentAccountData && isAccountSynced(currentAccountData);
    
    if (isSyncedAccount) {
        // ? Cuenta sincronizada - ocultar formulario de trades
        formSection.classList.add('hidden');
        weekendNotice.classList.add('hidden');
        
        // Mostrar mensaje especial
        let syncNotice = document.getElementById('syncAccountNotice');
        if (!syncNotice) {
            syncNotice = document.createElement('div');
            syncNotice.id = 'syncAccountNotice';
            syncNotice.style.cssText = `
                background: rgba(255, 154, 60, 0.12);
                border: 2px solid #ff9a3c;
                border-radius: 8px;
                padding: 20px;
                margin: 15px 0;
                color: #ff9a3c;
                font-weight: bold;
                text-align: center;
                box-shadow: 0 4px 15px rgba(255, 154, 60, 0.2);
            `;
        }
        syncNotice.innerHTML = `
            <div style="font-size: 18px; margin-bottom: 10px;">?? Cuenta Sincronizada</div>
            <div style="font-size: 14px; line-height: 1.6;">
                Esta cuenta est? sincronizada con ${getSyncProviderLabel(currentAccountData)}.<br>
                Los trades se actualizan autom?ticamente.<br>
                <br>
                ? <strong>No se pueden a?adir trades manualmente</strong> para evitar inconsistencias.<br>
                ? Puedes a?adir notas de trading en la pesta?a "Notas".
            </div>
        `;
        
        const formContainer = formSection.parentElement;
        if (formContainer && !formContainer.contains(syncNotice)) {
            formContainer.insertBefore(syncNotice, formSection);
        }
    } else {
        // ? Cuenta manual - mostrar formulario normalmente
        formSection.classList.remove('hidden');
        
        // Ocultar el aviso de sincronizaci?n si existe
        const syncNotice = document.getElementById('syncAccountNotice');
        if (syncNotice) syncNotice.remove();
        
        // ?? PERMITIR trades los fines de semana (no ocultar formulario)
        // Solo mostrar aviso informativo
        if (isWeekend(date)) {
            weekendNotice.classList.remove('hidden');
        } else {
            weekendNotice.classList.add('hidden');
        }
    }
    
    loadDayTrades(date);
    
    // populate notes tab if server note exists
    try {
        const dateKey = formatDateKey(date);
        const mcMap = window.__dailyNotesMap || {};
        const note = mcMap[dateKey] || null;
        
        // ?? Mostrar vista previa de nota en el panel de notas
        const previewContainer = document.getElementById('notesPreviewContainer');
        if (previewContainer) {
            if (note && note.note) {
                const sentimentEmojiMap = {
                    cabreado: '??',
                    estresado: '??',
                    tranquilo: '??',
                    emocionado: '??',
                    con_sueno: '??',
                    otro: '??'
                };
                const sentimentIcon = sentimentEmojiMap[note.sentiment] || '';
                const outcomeClass = note.day_outcome || note.outcome || '';
                const outcomeLabel = {
                    ganador: '?? Ganador',
                    perdedor: '?? Perdedor',
                    break_even: '?? Break Even',
                    neutral: '? Sin cambios'
                }[outcomeClass] || '';
                
                previewContainer.innerHTML = `
                    <div class="notes-card">
                        <div class="notes-card-header">
                            <div class="notes-card-date">?? Nota del ${dateKey}</div>
                            <div class="notes-card-sentiment">${sentimentIcon}</div>
                            ${outcomeLabel ? `<div class="notes-card-outcome ${outcomeClass}">${outcomeLabel}</div>` : ''}
                        </div>
                        <div class="notes-card-text">${escapeHtml(note.note || '')}</div>
                    </div>
                `;
                previewContainer.style.display = 'block';
            } else {
                previewContainer.innerHTML = '';
                previewContainer.style.display = 'none';
            }
        }
        
        if (note) {
            const sentimentEl = document.getElementById('notesSentiment');
            const outcomeEl = document.getElementById('notesOutcome');
            const textarea = document.getElementById('notesTextarea');
            if (sentimentEl) sentimentEl.value = note.sentiment || '';
            if (outcomeEl) outcomeEl.value = note.day_outcome || note.outcome || '';
            if (textarea) textarea.value = note.note || '';
        } else {
            // clear fields for no-note
            const sentimentEl = document.getElementById('notesSentiment');
            const outcomeEl = document.getElementById('notesOutcome');
            const textarea = document.getElementById('notesTextarea');
            if (sentimentEl) sentimentEl.value = '';
            if (outcomeEl) outcomeEl.value = '';
            if (textarea) textarea.value = '';
        }
    } catch (e) {}
    // Actualizar estado de bloqueo del formulario seg?n el total del d?a
    try { updateTradeFormBlockUI(formatDateKey(date)); } catch (e) {}
    if (modal) {
        modal.classList.add('show');
        modal.style.display = 'flex';
        modal.setAttribute('aria-hidden', 'false');
        try {
            document.body.style.overflow = 'hidden';
        } catch (e) {}
        const scrollArea = modal.querySelector('.overflow-y-auto');
        if (scrollArea) {
            scrollArea.scrollTop = 0;
        }
    }
}
// Tab switching helper for day modal
function switchDayModalTab(tab) {
    try {
        const tradesPanel = document.getElementById('tradesPanel');
        const notesPanel = document.getElementById('notesPanel');
        const tabs = document.querySelectorAll('#dayModal .modal-tabs .tab');

        tabs.forEach(t => t.classList.toggle('active', t.dataset.tab === tab));
        if (tradesPanel) tradesPanel.classList.toggle('hidden', tab !== 'trades');
        if (notesPanel) notesPanel.classList.toggle('hidden', tab !== 'notes');
    } catch (e) { console_warn('switchDayModalTab error', e); }
}

// Save daily note for arbitrary selected date
async function saveDailyNote(dateKey, sentiment, noteText, dayOutcome) {
    try {
        const userId = currentUserId || sessionStorage.getItem('currentUserId') || localStorage.getItem('currentUserId');
        if (!userId) throw new Error('No user');
        if (!currentAccount) {
            // No mostrar alert aqu�, dejar que el llamador lo maneje
            throw new Error('Selecciona una cuenta primero');
        }
        const turso = window.tursoClient;
        if (!turso) throw new Error('No tursoClient');

        const now = new Date().toISOString();
        // Try update then insert with day_outcome
        await turso.execute({ sql: 'UPDATE daily_notes SET sentiment = ?, note = ?, day_outcome = ?, updated_at = ? WHERE user_id = ? AND account_id = ? AND date = ?', args: [sentiment, noteText, dayOutcome, now, userId, currentAccount, dateKey] });
        const id = Date.now() + Math.random().toString(36).substr(2,9);
        await turso.execute({ sql: 'INSERT OR IGNORE INTO daily_notes (id, user_id, account_id, date, sentiment, note, day_outcome, created_at, updated_at) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?)', args: [id, userId, currentAccount, dateKey, sentiment, noteText, dayOutcome, now, now] });

        // store day outcome in in-memory map for UI
        window.__dailyNotesMap = window.__dailyNotesMap || {};
        window.__dailyNotesMap[dateKey] = Object.assign({}, window.__dailyNotesMap[dateKey] || {}, { sentiment: sentiment, note: noteText, day_outcome: dayOutcome });

        // refresh display to show flags
        try { updateDisplay(); } catch (e) {}
        return true;
    } catch (e) {
        // Solo loggear errores que NO sean "no hay cuenta" (esos se manejan en el llamador)
        if (!e.message.includes('Selecciona una cuenta')) {
            console_error('saveDailyNote error', e);
            showAlert('Error al Guardar', 'No se pudo guardar la nota: ' + (e.message || ''), 'error');
        }
        return false;
    }
}

// exposed helpers used by journal.html buttons
window.switchDayModalTab = switchDayModalTab;
window.saveDailyNote = saveDailyNote;

// UI handlers for notes panel
window.saveNotesForSelectedDay = async function() {
    // ?? VALIDAR CUENTA PRIMERO
    if (!currentAccount) {
        window.closeModal?.();
        showAlert('Cuenta Requerida', 'Necesitas crear una cuenta primero para anadir notas', 'warning');
        setTimeout(() => showFirstAccountModal(), 300);
        return;
    }
    
    const dateKey = formatDateKey(selectedDate || new Date());
    const sentiment = document.getElementById('notesSentiment')?.value || '';
    const outcome = document.getElementById('notesOutcome')?.value || '';
    const rawText = document.getElementById('notesTextarea')?.value || '';
    const text = rawText.trim();

    if (text.length < 3) {
        showAlert('Observación inválida', 'La nota debe tener al menos 3 caracteres', 'error');
        return;
    }

    const noteRegex = /^[a-zA-Z0-9\sÀ-ÿ]+$/;
    if (!noteRegex.test(text)) {
        showAlert('Observación inválida', 'La nota solo puede contener letras, números y espacios', 'error');
        return;
    }
    
    try {
        await saveDailyNote(dateKey, sentiment, text, outcome);
        
        // ?? Recargar la lista de trades para mostrar la nota card
        loadDayTrades(selectedDate);
        
        // ?? Mostrar mensaje visual
        showAlert('Nota Guardada', 'Nota guardada y actualizada', 'success');
        
    } catch (error) {
        console_error('Error guardando nota:', error);
        showAlert('Error', 'Error al guardar la nota', 'error');
    }
}

window.deleteNotesForSelectedDay = async function() {
    try {
        let dateKey;
        // Manejar selectedDate que puede ser un Date o un string
        if (typeof selectedDate === 'string') {
            dateKey = selectedDate;
        } else {
            dateKey = formatDateKey(selectedDate || new Date());
        }
        
        const userId = currentUserId || sessionStorage.getItem('currentUserId') || localStorage.getItem('currentUserId');
        if (!userId) throw new Error('No user');
        if (!currentAccount) throw new Error('Selecciona una cuenta primero');
        const turso = window.tursoClient;
        if (!turso) throw new Error('No turso');

        await turso.execute({ sql: 'DELETE FROM daily_notes WHERE user_id = ? AND account_id = ? AND date = ?', args: [userId, currentAccount, dateKey] });
        if (window.__dailyNotesMap) delete window.__dailyNotesMap[dateKey];
        document.getElementById('notesSentiment').value = '';
        document.getElementById('notesOutcome').value = '';
        document.getElementById('notesTextarea').value = '';
        window.showNotification('Nota eliminada correctamente', 'success', 3000);
        try { updateDisplay(); } catch(e){}
    } catch (e) {
        console_error('deleteNotesForSelectedDay', e);
        window.showAlert('Error al Eliminar', 'No se pudo eliminar la nota: ' + (e.message || ''), 'error');
    }
}
// Expose for inline handlers and other non-module pages (e.g., journal.html)
window.openDayModal = openDayModal;
window.deleteTradeFromDB = deleteTradeFromDB;

// ?? Funci?n para abrir modal desde el calendario usando string de fecha
window.openDayForDate = function(dateStr) {
    // Convertir string YYYY-MM-DD a objeto Date
    const [year, month, day] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day); // month - 1 porque Date usa 0-11
    openDayModal(date);
};

function loadDayTrades(date) {
    const tradesList = document.getElementById('tradesList');
    let dayTrades = journalData[formatDateKey(date)] || [];
    
    // ?? FILTRAR FIN DE SEMANA si est? desactivado
    if (!showWeekendTrades) {
        const dayOfWeek = new Date(date).getDay();
        if (dayOfWeek === 0 || dayOfWeek === 6) {
            // Domingo (0) o S?bado (6)
            tradesList.innerHTML = `<div class="no-trades" style="background: #1a2332; padding: 20px; border-radius: 6px; color: #999; text-align: center;">
                ?? No se muestran trades de fin de semana<br>
                <small style="margin-top: 8px; display: block;">Activa el toggle para incluirlos</small>
            </div>`;
            return;
        }
    }
    
    // Load mission-control saved note for this date (server-backed cache)
    const mcMap = (window.__dailyNotesMap) || {};
    const serverNote = mcMap[formatDateKey(date)] || null;
    
    // ?? Crear HTML de nota card destacada SI EXISTE Y TIENE CONTENIDO
    let mcNoteHtml = '';
    if (serverNote && serverNote.note && serverNote.note.trim()) {
        const sentimentEmojiMap = {
            cabreado: '??',
            estresado: '??',
            tranquilo: '??',
            emocionado: '??',
            con_sueno: '??',
            otro: '??'
        };
        const sentimentIcon = sentimentEmojiMap[serverNote.sentiment] || '';
        const outcomeClass = serverNote.day_outcome || serverNote.outcome || '';
        const outcomeLabel = {
            ganador: '?? Ganador',
            perdedor: '?? Perdedor',
            break_even: '?? Break Even',
            neutral: '? Sin cambios'
        }[outcomeClass] || '';
        
        mcNoteHtml = `
            <div class="notes-card-container">
                <div class="notes-card">
                    <div class="notes-card-header">
                        <div class="notes-card-date">?? ${formatDateKey(date)}</div>
                        <div class="notes-card-sentiment">${sentimentIcon}</div>
                        ${outcomeLabel ? `<div class="notes-card-outcome ${outcomeClass}">${outcomeLabel}</div>` : ''}
                    </div>
                    <div class="notes-card-text">${escapeHtml(serverNote.note || '')}</div>
                </div>
            </div>
        `;
    }

    if (dayTrades.length === 0) {
        // Si no hay trades, mostrar mensaje pero NO mostrar contenedor de notas vac?o
        tradesList.innerHTML = `<div class="no-trades">No hay trades registrados para este d?a</div>${mcNoteHtml}`;
        return;
    }
    
    // ?? Usar initial_balance para c?lculos de %
    const initialBalance = accounts[currentAccount]?.initial_balance || accounts[currentAccount]?.balance || 10000;
    
    // ?? Solo agregar notas si existen
    tradesList.innerHTML = mcNoteHtml + dayTrades.map(trade => {
        // ?? Calcular % din?micamente desde profitUSD
        const resultPercent = calculatePercent(trade.profitUSD || 0, initialBalance);
        
        return `
        <div class="trade-card ${trade.profitUSD > 0 ? 'win' : trade.profitUSD < 0 ? 'loss' : 'breakeven'}">
            <div class="trade-header">
                <span class="trade-pair">${trade.pair}</span>
                <span class="trade-direction ${trade.direction.toLowerCase()}">${trade.direction}</span>
                <button class="delete-btn" onclick="deleteTrade('${trade.id}')">Eliminar</button>
            </div>
            
            ${trade.entryTime || trade.exitTime ? `
                <div class="trade-times">
                    ${trade.entryTime ? `<span>?? Entrada: ${trade.entryTime}</span>` : ''}
                    ${trade.exitTime ? `<span>?? Salida: ${trade.exitTime}</span>` : ''}
                </div>
            ` : ''}
            
            <div class="trade-details">
                <div class="trade-detail">
                    <div class="trade-detail-label">Profit USD:</div>
                    <div class="trade-detail-value ${trade.profitUSD > 0 ? 'positive' : trade.profitUSD < 0 ? 'negative' : 'neutral'}">
                        ${trade.profitUSD > 0 ? '+' : ''}${(trade.profitUSD || 0).toFixed(2)} USD
                    </div>
                </div>
                <div class="trade-detail">
                    <div class="trade-detail-label">Resultado %:</div>
                    <div class="trade-detail-value ${resultPercent > 0 ? 'positive' : resultPercent < 0 ? 'negative' : 'neutral'}">
                        ${resultPercent > 0 ? '+' : ''}${resultPercent.toFixed(2)}%
                    </div>
                </div>
                ${trade.lotSize ? `
                    <div class="trade-detail">
                        <div class="trade-detail-label">Lotes:</div>
                        <div class="trade-detail-value">${trade.lotSize}</div>
                    </div>
                ` : ''}
            </div>
            
            ${trade.ticket ? `
                <div style="font-size: 11px; color: #90a4ae; margin-top: 8px;">
                    ?? Ticket: ${trade.ticket} ${trade.importSource ? '? Importado' : ''}
                </div>
            ` : ''}
            
            ${trade.comment ? `<div class="trade-comment">"${trade.comment}"</div>` : ''}
            
            ${isTradingViewUrl(trade.tradingViewUrl) ? `
                <div class="trade-url">
                    <a href="${trade.tradingViewUrl}" target="_blank" rel="noopener noreferrer">?? Ver captura</a>
                </div>
            ` : ''}
        </div>
    `}).join('');
}
window.closeModal = function() {
    const dayModal = document.getElementById('dayModal');
    if (dayModal) {
        dayModal.classList.remove('show');
        try { dayModal.style.display = 'none'; } catch (e) {}
        dayModal.setAttribute('aria-hidden', 'true');
    }
    try { document.body.style.overflow = ''; } catch (e) {}
    const tradeForm = document.getElementById('tradeForm');
    if (tradeForm) tradeForm.reset();
}

// ============================================
// USER INFO
// ============================================
// NOTE: showUserInfo / closeUserInfoModal / logoutUser are provided by the central
// config module and attached to window there. This file intentionally does not
// override them so the behavior is consistent across pages.

// ============================================
// EXPORTACI?N
// ============================================
window.exportData = async function() {
    try {
        await saveCurrentAccountData();
        const allTrades = await loadTradesFromDB(currentAccount);
        
        const dataToExport = {
            account: accounts[currentAccount],
            trades: allTrades,
            exportDate: new Date().toISOString(),
            version: '3.2-csv-fixed'
        };
        
        const dataStr = JSON.stringify(dataToExport, null, 2);
        const dataBlob = new Blob([dataStr], {type: 'application/json'});
        
        const link = document.createElement('a');
        link.href = URL.createObjectURL(dataBlob);
        link.download = `trading_journal_${accounts[currentAccount].name}_${new Date().toISOString().split('T')[0]}.json`;
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        showAlert('Exportacion Exitosa', 'Datos exportados correctamente', 'success');
    } catch (error) {
        console_error('Export error:', error);
        showAlert('Error de Exportacion', 'Error al exportar los datos', 'error');
    }
}

// ============================================
// ADMIN PANEL
// ============================================
// Admin panel is provided centrally (see `js/config.js`).
// This file intentionally does not implement its own admin UI to avoid
// overriding the central implementation.

// ============================================
// EVENT LISTENERS
// ============================================
// EVENT DELEGATION PARA FORMULARIO DE CUENTAS
// ============================================
// Usar event delegation para que funcione incluso si el formulario se recrea

document.addEventListener('submit', async function(e) {
    // Solo procesar si es el formulario de crear cuenta
    if (e.target.id !== 'accountForm') return;
    
    e.preventDefault();
    
    // ?? SOLUCI?N: Usar querySelector en el formulario, no en document
    // Esto asegura que accedamos a los elementos DENTRO del formulario que se env?a
    const nameEl = e.target.querySelector('#accountName');
    const balanceEl = e.target.querySelector('#accountBalance');
    
    if (!nameEl || !balanceEl) {

        showAlert('Error del Sistema', 'Elementos del formulario no estan disponibles', 'error');
        return;
    }
    
    const rawName = (nameEl.value || '').trim();
    const name = rawName.slice(0, 20);
    

    
    const balanceInput = (balanceEl.value || '').trim();
    const balance = balanceInput === '' ? NaN : parseFloat(balanceInput);

    // Validaciones mejoradas
    if (!name || name.length === 0) {

        showAlert('Campo Requerido', 'El nombre de la cuenta no puede estar vacio', 'error');
        return;
    }

    if (name.length < 3) {
        showAlert('Nombre Invalido', 'El nombre debe tener al menos 3 caracteres', 'error');
        return;
    }
    
    // Validar caracteres permitidos (solo letras, números, espacios y acentos)
    const nameRegex = /^[a-zA-Z0-9\sÀ-ÿ]+$/;
    if (!nameRegex.test(name)) {

        showAlert('Nombre Invalido', 'El nombre solo puede contener letras, números y espacios', 'error');
        return;
    }
    
    if (isNaN(balance)) {
        showAlert('Balance Invalido', 'Debes ingresar un balance valido (numero)', 'error');
        return;
    }
    
    if (balance < 0) {
        showAlert('Balance Invalido', 'El balance no puede ser negativo', 'error');
        return;
    }
    
    if (balance > 1e6) {
        showAlert('Balance Invalido', 'El balance no puede superar $1,000,000', 'error');
        return;
    }
    
    // IMPORTANTE: Validar plan del usuario ANTES de intentar crear
    
    if (!currentUserId) {
        console_error('No hay sesión activa');
        showAlert('Error de Sesión', 'No hay sesión activa. Por favor, inicia sesión de nuevo', 'error');
        return;
    }
    
    try {
        const { validateAccountCreation } = await import('./config.js');
        const validation = await validateAccountCreation(currentUserId);
        
        if (!validation.canCreate) {
            showAlert(
                validation.title || 'Limite Alcanzado',
                validation.message,
                'warning'
            );
            if (window.NotificationCenter && typeof window.NotificationCenter.add === 'function') {
                try {
                    window.NotificationCenter.add({
                        type: 'warning',
                        title: validation.title || 'Límite de cuentas alcanzado',
                        message: validation.message || 'Has alcanzado el límite de cuentas de tu plan.'
                    });
                } catch (e) {}
            }
            return;
        }
    } catch (error) {
        console_error('Account limit validation error:', error);
        showAlert('Error de Validacion', 'Error al validar el limite de cuentas: ' + error.message, 'error');
        return;
    }
    
    // ? Todas las validaciones pasaron, crear la cuenta
    
    try {
        await saveCurrentAccountData();
        
        const newAccountId = generateId();
        accounts[newAccountId] = {
            id: newAccountId,
            name: name,
            balance: balance,
            initial_balance: balance,
            status: 'active',
            data: {}
        };
        
        await saveAccountToDB(accounts[newAccountId]);
        
        currentAccount = newAccountId;
        journalData = {};
        
        updateAccountSelector();
        updateDisplay();
        
        // Actualizar tambi�n el dropdown de calendar-demo.js si existe
        if (typeof window.populateAccountsFromAppJs === 'function') {
            window.populateAccountsFromAppJs();
        }
        
        // Cerrar modal (funciona en ambas p?ginas)
        if (window.closeAccountModal) {
            window.closeAccountModal();
        }
        
        showAlert('Cuenta Creada', `La cuenta "${name}" ha sido creada exitosamente`, 'success');
        setTimeout(() => {
            try {
                window.location.reload();
            } catch (e) {}
        }, 800);
        
    } catch (error) {
        console_error('? Error creando cuenta:', error);
        showAlert('Error al Crear Cuenta', window.getSafeErrorMessage(error), 'error');
    }
});

// ============================================
// ?? HELPER - Contar Trades del Mes
// ============================================
function countMonthlyTrades(accountId, dateRef = null) {
    const base = dateRef instanceof Date ? dateRef : currentDate;
    const monthStart = new Date(base.getFullYear(), base.getMonth(), 1);
    const monthEnd = new Date(base.getFullYear(), base.getMonth() + 1, 0);
    let count = 0;
    
    for (let d = new Date(monthStart); d <= monthEnd; d.setDate(d.getDate() + 1)) {
        const dateKey = formatDateKey(d);
        const dayTrades = journalData[dateKey] || [];
        count += dayTrades.length;
    }
    
    return count;
}

async function getMonthlyTradeCount(accountId, monthKey) {
    if (!accountId || !monthKey) return 0;
    try {
        const fresh = await loadTradesFromDB(accountId);
        return Object.keys(fresh)
            .filter(dateKey => String(dateKey).startsWith(monthKey))
            .reduce((sum, key) => sum + (fresh[key]?.length || 0), 0);
    } catch (e) {
        try {
            if (window.tursoClient) {
                const result = await tursoClient.execute({
                    sql: "SELECT COUNT(*) as count FROM trades WHERE account_id = ? AND substr(REPLACE(REPLACE(date, '.', '-'), '/', '-'), 1, 7) = ?",
                    args: [accountId, monthKey]
                });
                return parseInt(result.rows[0]?.count || 0, 10);
            }
        } catch (_) {}
        return 0;
    }
}

// Exponer helper para calendar-demo.js
window.getMonthlyTradeCount = getMonthlyTradeCount;

// ============================================
// ?? FORMULARIO MANUAL - EVENT LISTENER
// ============================================
const tradeForm = document.getElementById('tradeForm');
if (tradeForm) {
    document.getElementById('tradeForm').addEventListener('submit', async function(e) {
        e.preventDefault();
        
        // ?? Verificar si hay cuenta creada
        if (!currentAccount) {
            window.closeModal();
            showAlert('Cuenta Requerida', 'Necesitas crear una cuenta primero para anadir trades', 'warning');
            setTimeout(() => showFirstAccountModal(), 300); // Delay para que se cierre el modal primero
            return;
        }
        
        // ?? FIX 4: Verificar si la cuenta est? sincronizando
        if (currentAccount && accounts[currentAccount]) {
            const acct = accounts[currentAccount];
            if (acct.syncing) {
                showAlert('Cuenta Sincronizando', 'La cuenta esta sincronizando con el EA. Por favor espera a que termine para agregar trades manualmente.', 'warning');
                return;
            }
        }
        
        const rawPair = document.getElementById('pair').value;
        const pair = sanitizeString(rawPair, 20).toUpperCase().replace(/\s+/g, '');
        const direction = document.getElementById('direction').value;
        const lotSizeRaw = document.getElementById('lotSize').value;
        const lotSize = lotSizeRaw ? parseFloat(lotSizeRaw) : null;
        const profitUSDRaw = document.getElementById('profitUSD').value;
        const profitUSD = profitUSDRaw === '' ? NaN : parseFloat(profitUSDRaw);
        // Comentario: sanitizar y limitar a 300 caracteres (solo letras/números/espacios)
        const rawComment = sanitizeString(document.getElementById('comment').value, 300);
        const comment = rawComment.trim();

        // Bloqueo adicional: evitar payloads que intenten inyectar SQL o scripts
        function containsSqlOrScript(s) {
            if (!s) return false;
            try {
                const t = String(s).toLowerCase();
                // Patterns indicating SQL statements or script tags
                const patterns = [
                    "<script",
                    "</script>",
                    "select ",
                    "insert ",
                    "update ",
                    "delete ",
                    "drop ",
                    "truncate ",
                    "--",
                    ";--",
                    "/*",
                    "*/",
                    "exec(",
                    "exec ",
                    "xp_",
                    "union ",
                    " or 1=1"
                ];

                return patterns.some(p => t.indexOf(p) !== -1);
            } catch (e) {
                return false;
            }
        }
        const entryTime = document.getElementById('entryTime').value;
        const exitTime = document.getElementById('exitTime').value;
        const tradingViewUrlRaw = document.getElementById('tradingViewUrl').value.trim();
        const tradingViewUrl = tradingViewUrlRaw && isTradingViewUrl(tradingViewUrlRaw) ? tradingViewUrlRaw : '';

        // Validaciones b?sicas y protecci?n contra valores no finitos
        if (!pair || !direction || !isFiniteNumber(profitUSD)) {
            showAlert('Campos Incompletos', 'Por favor completa los campos obligatorios: Par, Direccion y Resultado (valor numerico valido)', 'error');
            return;
        }

        // Par: solo letras (ej. EURUSD), longitud 3-12
        // Permitir letras, n?meros y separadores comunes: '/', '-' y '.'
        if (!/^[A-Z0-9.\/\-]{3,20}$/.test(pair)) {
            showAlert('Par inv?lido. Usa letras/n?meros y opcionalmente /, - o . (ej: EUR/USD, BTC-USD). Longitud 3-20.', 'error');
            return;
        }

        // Validar lotSize si est? presente: positivo, no excesivo, m?ximo 2 decimales
        if (lotSize !== null) {
            if (!isFiniteNumber(lotSize) || lotSize <= 0 || lotSize > 10000) {
                showAlert('Volumen Invalido', 'Volumen (lotes) invalido', 'error');
                return;
            }
            const lotDecimals = (String(lotSize).split('.')[1] || '').length;
            if (lotDecimals > 2) {
                showAlert('Volumen Invalido', 'Volumen: maximo 2 decimales', 'error');
                return;
            }
        }

        // ProfitUSD: l?mites y m?ximo 2 decimales
        if (!isFiniteNumber(profitUSD) || Math.abs(profitUSD) > 1e8) {
            showAlert('Resultado Invalido', 'Resultado (USD) invalido o fuera de rango', 'error');
            return;
        }
        // ?? CR?TICO: Redondear a 2 decimales para evitar problemas de precisi?n flotante
        const profitRounded = Math.round(profitUSD * 100) / 100;
        const profitDecimals = (String(profitRounded).split('.')[1] || '').length;
        if (profitDecimals > 2) {
            showAlert('Resultado Invalido', 'Resultado: maximo 2 decimales', 'error');
            return;
        }

        if (entryTime && exitTime && entryTime >= exitTime) {
            showAlert('Hora Invalida', 'La hora de salida debe ser posterior a la de entrada', 'error');
            return;
        }

        // Validación de comentario (si existe)
        if (comment) {
            if (comment.length < 3) {
                showAlert('Comentario Invalido', 'El comentario debe tener al menos 3 caracteres', 'error');
                return;
            }

            const commentRegex = /^[a-zA-Z0-9\sÀ-ÿ]+$/;
            if (!commentRegex.test(comment)) {
                showAlert('Comentario Invalido', 'El comentario solo puede contener letras, números y espacios', 'error');
                return;
            }
        }

        // Rechazar comentarios que contengan código/script/SQL
        if (containsSqlOrScript(comment)) {
            showAlert('Comentario Invalido', 'Se han detectado fragmentos de codigo o sentencias SQL. Por favor, escribe texto plano (max. 300 caracteres).', 'error');
            return;
        }

        // ?? VERIFICAR L?MITE MENSUAL DE TRADES PARA PLAN FREE
        const userPlan = localStorage.getItem('userPlan') || 'free';
        if (userPlan === 'free') {
            const maxTradesPerMonth = 20;
            const dateForLimit = (selectedDate instanceof Date) ? selectedDate : currentDate;
            const monthKey = `${dateForLimit.getFullYear()}-${String(dateForLimit.getMonth() + 1).padStart(2, '0')}`;
            const monthlyTradeCount = await getMonthlyTradeCount(currentAccount, monthKey);
            
            if (monthlyTradeCount >= maxTradesPerMonth) {
                showAlert(
                    'Limite de Trades Alcanzado',
                    `Has registrado ${monthlyTradeCount}/${maxTradesPerMonth} trades este mes. El plan FREE permite 20 trades/mes. Actualiza tu plan para trades ilimitados.`,
                    'warning'
                );
                return;
            }
        }
        
        const dateKey = formatDateKey(selectedDate);

        // ?? VALIDACI?N DE L?MITE DIARIO DESACTIVADA
        // Permite operar con alto riesgo sin restricciones de ?10000% del balance
        
        const initialBalance = accounts[currentAccount]?.initial_balance || accounts[currentAccount]?.balance || 10000;
        const dayProfit = calculateDayProfitUSD(dateKey);
        const newTotalProfit = dayProfit + profitRounded;
        const newTotalPct = calculatePercent(newTotalProfit, initialBalance);

        if (newTotalPct > 10000 || newTotalPct < -10000) {
            updateTradeFormBlockUI(dateKey);
            showAlert('Operacion Bloqueada', 'El total del dia excede el limite permitido (100% del balance). Revisa tus entradas.', 'error');
            return;
        }
        

        const trade = {
            id: generateId(),
            pair: pair,
            symbol: pair,
            direction: direction,
            lotSize: lotSize,
            profitUSD: profitRounded,  // ? Usar valor redondeado
            comment: comment,
            entryTime: entryTime,
            exitTime: exitTime,
            tradingViewUrl: tradingViewUrl,
            timestamp: new Date().toISOString(),
            importSource: 'manual'
        };

        const success = await saveTradeToDB(currentAccount, dateKey, trade);
        
        if (!success) {
            showAlert('Error al Guardar', 'Error al guardar el trade', 'error');
            return;
        }
        
        // Si el trade es de un mes distinto, mover la vista al mes del trade
        if (selectedDate instanceof Date) {
            window.currentDate = new Date(selectedDate);
        }

        // ?? Recargar desde BD (calcular? result autom?ticamente)
        journalData = await loadTradesFromDB(currentAccount, window.currentDate);
        // ?? Exponer datos globalmente para recap-card.js
        window.journalData = journalData;
        window.accounts = accounts;  // Asegurar que accounts est? actualizado

        // ?? Recalcular profit total (all-time)
        await refreshAccountTotalProfit(currentAccount);
        
        // ?? BALANCE STATE MANAGER: Actualizar despu�s de a�adir trade
        if (window.balanceStateManager) {
            const allTrades = Object.values(journalData).flat();
            window.balanceStateManager.loadTrades(currentAccount, allTrades);
            
            // ?? Actualizar �ltimas operaciones si est� disponible
            if (typeof window.updateLatestTrades === 'function') {
                setTimeout(() => window.updateLatestTrades(), 100);
            }
        }
        
        // ?? Invalidar cach? del recap para forzar rec?lculo
        if (typeof invalidateRecapCache === 'function') {
            invalidateRecapCache();
        }
        
        // 🆕 Actualizar panel de Trade Control si está activo
        if (window.tradeControlUI && window.tradeControlUI.sessionPanel) {
            try {
                await window.tradeControlUI.updateSessionPanel();
            } catch (e) {
            }
        }
        
        // ? BALANCE STATE MANAGER: Actualizar despu�s de a�adir
        if (window.balanceStateManager) {
            const allTrades = Object.values(journalData).flat();
            window.balanceStateManager.loadTrades(currentAccount, allTrades);
            
            // ? Actualizar �ltimas operaciones si est� disponible
            if (typeof window.updateLatestTrades === 'function') {
                setTimeout(() => window.updateLatestTrades(), 100);
            }
        }
        
        loadDayTrades(selectedDate);
        updateDisplay();
        
        // ?? Actualizar m�tricas de calendar-demo despu�s de agregar trade
        if (typeof window.updateRealTimeMetrics === 'function') {
            window.updateRealTimeMetrics(window.currentDate);
        }
        
        window.closeModal();
        
        // ?? Refrescar tarjetas de performance
        if (typeof window.renderPerformanceCardsNew === 'function') {
            window.renderPerformanceCardsNew();
        }
        
        showAlert('Trade Agregado', 'Trade agregado correctamente', 'success');
    });
}

window.addEventListener('click', function(event) {
    const dayModal = document.getElementById('dayModal');
    const accountModal = document.getElementById('accountModal');
    const userInfoModal = document.getElementById('userInfoModal');
    const importModal = document.getElementById('importModal');
    
    if (event.target === dayModal) window.closeModal();
    if (event.target === accountModal) window.closeAccountModal();
    if (event.target === userInfoModal) window.closeUserInfoModal();
    if (event.target === importModal) window.closeImportModal();
});

window.addEventListener('beforeunload', async function() {
    await saveCurrentAccountData();
});


// ============================================
// ?? APLICAR RESTRICCIONES DE LAYOUT POR PLAN
// ============================================
function applyPlanLayoutRestrictions() {
    const userPlan = localStorage.getItem('userPlan') || 'free';
    const userType = localStorage.getItem('userType') || 'user';
    
    // Admin siempre ve todo
    if (userType === 'admin') return;
    
    const dashboardLayout = document.querySelector('.dashboard-layout');
    const metricsSidebar = document.querySelector('.metrics-sidebar');
    
    if (userPlan === 'free') {
        // Plan Free: ocultar sidebar y ajustar layout
        if (dashboardLayout) dashboardLayout.classList.add('free-plan');
        if (metricsSidebar) metricsSidebar.classList.add('hidden-free');
        // ?? Ocultar pesta?a de sincronizaci?n autom?tica
        const syncTabBtn = document.getElementById('syncTabBtn');
        if (syncTabBtn) syncTabBtn.style.display = 'none';

    } else {
        // Pro/Unlimited: mostrar todo
        if (dashboardLayout) dashboardLayout.classList.remove('free-plan');
        if (metricsSidebar) metricsSidebar.classList.remove('hidden-free');
    }
}

// ============================================
// ?? VERIFICAR L?MITE DE TRADES EN PLAN FREE
// ============================================
function checkFreeTradeLimit(monthlyTradeCount) {
    const userPlan = localStorage.getItem('userPlan') || 'free';
    
    // Solo aplica a plan Free
    if (userPlan !== 'free') return;
    
    // L?mite de 20 trades mensuales en Free
    const TRADE_LIMIT = 20;
    
    if (monthlyTradeCount >= TRADE_LIMIT) {
        // Verificar si ya se mostr? la notificaci?n en esta sesi?n
        const notificationKey = 'freeTradeWarningShown_' + new Date().toISOString().split('T')[0]; // Por d?a
        
        if (!sessionStorage.getItem(notificationKey)) {
            // Mostrar notificaci?n solo una vez
            sessionStorage.setItem(notificationKey, 'true');
            
            showAlert(
                `Límite de ${TRADE_LIMIT} trades alcanzado`,
                `Has alcanzado el límite de ${TRADE_LIMIT} trades mensuales en plan Free. Actualiza tu plan a Pro o Unlimited para seguir operando sin restricciones.`,
                'warning'
            );

            if (window.NotificationCenter && typeof window.NotificationCenter.add === 'function') {
                try {
                    window.NotificationCenter.add({
                        type: 'warning',
                        title: `Límite de ${TRADE_LIMIT} trades alcanzado`,
                        message: `Has alcanzado el límite de ${TRADE_LIMIT} trades mensuales en plan Free. Actualiza tu plan a Pro o Unlimited para seguir operando sin restricciones.`
                    });
                } catch (e) {}
            }
        }
    }
}

function calculatePercent(profitUSD, balance) {
    if (!balance || balance <= 0) return 0;
    return (profitUSD / balance) * 100;
}

// Utilidades de validaci?n y bloqueo de d?a
function isFiniteNumber(v) {
    return typeof v === 'number' && isFinite(v);
}

function sanitizeString(str, maxLen = 500) {
    if (!str && str !== 0) return '';
    try {
        const s = String(str).replace(/<[^>]*>/g, ''); // quitar etiquetas HTML b?sicas
        return s.slice(0, maxLen);
    } catch (e) {
        return '';
    }
}

function isSafeUrl(url) {
    if (!url) return false;
    try {
        const u = new URL(url);
        return (u.protocol === 'http:' || u.protocol === 'https:');
    } catch (e) {
        return false;
    }
}

function isTradingViewUrl(url) {
    if (!url) return false;
    try {
        const u = new URL(url);
        const host = (u.hostname || '').toLowerCase();
        return (u.protocol === 'http:' || u.protocol === 'https:') && (host === 'tradingview.com' || host.endsWith('.tradingview.com'));
    } catch (e) {
        return false;
    }
}

function calculateDayProfitUSD(dateKey) {
    const dayTrades = journalData[dateKey] || [];
    return dayTrades.reduce((s, t) => s + Number(t.profitUSD || 0), 0);
}

function isDayBlocked(dateKey) {
    // ?? Usar initial_balance para c?lculos
    const initialBalance = accounts[currentAccount]?.initial_balance || accounts[currentAccount]?.balance || 10000;
    const dayProfit = calculateDayProfitUSD(dateKey);
    const pct = calculatePercent(dayProfit, initialBalance);
    return pct > 100 || pct < -100;
}

function updateTradeFormBlockUI(dateKey) {
    const tradeForm = document.getElementById('tradeForm');
    if (!tradeForm) return;
    const infoBtn = document.getElementById('tradeFormInfoBtn');
    const submitBtn = tradeForm.querySelector('button[type="submit"]');

    const blocked = isDayBlocked(dateKey);

    // only disable form inputs (keep modal close buttons enabled)
    const inputs = tradeForm.querySelectorAll('input, textarea, select');
    inputs.forEach(el => {
        // Allow disabling the file input only when needed
        el.disabled = blocked;
    });

    if (submitBtn) submitBtn.disabled = blocked;

    if (infoBtn) {
        if (blocked) {
            infoBtn.classList.remove('hidden');
            infoBtn.onclick = function() {
                // ?? Usar initial_balance para c?lculos
                const initialBalance = accounts[currentAccount]?.initial_balance || accounts[currentAccount]?.balance || 10000;
                const dayProfit = calculateDayProfitUSD(dateKey);
                const pct = calculatePercent(dayProfit, initialBalance);
                showAlert(
                    `Bloqueo: El total del d?a es ${dayProfit >= 0 ? '+' : ''}$${dayProfit.toFixed(2)} (${pct > 0 ? '+' : ''}${pct.toFixed(2)}%).\nNo se permiten m?s trades en este d?a.`,
                    'warning'
                );
            };
        } else {
            infoBtn.classList.add('hidden');
            infoBtn.onclick = null;
        }
    }
}


// Funciones globales
window.changeAccount = changeAccount;
window.editAccountName = editAccountName;
window.toggleAccountStatus = toggleAccountStatus;  // Usado en accounts.html para cambiar estado

// Exponer utilidades ligeras para otros scripts no-modulares
window.isSafeUrl = isSafeUrl;
window.sanitizeString = sanitizeString;
window.isFiniteNumber = isFiniteNumber;
window.calculateDayProfitUSD = calculateDayProfitUSD;
window.updateTradeFormBlockUI = updateTradeFormBlockUI;
window.isTradingViewUrl = isTradingViewUrl;

// Navegaci?n desde Journal a Ajustes de Cuenta
function openAccountSettingsFromJournal() {
    if (!currentAccount) return;
    try {
        localStorage.setItem('openSettingsForAccount', currentAccount);
    } catch (e) {
        // ignore storage errors
    }
    window.location.href = '/accounts';
}

window.openAccountSettingsFromJournal = openAccountSettingsFromJournal;


// ============================================
// IMPORTACI?N CSV/HTML
// ============================================
window.showImportModal = function() {
    document.getElementById('importForm').reset();
    document.getElementById('importPreview').style.display = 'none';
    const importModal = document.getElementById('importModal');
    if (importModal) {
        importModal.classList.add('show');
        importModal.style.display = 'flex';
        importModal.setAttribute('aria-hidden', 'false');
    }
}

window.closeImportModal = function() {
    const importModal = document.getElementById('importModal');
    if (importModal) {
        importModal.classList.remove('show');
        try { importModal.style.display = 'none'; } catch (e) {}
        importModal.setAttribute('aria-hidden', 'true');
    }
}
const csvFile = document.getElementById('csvFile');
if(csvFile){
    document.getElementById('csvFile').addEventListener('change', function(e) {
        const file = e.target.files[0];
        if (!file) return;
        
        const preview = document.getElementById('importPreview');
        const previewText = document.getElementById('previewText');
        
        previewText.textContent = `Archivo seleccionado: ${file.name} (${(file.size / 1024).toFixed(2)} KB)`;
        preview.style.display = 'block';
    });
}

// ============================================
// ?? IMPORTACI?N CSV/HTML - ACTUALIZADO PARA USD
// ============================================
const importForm = document.getElementById('importForm');
if(importForm){
    document.getElementById('importForm').addEventListener('submit', async function(e) {
        e.preventDefault();

        if (window.demoGate && window.demoGate('import_trades', 'Importar Trades desde Archivo')) {
            return;
        }
        
        const fileInput = document.getElementById('csvFile');
        const file = fileInput.files[0];
        
        if (!file) {
            showAlert('Archivo Requerido', 'Por favor selecciona un archivo HTML de MetaTrader', 'error');
            return;
        }
        
        if (!currentAccount || !accounts[currentAccount]) {
            showAlert('Cuenta Requerida', 'No hay una cuenta activa', 'error');
            setTimeout(() => showFirstAccountModal(), 300); // Mostrar modal de bienvenida para crear cuenta
            return;
        }
        
        const button = document.getElementById('importButton');
        const originalContent = button.innerHTML;
        button.disabled = true;
        button.innerHTML = `
            <svg class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Importando...
        `;
        
        try {
            const sessionToken = sessionStorage.getItem('tfx_token') ||
                                sessionStorage.getItem('tfx_authToken') ||
                                sessionStorage.getItem('userToken') ||
                                localStorage.getItem('tfx_token') ||
                                localStorage.getItem('userToken');
            if (!sessionToken) {
                const err = new Error('Sesión expirada. Inicia sesión nuevamente.');
                err.safeMessage = 'Sesión expirada. Inicia sesión nuevamente.';
                throw err;
            }

            if (!window.tursoClient) {
                const err = new Error('No hay conexión con la base de datos.');
                err.safeMessage = 'No hay conexión con la base de datos. Intenta recargar la página.';
                throw err;
            }

            // RECARGAR TRADES DESDE BD PARA VALIDACI�N PRECISA
            journalData = await loadTradesFromDB(currentAccount);
            window.journalData = journalData;
            
            const content = await file.text();
            
            const parseResult = parseMetaTraderFile(content, {
                logLevel: 'none',
                removeDuplicates: true
            });
            
            if (!parseResult.success) {
                const err = new Error(parseResult.errors[0]?.message || 'Error en el parseo');
                err.safeMessage = err.message;
                throw err;
            }
            
            let { trades, metadata } = parseResult;

            const normalizeTradeDate = (raw) => {
                if (!raw) return '';
                let v = String(raw).trim();
                if (v.includes('T') || v.includes(' ')) {
                    v = v.split(/[T ]/)[0];
                }
                if (/^\d{4}\.\d{2}\.\d{2}$/.test(v)) {
                    v = v.replace(/\./g, '-');
                }
                if (/^\d{4}\/\d{2}\/\d{2}$/.test(v)) {
                    v = v.replace(/\//g, '-');
                }
                if (/^\d{2}-\d{2}-\d{4}$/.test(v)) {
                    const [p1, p2, yyyy] = v.split('-');
                    const n1 = parseInt(p1, 10);
                    const n2 = parseInt(p2, 10);
                    let day = p1;
                    let month = p2;
                    if (!Number.isNaN(n1) && !Number.isNaN(n2)) {
                        if (n1 > 12 && n2 <= 12) {
                            day = p1;
                            month = p2;
                        } else if (n2 > 12 && n1 <= 12) {
                            day = p2;
                            month = p1;
                        } else {
                            day = p1;
                            month = p2;
                        }
                    }
                    v = `${yyyy}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
                }
                return v;
            };

            trades = trades.map(t => ({
                ...t,
                date: normalizeTradeDate(t.date)
            }));
            
            // CONTAR DUPLICADOS PRIMERO
            let duplicateCount = 0;
            for (const trade of trades) {
                const dateKey = trade.date;
                const existing = journalData[dateKey]?.find(t => t.ticket === trade.ticket);
                if (existing) {
                    duplicateCount++;
                }
            }
            
            // VALIDAR LIMITE DE TRADES PERMITIDOS PRIMERO
            const userPlan = localStorage.getItem('userPlan') || 'free';
            let maxTradesPerMonth = 20; // Plan FREE
            if (userPlan === 'pro') maxTradesPerMonth = Infinity;
            if (userPlan === 'unlimited') maxTradesPerMonth = Infinity;
            
            // OBTENER MESES UNICOS DE LOS TRADES A IMPORTAR
            const monthsToValidate = new Set(trades.map(t => String(t.date || '').slice(0, 7)).filter(Boolean)); // YYYY-MM
            
            // VALIDAR LIMITE PARA CADA MES
            for (const targetMonth of monthsToValidate) {
                let tradesInMonth = 0;
                try {
                    tradesInMonth = await getMonthlyTradeCount(currentAccount, targetMonth);
                } catch (error) {
                    console_error('Error contando trades del mes:', error);
                    tradesInMonth = 0;
                }
                
                // Contar trades NUEVOS (no duplicados) de este mes
                const tradesNewInMonth = trades
                    .filter(t => t.date.slice(0, 7) === targetMonth)
                    .filter(t => !journalData[t.date]?.find(existing => existing.ticket === t.ticket))
                    .length;
                
                // VALIDAR SOLO CONTRA LOS NUEVOS (duplicados se omiten autom�ticamente)
                const tradesAfterImportInMonth = parseInt(tradesInMonth, 10) + parseInt(tradesNewInMonth, 10);
                
                if (userPlan === 'free' && tradesAfterImportInMonth > maxTradesPerMonth) {
                    const remaining = Math.max(0, maxTradesPerMonth - tradesInMonth);
                    
                    button.disabled = false;
                    button.innerHTML = originalContent;
                    
                    // Cerrar modal antes del alert para evitar que quede debajo
                    closeImportModal();
                    
                    await showAlert('Limite Alcanzado',
                        `Mes: ${targetMonth}\nLimite: ${maxTradesPerMonth} trades/mes\nTienes: ${tradesInMonth} trades\nIntentas importar: ${tradesNewInMonth} nuevos\nDisponibles: ${remaining}\n\nNo se puede completar la importacion.`,
                        'warning');
                    return;
                }
            }
            
            // CONFIRMAR CUENTA ANTES DE IMPORTAR
            const initialBalance = accounts[currentAccount]?.initial_balance || accounts[currentAccount]?.balance;
            const currentBalanceRaw = accounts[currentAccount]?.balance ?? accounts[currentAccount]?.initial_balance ?? 0;
            const currentBalanceValue = Number(currentBalanceRaw);
            const currentBalance = Number.isFinite(currentBalanceValue) ? currentBalanceValue : 0;
            const detectedBalanceValue = Number(metadata?.detectedBalance);
            const detectedBalance = Number.isFinite(detectedBalanceValue) ? detectedBalanceValue : null;
            const totalProfitUSD = trades.reduce((sum, t) => sum + (Number(t.profitUSD) || 0), 0);
            
            // Cerrar modal de importaci�n ANTES de mostrar confirmaci�n
            closeImportModal();
            
            // Restaurar bot�n temporalmente
            button.disabled = false;
            button.innerHTML = originalContent;
            
            // MOSTRAR CONFIRMACION DE CUENTA CON showConfirm
            const confirmed = await showConfirm({
                title: 'Confirmar Importacion',
                message: `<div style="text-align: left; font-size: 14px; line-height: 1.6;">
                    <p><strong>Cuenta destino:</strong> ${accounts[currentAccount].name}</p>
                    <p><strong>Balance actual:</strong> $${currentBalance.toFixed(2)}</p>
                    <p><strong>Trades a importar:</strong> ${trades.length}</p>
                    <p><strong>P/L total:</strong> ${totalProfitUSD >= 0 ? '+' : ''}${totalProfitUSD.toFixed(2)} USD</p>
                    ${detectedBalance !== null ? `<p><strong>Balance en MetaTrader:</strong> $${detectedBalance.toFixed(2)}</p>` : ''}
                </div>`,
                confirmText: 'Importar',
                cancelText: 'Cancelar',
                type: 'info'
            });
            
            if (!confirmed) {
                return;
            }
            
            // Reactivar estado de importando
            button.disabled = true;
            button.innerHTML = `
                <svg class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Importando...
            `;
            
            // ADVERTENCIA ADICIONAL si el balance detectado difiere mucho
            if (detectedBalance && Math.abs(detectedBalance - currentBalance) > 100) {
                // Restaurar bot�n antes de mostrar advertencia
                button.disabled = false;
                button.innerHTML = originalContent;
                
                const continueAnyway = await showConfirm({
                    title: 'Advertencia de Balance',
                    message: `<div style="text-align: left;">
                        <p>El balance en MetaTrader (<strong>$${detectedBalance.toFixed(2)}</strong>) difiere del balance actual (<strong>$${currentBalance.toFixed(2)}</strong>).</p>
                        <p>Continuar de todos modos?</p>
                    </div>`,
                    confirmText: 'Continuar',
                    cancelText: 'Cancelar',
                    type: 'warning'
                });
                
                if (!continueAnyway) {
                    return;
                }
                
                // Reactivar estado de importando despu�s de confirmar
                button.disabled = true;
                button.innerHTML = `
                    <svg class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Importando...
                `;
            }
            
            // IMPORTACION SECUENCIAL (Como en journal.html)
            let importedCount = 0;
            let skippedCount = 0;
            let failedCount = 0;
            
            for (const trade of trades) {
                const dateKey = trade.date;
                
                // Verificar duplicado
                const existing = journalData[dateKey]?.find(t => t.ticket === trade.ticket);
                if (existing) {
                    skippedCount++;
                    continue;
                }
                
                // Insertar en DB
                try {
                    const savedTrade = await saveTradeToDB(currentAccount, dateKey, trade);

                    if (!savedTrade) {
                        failedCount++;
                        continue;
                    }
                    
                    // Agregar a memoria
                    if (!journalData[dateKey]) journalData[dateKey] = [];
                    journalData[dateKey].push(savedTrade);
                    
                    importedCount++;
                    
                    // Actualizar contador cada 5 trades
                    if (importedCount % 5 === 0 || importedCount === trades.length - skippedCount) {
                        button.innerHTML = `
                            <svg class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Importando... ${importedCount}/${trades.length - skippedCount}
                        `;
                    }
                } catch (error) {
                    failedCount++;
                }
            }
            
            // Actualizar balance con trades importados
            const newBalance = currentBalance + totalProfitUSD;
            accounts[currentAccount].balance = newBalance;
            
            try {
                await tursoClient.execute({
                    sql: 'UPDATE accounts SET balance = ? WHERE id = ?',
                    args: [newBalance, currentAccount]
                });
            } catch (error) {

            }
            
            // Actualizar UI
            if (window.invalidateRecapCache) window.invalidateRecapCache();
            if (window.updateDisplay) window.updateDisplay();

            // Refrescar trades desde BD para evitar mostrar 0 temporalmente
            try {
                const refreshed = await loadTradesFromDB(currentAccount);
                journalData = refreshed;
                window.journalData = journalData;
                if (window.updateDisplay) window.updateDisplay();
                await refreshAccountTotalProfit(currentAccount);
                try {
                    if (typeof loadDayTrades === 'function' && typeof selectedDate !== 'undefined') {
                        loadDayTrades(selectedDate);
                    }
                } catch (e) {}
                if (typeof window.updateRealTimeMetrics === 'function') {
                    window.updateRealTimeMetrics(window.currentDate);
                }
            } catch (error) {
                console_error('Error refrescando trades post-import:', error);
            }
            
            // Restaurar boton
            button.disabled = false;
            button.innerHTML = originalContent;
            
            // Modal ya se cerr� antes, no es necesario cerrarlo de nuevo
            
            // Mostrar resultado
            let message = `Importados: ${importedCount} trades`;
            if (skippedCount > 0) message += `\nOmitidos (duplicados): ${skippedCount}`;
            if (failedCount > 0) message += `\nFallidos: ${failedCount}`;
            if (totalProfitUSD !== 0) message += `\nP/L total: ${totalProfitUSD >= 0 ? '+' : ''}${totalProfitUSD.toFixed(2)} USD`;
            message += `\nBalance actualizado: $${newBalance.toFixed(2)}`;
            
            await showAlert('Importacion Completada', message, 'success');
            
        } catch (error) {
            console_error('Error en importacion:', error);
            showAlert('Error de Importacion', window.getSafeErrorMessage(error), 'error');
        } finally {
            button.disabled = false;
            button.innerHTML = originalContent;
        }
    });
}

// ============================================
// ADMIN AUTH
// ============================================
// Exponer a window para acceso desde otros módulos
window.verifyAdminPassword = async function(password) {
    try {
        const verifyBase = (typeof window !== 'undefined' && window.WORKER_URL)
            ? window.WORKER_URL
            : 'https://trading-journal-preprod.monkeydfx-trader.workers.dev';

        // Exchange password for short-lived admin token
        const resp = await fetch(`${verifyBase}/api/admin-login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ password })
        });

        const data = await resp.json().catch(() => ({}));
        if (!resp.ok || !data.token) {
            return { success: false, error: data.error || 'Unauthorized' };
        }

        return { success: true, token: data.token };
    } catch (error) {

        return { success: false, error: error.message };
    }
};

// Mantener referencia local para compatibilidad
async function verifyAdminPassword(password) {
    return window.verifyAdminPassword(password);
}

function updateAdminVisibility() {
    // ? GUARD #0: Never show admin UI until app is fully initialized
    if (!window._appInitialized) {
        return;
    }
    
    // ??? SECURITY: Only admins should see admin features (not FREE/PRO/UNLIMITED users)
    const userType = (localStorage.getItem('userType') || '').toLowerCase().trim();
    const userPlan = (localStorage.getItem('userPlan') || 'free').toLowerCase().trim();
    
    // Only show admin button if userType is explicitly 'admin'
    const isAdmin = userType === 'admin';
    
    if (!isAdmin) {
        const adminButtons = document.querySelectorAll('.admin-only');
        adminButtons.forEach(btn => {
            btn.style.display = 'none';
        });
        return;
    }

    // ?? Solo usuarios UNLIMITED pueden ver el bot?n de admin
    // El acceso real al panel requiere contrase?a adicional
    
    // ? SOLO mostrar/ocultar BOTONES, nunca abrir modales
    // Si llegamos aqu?, es UNLIMITED - mostrar el bot?n
    const adminButtons = document.querySelectorAll('.admin-only');
    adminButtons.forEach(btn => {
        btn.style.display = '';
    });
}

window.showAdminAuth = async function() {
    // Solo usuarios con rol admin pueden acceder
    const userType = localStorage.getItem('userType') || '';
    const dbUserType = sessionStorage.getItem('dbUserType') || '';
    const hasAdminToken = (typeof window !== 'undefined' && !!window._adminToken);
    const isAdmin = userType === 'admin' || dbUserType === 'admin';
    
    // TEMPORAL: Si el worker no responde, confiar en localStorage
    if (!hasAdminToken && !isAdmin) {


        return;
    }

    // Show the admin auth modal
    const authModal = document.getElementById('adminAuthModal');
    if (authModal) {
        authModal.classList.add('show');
        
    } else {

    }
}

window.closeAdminAuthModal = function() {
    const authModal = document.getElementById('adminAuthModal');
    if (authModal) {
        authModal.classList.remove('show');
    }
    const input = document.getElementById('adminPassword');
    if (input) input.value = '';
}
// Handle admin auth form submission
const adminAuthForm = document.getElementById('adminAuthForm');
if (adminAuthForm) {
    adminAuthForm.addEventListener('submit', async function(e) {
        e.preventDefault();
        
        const password = document.getElementById('adminPassword').value;
        if (!password) return;

        const result = await verifyAdminPassword(password);
        if (result.success) {
            // mark session as admin and cache token
            window._adminToken = result.token;
            localStorage.setItem('userType', 'admin');
            updateAdminVisibility();
            showAlert('Acceso Concedido', 'Acceso concedido', 'success');
            
            // Close auth modal and open admin modal
            setTimeout(() => {
                closeAdminAuthModal();
                
                const adminModal = document.getElementById('adminModal');
                if (adminModal) {
                    adminModal.classList.add('show');
                    
                    
                    // Initialize admin panel functionality
                    if (window.initAdminPanel && typeof window.initAdminPanel === 'function') {
                        window.initAdminPanel();
                    }
                } else {

                    showAlert('Panel No Disponible', 'Panel admin no disponible en esta pagina', 'warning', 4000);
                }
            }, 300);
        } else {
            showAlert('Error de Autenticacion', `${result.error || 'Contrasena incorrecta'}`, 'error');
            document.getElementById('adminPassword').value = '';
        }
    });
}

// ============================================
// INICIALIZACI?N
// ============================================
async function initializeApp() {
    const loadingOverlay = document.getElementById('journalLoadingOverlay');
    if (loadingOverlay) loadingOverlay.classList.add('active');
    
    // ? SECURITY: FIRST - Clean up any stale admin flags from previous sessions
    // Only allow admin flag if there's an admin token in memory (which would be set during THIS session)
    if (!window._adminToken && localStorage.getItem('userType') === 'admin') {
        // No valid admin token in memory, but localStorage says admin - this is a refresh/stale flag
        // Clean it up immediately - the server will tell us the real user type
        localStorage.removeItem('userType');
    }
    
    // ?? MOSTRAR PANTALLA DE CARGA ANTES DE RENDERIZAN NADA
    const mainContent = document.getElementById('mainContent') || document.querySelector('.main-content') || document.querySelector('.container');
    if (mainContent) {
        mainContent.style.visibility = 'hidden';
        mainContent.style.opacity = '0';
    }
    
    // Mark page load time for extra protection against accidental admin modal opens
    window._pageLoadTime = Date.now();
    
    //

    const modalsToHide = [
        'adminModal', 
        'adminAuthModal', 
        'userInfoModal', 
        'accountModal', 
        'dayModal', 
        'importModal'
    ];
    
    modalsToHide.forEach(modalId => {
        const modal = document.getElementById(modalId);
        if (modal) {
            modal.style.display = 'none';
            modal.classList.remove('show');
            modal.setAttribute('aria-hidden', 'true');
        }
    });
    
    if (!window.tursoClient) {

    }
    
    // Verificar estado de base de datos
    // Las migraciones se controlan con ENABLE_AUTO_MIGRATIONS en config.js
    let dbReady = false;
    try {
        if (window.tursoClient) {
            dbReady = await initializeDatabase();
        }
    } catch (error) {
        // Si las migraciones fallan, asumir que las tablas ya existen

        dbReady = true;
    }
    
    // ?? SINCRONIZAR DATOS DEL USUARIO DESDE LA BD
    // Esto asegura que userType, userPlan y otros datos est?n actualizados
    let session = await syncUserDataFromDB();
    
    // Si la sincronizaci?n falla, usar checkSession() como fallback
    if (!session) {
        session = await checkSession();
    }
    
    if (!session) {
        const isDemo = isDemoSessionLocal();
        if (isDemo) {
            try { localStorage.setItem('demo_mode', 'true'); } catch (e) {}
            session = {
                email: localStorage.getItem('userEmail') || sessionStorage.getItem('userEmail') || 'demo@tripulacionfx.com',
                username: localStorage.getItem('userName') || 'DEMO',
                userId: 'demo_user',
                userType: 'user',
                userPlan: 'unlimited'
            };
        } else {
            showAlert('Sesión Requerida', 'Por favor inicia sesión primero', 'warning');
            setTimeout(() => {
                window.location.href = '/';
            }, 2000);
            if (loadingOverlay) loadingOverlay.classList.remove('active');
            return;
        }
    }
    
    currentUserId = session.userId;
    window.currentUserId = currentUserId;
    updateUserDisplay(session.email);

    try {
        // Siempre guardar el userType que viene del servidor
        if (session.userType) {
            sessionStorage.setItem('dbUserType', session.userType);
            if (session.userType === 'admin') {
                localStorage.setItem('userType', 'admin');
            } else {
                // Si no es admin seg?n el servidor, borrar
                localStorage.removeItem('userType');
            }
            try { window.dispatchEvent(new CustomEvent('userTypeUpdated')); } catch (e) {}
        } else {
            // Si el servidor no env?a userType, limpiar sessionStorage pero mantener localStorage
            sessionStorage.removeItem('dbUserType');
            try { window.dispatchEvent(new CustomEvent('userTypeUpdated')); } catch (e) {}
        }
    } catch (e) {}

    updateAdminVisibility();
    
    showWeekendTrades = localStorage.getItem('showWeekendTrades') === '1';
    
    // ?? MARCAR COMO INICIALIZADO ANTES DE RENDERIZAR CONTENIDO
    window._appInitialized = true;
    
    await initializeAccounts();
    
    // ?? Cargar notas diarias de la cuenta actual
    await loadNotesForCurrentAccount();
    
    updateDisplay();
    
    // ?? APLICAR RESTRICCI�N DE SIDEBAR SEG�N PLAN
    applyPlanLayoutRestrictions();
    
    // Inicializar timeout de sesion
    initSessionTimeout();
    
    // ?? INICIALIZAR TOGGLE DE FIN DE SEMANA
    const weekendToggle = document.getElementById('weekendToggleBtn');
    if (weekendToggle) {
        // Actualizar estilo inicial basado en el estado guardado
        updateWeekendToggleStyle();
    }
    
    // ?? FIJAR MES ACTUAL COMO FOCO INICIAL
    currentDate = new Date();
    currentDate.setDate(1); // Ir al primer d?a del mes actual
    updateDisplay();
    
    // ?? FORCE REFRESH: Sincronizar trades al cargar la página
    // Esto asegura que después de una reconexión siempre obtenemos datos frescos
    if (currentAccount && accounts[currentAccount]) {
        const performInitialSync = async () => {
            try {
                
                // Mostrar notificación de sincronización
                if (window.NotificationCenter && typeof window.NotificationCenter.add === 'function') {
                    window.NotificationCenter.add({
                        type: 'info',
                        title: '🔄 Sincronizando datos',
                        message: 'Obteniendo trades desde MT5...'
                    });
                }
                
                await doFullRefresh();
                
                // Notificación de éxito
                if (window.NotificationCenter && typeof window.NotificationCenter.add === 'function') {
                    window.NotificationCenter.add({
                        type: 'success',
                        title: '✅ Datos sincronizados',
                        message: 'Trades actualizados desde MT5'
                    });
                }
            } catch (error) {
                // Fallback: intentar auto-sync check
                try {
                    await runAutoSyncCheck(true);
                } catch (e) {}
            }
        };
        
        setTimeout(performInitialSync, 1500);
    }
    
    // Initialize user activity tracking - set to current time on page load
    window._lastUserActivity = Date.now();
    
    // Track subsequent user activity to prevent accidental admin modal opens
    ['click', 'keydown', 'mousemove', 'scroll'].forEach(eventType => {
        document.addEventListener(eventType, () => {
            window._lastUserActivity = Date.now();
        }, { passive: true });
    });
    
    // ?? MOSTRAR CONTENIDO AHORA QUE EST? TODO INICIALIZADO
    if (mainContent) {
        mainContent.style.visibility = 'visible';
        mainContent.style.opacity = '1';
        mainContent.style.transition = 'opacity 0.3s ease-in-out';
    }

    if (loadingOverlay) {
        loadingOverlay.classList.remove('active');
        loadingOverlay.setAttribute('aria-busy', 'false');
    }
    
    // ? ACTUALIZAR VISIBILIDAD DEL BOT?N DE AJUSTES SEG?N PLAN
    const userPlan = localStorage.getItem('userPlan') || 'free';
    const settingsBtn = document.getElementById('settingsBtn');
    if (settingsBtn) {
        const hasAccount = currentAccount && accounts[currentAccount];
        const shouldShow = userPlan !== 'free' && hasAccount;
        settingsBtn.style.display = shouldShow ? 'inline-flex' : 'none';
    }
    
    // ??? UNLOCK ADMIN MODALS ONLY AFTER FULL INITIALIZATION
    // Remove CSS protection that prevented showing until now
    const adminModals = document.querySelectorAll('#adminModal, #adminAuthModal');
    adminModals.forEach(modal => {
        modal.style.visibility = '';
        modal.style.opacity = '';
        modal.style.pointerEvents = '';
    });
    
    // ?? ACTUALIZAR BOT?N DEL PLAN EN EL HEADER
    updatePlanDisplayButton();
    
    //
}

// ============================================
// ?? ACTUALIZAR BOT?N DE PLAN EN HEADER
// ============================================
function updatePlanDisplayButton() {
    const planDisplayBtn = document.getElementById('plan-display-btn');
    if (!planDisplayBtn) return;
    
    const userPlan = localStorage.getItem('userPlan') || 'free';
    
    // Convertir plan a mayúsculas y mostrar valores apropiados
    let planText = '';
    switch(userPlan.toLowerCase()) {
        case 'free':
            planText = 'FREE';
            break;
        case 'pro':
            planText = 'PRO';
            break;
        case 'unlimited':
            planText = 'UNLIMITED';
            break;
        default:
            planText = 'PRO'; // Fallback
            break;
    }
    
    planDisplayBtn.textContent = planText;
    // Mostrar el botón después de actualizar el contenido
    planDisplayBtn.style.opacity = '1';
    planDisplayBtn.style.width = 'auto';
    planDisplayBtn.style.overflow = 'visible';
}

// ?? Exponer función globalmente para actualizaciones después del login
window.updatePlanDisplayButton = updatePlanDisplayButton;

// ============================================
// ?? TOGGLE FORMATO DE RESULTADOS
// ============================================
window.toggleResultFormat = function(type) {
    if (type === 'monthly') {
        const el = document.getElementById('totalResult');
        if (!el) return;
        
        const currentFormat = el.getAttribute('data-format');
        const usdValue = parseFloat(el.getAttribute('data-usd') || 0);
        const percentValue = parseFloat(el.getAttribute('data-percent') || 0);
        
        if (currentFormat === 'percent') {
            // Cambiar a USD
            el.setAttribute('data-format', 'usd');
            el.textContent = usdValue >= 0 ? `+$${Math.abs(usdValue).toFixed(2)}` : `-$${Math.abs(usdValue).toFixed(2)}`;
        } else {
            // Cambiar a %
            el.setAttribute('data-format', 'percent');
            el.textContent = `${percentValue > 0 ? '+' : ''}${percentValue.toFixed(2)}%`;
        }
    } else if (type === 'total') {
        const el = document.getElementById('totalProfitUSD');
        if (!el) return;
        
        const currentFormat = el.getAttribute('data-format');
        const usdValue = parseFloat(el.getAttribute('data-usd') || 0);
        const percentValue = parseFloat(el.getAttribute('data-percent') || 0);
        
        if (currentFormat === 'usd') {
            // Cambiar a %
            el.setAttribute('data-format', 'percent');
            el.textContent = `${percentValue > 0 ? '+' : ''}${percentValue.toFixed(2)}%`;
        } else {
            // Cambiar a USD
            el.setAttribute('data-format', 'usd');
            el.textContent = usdValue >= 0 ? `+$${Math.abs(usdValue).toFixed(2)}` : `-$${Math.abs(usdValue).toFixed(2)}`;
        }
    }
}

// ============================================
// ?? ABRIR IMPORTACI?N DESDE MODAL DE CUENTA
// ============================================
window.openImportFromAccountModal = function() {
    if (window.demoGate && window.demoGate('import_trades', 'Importar Trades desde Archivo')) {
        return;
    }
    // Bloquear en móvil
    const isMobile = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (isMobile) {
        showAlert('Solo disponible en Desktop', 'La importación de trades requiere un ordenador. Por favor, accede desde tu PC o portátil para usar esta función.', 'info');
        return;
    }
    
    // Verificar si la cuenta actual es de sincronizaci?n autom?tica
    const currentAccountData = accounts[currentAccount];
    const isSynced = currentAccountData && isAccountSynced(currentAccountData);
    
    if (isSynced) {
        showAlert('Importacion No Permitida', 'No puedes importar trades manualmente en una cuenta de sincronizacion automatica. Los trades se sincronizan automaticamente desde tu EA.', 'error');
        return;
    }
    
    // Cerrar modal de cuenta pero NO de importaci?n
    closeAccountModal();
    // Abrir modal de importaci?n
    showImportModal();
}

function showDeletedTradesNotificationNew(deletedTrades) {
    // FIX: Mostrar como una notificación de Error (roja) centralizada en lugar de banner
    const tradesSummary = deletedTrades.slice(0, 3)
        .map(({ trade }) => `${trade?.pair || '—'} ${(trade?.direction || '').toUpperCase()}`)
        .join(', ');
    
    const moreCount = deletedTrades.length > 3 ? ` +${deletedTrades.length - 3} más` : '';
    
    const instructions = `
Para que el EA reenvíe estos trades:
1. Abre Files → File Explorer en MT5
2. Borra DataBridge_State.txt
3. Cierra MetaTrader completamente
4. Abre MetaTrader de nuevo`;
    
    const message = `Se eliminaron: ${tradesSummary}${moreCount}\n\n${instructions}`;
    
    if (window.showAlert) {
        window.showAlert('Trades eliminados detectados', message, 'error');
    }
}

document.addEventListener('DOMContentLoaded', async () => {
    await initializeApp();
    
    // ?? HEARTBEAT: Mantener JWT vivo cada 15 minutos (ping silencioso)
    // Previene expiración de token durante sesiones largas (MT5 siempre abierto)
    setInterval(async () => {
        if (currentUserId && !isDemoSession()) {
            try {
                // Query mínima para validar token sin modificar datos
                await tursoClient.execute({
                    sql: 'SELECT 1 as heartbeat_ping'
                });
            } catch (e) {
            }
        }
    }, 15 * 60 * 1000); // Cada 15 minutos
    
    // Ejecutar una vez al entrar (reconexión / refresco de sesión)
    setTimeout(() => runAutoSyncCheck(true), 1500);

    // Mantener auto-sync periódico
    setInterval(() => runAutoSyncCheck(false), 30000); // Cada 30 segundos

    // ?? FORCE REFRESH cuando vuelves de otra pestaña/navegador
    // Asegurar que siempre tienes trades frescos de MT5
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
            
            // Mostrar notificación de sincronización
            if (window.NotificationCenter && typeof window.NotificationCenter.add === 'function') {
                window.NotificationCenter.add({
                    type: 'info',
                    title: '🔄 Reconectando...',
                    message: 'Sincronizando trades desde MT5'
                });
            }
            
            try {
                // Intentar force refresh primero (trae TODO sin comparación)
                if (typeof doFullRefresh === 'function' && window.currentAccount) {
                    doFullRefresh()
                        .then(() => {
                            if (window.NotificationCenter && typeof window.NotificationCenter.add === 'function') {
                                window.NotificationCenter.add({
                                    type: 'success',
                                    title: '✅ Reconexión exitosa',
                                    message: 'Datos sincronizados desde MT5'
                                });
                            }
                        })
                        .catch((err) => {
                            runAutoSyncCheck(true);
                        });
                } else {
                    runAutoSyncCheck(true);
                }
            } catch (e) {
                runAutoSyncCheck(true);
            }
        }
    });

    window.addEventListener('focus', () => {
        try {
            if (typeof doFullRefresh === 'function' && window.currentAccount) {
                doFullRefresh()
                    .then(() => {})
                    .catch((err) => {
                        runAutoSyncCheck(true);
                    });
            } else {
                runAutoSyncCheck(true);
            }
        } catch (e) {
            runAutoSyncCheck(true);
        }
    });

    window.addEventListener('pageshow', () => {
        try {
            if (typeof doFullRefresh === 'function' && window.currentAccount) {
                doFullRefresh()
                    .then(() => {})
                    .catch((err) => {
                        runAutoSyncCheck(true);
                    });
            } else {
                runAutoSyncCheck(true);
            }
        } catch (e) {
            runAutoSyncCheck(true);
        }
    });
});
